import React, { useState, useEffect, useMemo, useCallback, startTransition } from 'react';
import { Card } from '../components/ui/Card';
import { LineChart, BarChart, DoughnutChart } from '../components/charts';
import { 
  DollarSign, 
  Users, 
  ShoppingCart, 
  TrendingUp,
  Calendar,
  ArrowUp,
  ArrowDown,
  Filter,
  RefreshCw,
  ChevronRight,
  Bell,
  PieChart,
  BarChart2,
  Target,
  Clock,
  Globe,
  Zap,
  Activity,
  TrendingDown,
  Share2,
  ChartPieIcon,
  MousePointerClick,
  AlertTriangle,
  Lightbulb,
  Home,
  ShoppingBag,
  Grid,
  FileText,
  CreditCard,
  Smartphone,
  ExternalLink,
  Search,
  Mail,
  Link,
  Image,
  Facebook,
  MessageSquare,
  Bot,
  Send,
  ChevronDown,
  Violet,
  Emerald,
  Info,
  TagIcon,
  AwardIcon,
  UsersIcon,
  BarChart3,
  Eye,
  Package,
  ArrowDownRight,
  Loader2,
  Settings
} from 'lucide-react';
import { Menu } from '@headlessui/react';
import styles from '../styles/LoadingLogo.module.css';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useAuth } from '../context/AuthContext';
import GlowyAIChatWidget from '../components/GlowyAIChatWidget';



// Monthly average USD/TRY exchange rates (display month → rate)
const USD_TRY_RATES = {
  '2024-01': 30.13, '2024-02': 30.87, '2024-03': 31.98, '2024-04': 32.39,
  '2024-05': 32.29, '2024-06': 32.56, '2024-07': 32.87, '2024-08': 33.61,
  '2024-09': 33.94, '2024-10': 34.20, '2024-11': 34.42, '2024-12': 34.84,
  '2025-01': 35.52, '2025-02': 36.17, '2025-03': 37.09, '2025-04': 38.13,
  '2025-05': 38.83, '2025-06': 39.48, '2025-07': 40.18, '2025-08': 40.79,
  '2025-09': 41.28, '2025-10': 41.79, '2025-11': 42.24, '2025-12': 42.70,
  '2026-01': 43.06, '2026-02': 43.40,
};

const getUsdValue = (tryValue, monthKey) => {
  const rate = USD_TRY_RATES[monthKey];
  if (!rate || !tryValue) return null;
  return tryValue / rate;
};

export default function Overviewv11() {
  const { user, selectedBrand } = useAuth();
  const isMarketer = selectedBrand?.currentUserRole === 'MARKETER';
  // Show special duplicate table only for specific brands
  const allowedBrandIdsForCategoryTable = new Set([
    'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e',
    '44e35dfe-0186-495d-a0cc-db5e7e459ab7',
    'dfcf54dd-b00d-434a-be1e-27b6484848eb',
    '7fc8e68d-f2ba-4101-95f7-acece386ab8f'
  ]);
  const currentBrandIdForView = typeof window !== 'undefined' ? localStorage.getItem('currentBrandId') : null;
  const [dateRange, setDateRange] = useState('last7');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isCustomDateOpen, setIsCustomDateOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');
  const [gaDateRange, setGaDateRange] = useState('7days');
  const [activeMetric, setActiveMetric] = useState('totalSales');
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  
  // Google Ads verileri için state ekleyelim
  const [unifiedGoogleAdsData, setUnifiedGoogleAdsData] = useState(null);
  const [isLoadingUnifiedGoogleAds, setIsLoadingUnifiedGoogleAds] = useState(false);
  
  // Meta Ads verileri için state ekleyelim
  const [unifiedMetaAdsData, setUnifiedMetaAdsData] = useState(null);
  const [isLoadingUnifiedMetaAds, setIsLoadingUnifiedMetaAds] = useState(false);
  

  
  // Aylık performans verileri için ayrı state'ler
  const [monthlyGoogleAdsData, setMonthlyGoogleAdsData] = useState(null);
  const [monthlyMetaAdsData, setMonthlyMetaAdsData] = useState(null);
  const [isLoadingMonthly, setIsLoadingMonthly] = useState(false);
  
  const [unifiedCampaignData, setUnifiedCampaignData] = useState(null);
  const [isLoadingUnifiedCampaign, setIsLoadingUnifiedCampaign] = useState(false);
  const [unifiedCampaignLast30Data, setUnifiedCampaignLast30Data] = useState(null);
  
  // GA Traffic Source verileri için state ekleyelim
  const [gaTrafficSourceData, setGaTrafficSourceData] = useState(null);
  const [gaTrafficSourceAllData, setGaTrafficSourceAllData] = useState(null);
  const [isLoadingGaTrafficSource, setIsLoadingGaTrafficSource] = useState(false);
  // GA Device Performance (mobile/desktop/tablet)
  const [gaDevicePerf, setGaDevicePerf] = useState([]);
  const [isLoadingGaDevicePerf, setIsLoadingGaDevicePerf] = useState(false);
  const [showAllGaMonths, setShowAllGaMonths] = useState(false);
  // Compact GA summaries (monthly/weekly) from backend views
  const [gaMonthlySummaryCompact, setGaMonthlySummaryCompact] = useState(null);
  const [gaWeeklySummaryCompact, setGaWeeklySummaryCompact] = useState(null);
  const [gaDailySummaryCompact, setGaDailySummaryCompact] = useState(null);
  // GA platform split
  const [gaPlatformDaily, setGaPlatformDaily] = useState([]);
  const [gaPlatformMonthly, setGaPlatformMonthly] = useState([]);
  
  const [activeChannelMetric, setActiveChannelMetric] = useState('Revenue');
  const [channelAggregation, setChannelAggregation] = useState('Monthly'); // 'Monthly' | 'Daily'
  const [showAllMonths, setShowAllMonths] = useState(false);
  const [showAllTrendMonths, setShowAllTrendMonths] = useState({});
  // Table A metric selector state
  const [weeklyMetric, setWeeklyMetric] = useState('revenue'); // 'revenue' | 'transactions' | 'sessions' | 'cr'
  
  // Funnel verileri için state ekleyelim
  const [funnelData, setFunnelData] = useState({
    steps: [
      { 
        name: 'Product Views',
        value: 0,
        percentage: 0,
        icon: Eye,
        vsLastPeriod: 0,
        dropoff: 0
      },
      { 
        name: 'Add to Cart',
        value: 0,
        percentage: 0,
        dropoff: 0,
        icon: ShoppingCart,
        vsLastPeriod: 0
      },
      { 
        name: 'View Cart',
        value: 0,
        percentage: 0,
        dropoff: 0,
        icon: MousePointerClick,
        vsLastPeriod: 0
      },
      { 
        name: 'Checkout',
        value: 0,
        percentage: 0,
        dropoff: 0,
        icon: CreditCard,
        vsLastPeriod: 0
      },
      { 
        name: 'Purchase',
        value: 0,
        percentage: 0,
        dropoff: 0,
        icon: Package,
        vsLastPeriod: 0
      }
    ],
    summary: {
      conversionRate: 0,
      avgTimeToConvert: "0",
      dropoffRate: 0,
      revenue: 0,
      avgOrderValue: 0
    }
  });
  const [eventsData, setEventsData] = useState(null);
  const [eventsLoading, setEventsLoading] = useState(false);
  const [eventsError, setEventsError] = useState(null);
  const [funnelLoading, setFunnelLoading] = useState(true);
  
  const [expandedPlatforms, setExpandedPlatforms] = useState(['Google Ads', 'Meta Ads']);
  // For duplicated table (Platform → Category expansion)
  const [expandedPlatforms2, setExpandedPlatforms2] = useState(['Google Ads', 'Meta Ads']);
  const [expandedCategories2, setExpandedCategories2] = useState({});
  
  // Live (today) summaries
  const [liveGads, setLiveGads] = useState(null);
  const [liveMeta, setLiveMeta] = useState(null);
  const [liveGa4, setLiveGa4] = useState(null);
  const [loadingLive, setLoadingLive] = useState(false);
  const [liveUpdatedAt, setLiveUpdatedAt] = useState(null);
  const [hasIkasConnected, setHasIkasConnected] = useState(false);
  const [liveIkas, setLiveIkas] = useState(null);
  const [liveIkasHourly, setLiveIkasHourly] = useState([]);
  const [isLoadingIkasSummary, setIsLoadingIkasSummary] = useState(false);
  const [ikasSummary, setIkasSummary] = useState(null);
  const [ikasDailyRows, setIkasDailyRows] = useState([]);
  // Shopify states
  const [hasShopifyConnected, setHasShopifyConnected] = useState(false);
  const [liveShopify, setLiveShopify] = useState(null);
  const [isLoadingShopifySummary, setIsLoadingShopifySummary] = useState(false);
  const [shopifySummary, setShopifySummary] = useState(null);
  const [shopifyDailyRows, setShopifyDailyRows] = useState([]);
  // WooCommerce states
  const [hasWooConnected, setHasWooConnected] = useState(false);
  const [liveWoo, setLiveWoo] = useState(null);
  const [isLoadingWooSummary, setIsLoadingWooSummary] = useState(false);
  const [wooSummary, setWooSummary] = useState(null);
  const [wooDailyRows, setWooDailyRows] = useState([]);
  // Adjust states
  const [hasAdjustConnected, setHasAdjustConnected] = useState(false);
  const [adjustSummary, setAdjustSummary] = useState(null);
  const [isLoadingAdjustSummary, setIsLoadingAdjustSummary] = useState(false);
  const [adjustDailyRows, setAdjustDailyRows] = useState([]);
  
  // Brand logo için state ekleyelim
  const [logoUrl, setLogoUrl] = useState('');
  
  // Real notification data from API
  const [notifications, setNotifications] = useState([]);
  const [notificationLoading, setNotificationLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  
  // Demo brand for overview2 (use dummy data only for this brand)
  const DEMO_BRAND_ID = 'ec9873c2-0edb-44eb-ac6f-2670c8e56dc4';
  const isDemoBrand = typeof window !== 'undefined' && (localStorage.getItem('currentBrandId') === DEMO_BRAND_ID);
  
  // E-commerce Analytics state'leri
  const [topProducts, setTopProducts] = useState([]);
  const [categoryPerformance, setCategoryPerformance] = useState([]);
  const [isLoadingEcommerce, setIsLoadingEcommerce] = useState({ products: true, categories: true, daily: true });
    const [dailyProductData, setDailyProductData] = useState({ data: [], totals: {}, changes: {} });
  
  // Silence verbose console logs on this page; preserve errors/warnings
  useEffect(() => {
    const originalLog = console.log;
    console.log = () => {};
    return () => { console.log = originalLog; };
  }, []);
  
  // Brand logo'yu çek
  const fetchBrandLogo = async () => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.log('No brand ID found in localStorage');
        return;
      }
      if (brandId === DEMO_BRAND_ID) {
        setLogoUrl('/logoicon.png');
        return;
      }

      const response = await fetch(`https://api.glowytics.com/api/brand-info/${brandId}/details`, {
        credentials: 'include',
        headers: {
          'X-Brand-ID': brandId
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch brand details');
      }

      const data = await response.json();
      if (data && data.logoUrl) {
        setLogoUrl(data.logoUrl);
      }
    } catch (error) {
      console.error('Error fetching brand logo:', error);
    }
  };

  // Fetch live "today" summaries for Google Ads, Meta Ads, GA4
  const fetchLiveTodaySummaries = async () => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;
      
      // Demo live data for special brand
      if (brandId === DEMO_BRAND_ID) {
        setLoadingLive(true);
        setLiveGads({
          cost: 12500,
          clicks: 3200,
          impressions: 185000,
          conversions: 145,
          conversion_value: 42500,
          ctr: 1.73,
          cpc: 3.91
        });
        setLiveMeta({
          spend: 8500,
          clicks: 2100,
          impressions: 125000,
          conversions: 95,
          conversion_value: 28000,
          ctr: 1.68,
          cpc: 4.05
        });
        setLiveGa4({
          sessions: 8500,
          users: 6200,
          transactions: 185,
          revenue: 62000,
          bounceRate: 42.5,
          avgSessionDuration: 245
        });
        setLiveUpdatedAt(new Date());
        setLoadingLive(false);
        return;
      }
      
      setLoadingLive(true);
      const headers = { 'X-Brand-ID': brandId };
      const [gadsRes, metaRes, ga4Res] = await Promise.allSettled([
        fetch(`https://api.glowytics.com/api/brands/${brandId}/live/google-ads/today`, { credentials: 'include', headers }),
        fetch(`https://api.glowytics.com/api/brands/${brandId}/live/meta-ads/today`, { credentials: 'include', headers }),
        fetch(`https://api.glowytics.com/api/brands/${brandId}/live/ga4/today`, { credentials: 'include', headers })
      ]);
      if (gadsRes.status === 'fulfilled' && gadsRes.value.ok) {
        const data = await gadsRes.value.json();
        setLiveGads(data || null);
      } else {
        setLiveGads(null);
      }
      if (metaRes.status === 'fulfilled' && metaRes.value.ok) {
        const data = await metaRes.value.json();
        setLiveMeta(data || null);
      } else {
        setLiveMeta(null);
      }
      if (ga4Res.status === 'fulfilled' && ga4Res.value.ok) {
        const data = await ga4Res.value.json();
        setLiveGa4(data || null);
      } else {
        setLiveGa4(null);
      }

      // Also refresh IKAS live if connected
      try {
        // Ensure we know IKAS connection status
        let isConnected = hasIkasConnected;
        if (!isConnected) {
          const connRes = await fetch('https://api.glowytics.com/api/auth/connections', { credentials: 'include', headers });
          if (connRes.ok) {
            const data = await connRes.json();
            let connected = false;
            if (Array.isArray(data)) {
              connected = !!data.find(c => String(c.platform || '').toUpperCase() === 'IKAS' && String(c.status || '').toUpperCase() === 'ACTIVE');
            } else if (data && typeof data === 'object') {
              const ikasObj = data.IKAS || data.ikas;
              connected = !!(ikasObj && String(ikasObj.status || '').toUpperCase() === 'ACTIVE');
            }
            setHasIkasConnected(connected);
            isConnected = connected;
          }
        }
        if (isConnected) {
          // Use backend live service (calls IKAS API) for accurate today totals/series
          const tzOffset = -new Date().getTimezoneOffset(); // minutes east of UTC
          const liveRes = await fetch(`https://api.glowytics.com/api/ikas/live/today?tzOffsetMinutes=${encodeURIComponent(tzOffset)}`, { credentials: 'include', headers });
          if (liveRes.ok) {
            const liveJs = await liveRes.json().catch(() => ({}));
            const series = Array.isArray(liveJs?.rows) ? liveJs.rows : [];
            setLiveIkasHourly(series);
            // Normalize totals to { revenue, orders, items }
            let totalsNorm = null;
            if (liveJs?.totals) {
              const t = liveJs.totals;
              totalsNorm = {
                revenue: Number(t.revenue || 0),
                orders: Number(t.orders || t.orders_count || 0),
                items: Number(t.items || t.items_count || 0)
              };
            } else {
              totalsNorm = series.reduce((acc, r) => {
                acc.revenue += Number(r.revenue || 0);
                acc.orders += Number(r.orders || r.orders_count || 0);
                acc.items += Number(r.items || r.items_count || 0);
                return acc;
              }, { revenue: 0, orders: 0, items: 0 });
            }
            setLiveIkas(totalsNorm);
          } else {
            setLiveIkas(null);
            setLiveIkasHourly([]);
          }
        } else {
          setLiveIkas(null);
          setLiveIkasHourly([]);
        }
      } catch {
        setLiveIkas(null);
        setLiveIkasHourly([]);
      }

      // Shopify live (if connected) using live service
      try {
        let shopifyConnected = hasShopifyConnected;
        if (!shopifyConnected) {
          const connRes = await fetch('https://api.glowytics.com/api/auth/connections', { credentials: 'include', headers });
          if (connRes.ok) {
            const data = await connRes.json();
            if (Array.isArray(data)) {
              shopifyConnected = !!data.find(c => String(c.platform || '').toUpperCase() === 'SHOPIFY' && String(c.status || '').toUpperCase() === 'ACTIVE');
            } else if (data && typeof data === 'object') {
              const sObj = data.SHOPIFY || data.shopify;
              shopifyConnected = !!(sObj && String(sObj.status || '').toUpperCase() === 'ACTIVE');
            }
            setHasShopifyConnected(shopifyConnected);
          }
        }
        if (shopifyConnected) {
          const tzOffset = -new Date().getTimezoneOffset();
          const liveRes = await fetch(`https://api.glowytics.com/api/shopify/live/today?tzOffsetMinutes=${encodeURIComponent(tzOffset)}`, { credentials: 'include', headers });
          if (liveRes.ok) {
            const js = await liveRes.json().catch(() => ({}));
            const totals = js?.totals || {};
            const normalized = {
              revenue: Number(totals.revenue || 0),
              orders: Number(totals.orders || totals.orders_count || 0),
              items: Number(totals.items || totals.items_count || 0)
            };
            setLiveShopify(normalized);
          } else {
            setLiveShopify(null);
          }
        } else {
          setLiveShopify(null);
        }
      } catch {
        setLiveShopify(null);
      }
      
      // WooCommerce live (via backend live service) if connected
      try {
        let wooConnected = hasWooConnected;
        if (!wooConnected) {
          const connRes = await fetch('https://api.glowytics.com/api/auth/connections', { credentials: 'include', headers });
          if (connRes.ok) {
            const data = await connRes.json();
            if (Array.isArray(data)) {
              wooConnected = !!data.find(c => String(c.platform || '').toUpperCase() === 'WOOCOMMERCE' && String(c.status || '').toUpperCase() === 'ACTIVE');
            } else if (data && typeof data === 'object') {
              const wObj = data.WOOCOMMERCE || data.woocommerce;
              wooConnected = !!(wObj && String(wObj.status || '').toUpperCase() === 'ACTIVE');
            }
            setHasWooConnected(wooConnected);
          }
        }
        if (wooConnected) {
          const tzOffset = -new Date().getTimezoneOffset();
          const url = `https://api.glowytics.com/api/woocommerce/live/today?source=api&tzOffsetMinutes=${encodeURIComponent(tzOffset)}`;
          const res = await fetch(url, { credentials: 'include', headers });
          if (res.ok) {
            const js = await res.json().catch(() => ({}));
            const t = js?.totals || {};
            setLiveWoo({
              revenue: Number(t.revenue || 0),
              orders: Number(t.orders || 0),
              items: Number(t.items || 0)
            });
          } else {
            setLiveWoo(null);
          }
        } else {
          setLiveWoo(null);
        }
      } catch {
        setLiveWoo(null);
      }
    } catch (e) {
      setLiveGads(null);
      setLiveMeta(null);
      setLiveGa4(null);
      setLiveIkas(null);
    } finally {
      setLoadingLive(false);
      setLiveUpdatedAt(new Date());
    }
  };

  useEffect(() => {
    fetchLiveTodaySummaries();
  }, []);

  // Fetch IKAS summary for selected range
  const fetchIkasSummary = async () => {
    try {
      if (!hasIkasConnected) {
        setIkasSummary(null);
        return;
      }
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;
      const windows = getComparisonWindows();
      if (!windows) return;
      setIsLoadingIkasSummary(true);
      const headers = { 'X-Brand-ID': brandId };
      const params = new URLSearchParams({ startDate: windows.current.start, endDate: windows.current.end });
      const res = await fetch(`https://api.glowytics.com/api/ikas/orders/daily?${params.toString()}`, {
        credentials: 'include',
        headers
      });
      if (!res.ok) {
        setIkasSummary(null);
        return;
      }
      const js = await res.json().catch(() => ({}));
      const rows = Array.isArray(js?.rows) ? js.rows : [];
      const totals = rows.reduce((acc, r) => {
        acc.revenue += Number(r.revenue || 0);
        acc.orders += Number(r.orders_count || 0);
        acc.items += Number(r.items_count || 0);
        return acc;
      }, { revenue: 0, orders: 0, items: 0 });
      setIkasSummary(totals);
      // Fill missing dates with zero values so days without sales are visible
      try {
        const rowMap = new Map();
        for (const r of rows) {
          const d = r.day || r.date;
          if (d) {
            const dateKey = typeof d === 'string' && d.length >= 10 ? d.slice(0, 10) : formatDateYYYYMMDD(new Date(d));
            rowMap.set(dateKey, r);
          }
        }
        const allDays = [];
        const cur = new Date(windows.current.start + 'T00:00:00');
        const end = new Date(windows.current.end + 'T00:00:00');
        while (cur <= end) {
          const key = formatDateYYYYMMDD(cur);
          if (rowMap.has(key)) {
            allDays.push(rowMap.get(key));
          } else {
            allDays.push({ day: key, orders_count: 0, items_count: 0, revenue: 0 });
          }
          cur.setDate(cur.getDate() + 1);
        }
        const sorted = [...allDays].sort((a, b) => new Date(b.day || b.date) - new Date(a.day || a.date));
        setIkasDailyRows(sorted.slice(0, 10));
      } catch {
        setIkasDailyRows(rows.slice(-10).reverse());
      }
    } catch (e) {
      setIkasSummary(null);
      setIkasDailyRows([]);
    } finally {
      setIsLoadingIkasSummary(false);
    }
  };

  // Re-fetch IKAS summary when range or connection changes
  useEffect(() => {
    fetchIkasSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, startDate, endDate, hasIkasConnected]);

  // Fetch Shopify summary for selected range
  const fetchShopifySummary = async () => {
    try {
      if (!hasShopifyConnected) {
        setShopifySummary(null);
        return;
      }
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;
      const windows = getComparisonWindows();
      if (!windows) return;
      setIsLoadingShopifySummary(true);
      const headers = { 'X-Brand-ID': brandId };
      const params = new URLSearchParams({ startDate: windows.current.start, endDate: windows.current.end });
      // Use order totals endpoint (aggregated from shopify_order_totals_raw)
      const res = await fetch(`https://api.glowytics.com/api/shopify/orders/totals/daily?${params.toString()}`, {
        credentials: 'include',
        headers
      });
      if (!res.ok) {
        setShopifySummary(null);
        return;
      }
      const js = await res.json().catch(() => ({}));
      const rows = Array.isArray(js?.rows) ? js.rows : [];
      // rows: [{ day, orders_count, total_value_sum, avg_order_value }]
      const totals = rows.reduce((acc, r) => {
        acc.revenue += Number(r.total_value_sum || 0);
        acc.orders += Number(r.orders_count || 0);
        return acc;
      }, { revenue: 0, orders: 0, items: 0 }); // items not available in totals view; keep 0
      setShopifySummary(totals);
      try {
        const mapped = rows.map(r => ({
          day: r.day,
          orders_count: r.orders_count,
          revenue: Number(r.total_value_sum || 0),
          items_count: 0
        }));
        const sorted = [...mapped].sort((a, b) => new Date(b.day || b.date) - new Date(a.day || a.date));
        setShopifyDailyRows(sorted.slice(0, 10));
      } catch {
        const mapped = rows.map(r => ({
          day: r.day,
          orders_count: r.orders_count,
          revenue: Number(r.total_value_sum || 0),
          items_count: 0
        }));
        setShopifyDailyRows(mapped.slice(-10).reverse());
      }
    } catch (e) {
      setShopifySummary(null);
      setShopifyDailyRows([]);
    } finally {
      setIsLoadingShopifySummary(false);
    }
  };

  useEffect(() => {
    fetchShopifySummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, startDate, endDate, hasShopifyConnected]);

  // Fetch Woo summary for selected range
  const fetchWooSummary = async () => {
    try {
      if (!hasWooConnected) {
        setWooSummary(null);
        setWooDailyRows([]);
        return;
      }
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;
      const windows = getComparisonWindows();
      if (!windows) return;
      setIsLoadingWooSummary(true);
      const headers = { 'X-Brand-ID': brandId };
      const params = new URLSearchParams({ startDate: windows.current.start, endDate: windows.current.end });
      const res = await fetch(`https://api.glowytics.com/api/woocommerce/analytics/orders-daily?${params.toString()}`, {
        credentials: 'include',
        headers
      });
      if (!res.ok) {
        setWooSummary(null);
        setWooDailyRows([]);
        return;
      }
      const js = await res.json().catch(() => ({}));
      const rows = Array.isArray(js?.rows) ? js.rows : [];
      const totals = rows.reduce((acc, r) => {
        acc.revenue += Number(r.revenue || 0);
        acc.orders += Number(r.orders_count || 0);
        acc.items += Number(r.items_count || 0);
        return acc;
      }, { revenue: 0, orders: 0, items: 0 });
      setWooSummary(totals);
      try {
        const mapped = rows.map(r => ({
          day: r.day,
          orders_count: r.orders_count,
          revenue: Number(r.revenue || 0),
          items_count: Number(r.items_count || 0)
        }));
        const sorted = [...mapped].sort((a, b) => new Date(b.day || b.date) - new Date(a.day || a.date));
        setWooDailyRows(sorted.slice(0, 10));
      } catch {
        const mapped = rows.map(r => ({
          day: r.day,
          orders_count: r.orders_count,
          revenue: Number(r.revenue || 0),
          items_count: Number(r.items_count || 0)
        }));
        setWooDailyRows(mapped.slice(-10).reverse());
      }
    } catch (e) {
      setWooSummary(null);
      setWooDailyRows([]);
    } finally {
      setIsLoadingWooSummary(false);
    }
  };

  useEffect(() => {
    fetchWooSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, startDate, endDate, hasWooConnected]);

  // Detect Adjust connection on mount
  useEffect(() => {
    (async () => {
      try {
        const brandId = localStorage.getItem('currentBrandId');
        if (!brandId) return;
        const res = await fetch('https://api.glowytics.com/api/auth/connections', { credentials: 'include', headers: { 'X-Brand-ID': brandId } });
        if (!res.ok) return;
        const data = await res.json();
        let connected = false;
        if (Array.isArray(data)) {
          connected = !!data.find(c => String(c.platform || '').toUpperCase() === 'ADJUST' && String(c.status || '').toUpperCase() === 'ACTIVE');
        } else if (data && typeof data === 'object') {
          const adj = data.ADJUST || data.adjust;
          connected = !!(adj && String(adj.status || '').toUpperCase() === 'ACTIVE');
        }
        setHasAdjustConnected(connected);
      } catch {}
    })();
  }, []);

  // Fetch Adjust summary for selected range
  const fetchAdjustSummary = async () => {
    try {
      if (!hasAdjustConnected) {
        setAdjustSummary(null);
        setAdjustDailyRows([]);
        return;
      }
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;
      const windows = getComparisonWindows();
      if (!windows) return;
      setIsLoadingAdjustSummary(true);
      const headers = { 'X-Brand-ID': brandId };
      const params = new URLSearchParams({ startDate: windows.current.start, endDate: windows.current.end });
      const res = await fetch(`https://api.glowytics.com/api/adjust/performance/daily?${params.toString()}`, {
        credentials: 'include',
        headers
      });
      if (!res.ok) {
        setAdjustSummary(null);
        setAdjustDailyRows([]);
        return;
      }
      const js = await res.json().catch(() => ({}));
      const rows = Array.isArray(js?.rows) ? js.rows : [];
      const totals = rows.reduce((acc, r) => {
        acc.revenue += Number(r.all_revenue || r.revenue || 0);
        acc.installs += Number(r.installs || 0);
        acc.purchases += Number(r.purchases || 0);
        acc.sessions += Number(r.sessions || 0);
        return acc;
      }, { revenue: 0, installs: 0, purchases: 0, sessions: 0 });
      setAdjustSummary(totals);
      try {
        const sorted = [...rows].sort((a, b) => new Date(b.day || b.date) - new Date(a.day || a.date));
        setAdjustDailyRows(sorted.slice(0, 10));
      } catch {
        setAdjustDailyRows(rows.slice(-10).reverse());
      }
    } catch {
      setAdjustSummary(null);
      setAdjustDailyRows([]);
    } finally {
      setIsLoadingAdjustSummary(false);
    }
  };

  useEffect(() => {
    fetchAdjustSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, startDate, endDate, hasAdjustConnected]);

  // 🔔 NOTIFICATION FUNCTIONS
  const fetchNotifications = async (unreadOnly = false) => {
    try {
      setNotificationLoading(true);
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.log('No brand ID found in localStorage');
        return;
      }
      if (brandId === DEMO_BRAND_ID) {
        const demo = [
          { id: 'n1', title: 'Demo: Campaign budget optimized', message: 'PMax budget adjusted +15% for high ROAS.', type: 'info', priority: 'normal', is_read: false, createdAt: new Date().toISOString() },
          { id: 'n2', title: 'Demo: Low inventory alert', message: 'Top category stock decreasing, check Merchant Center.', type: 'warning', priority: 'high', is_read: false, createdAt: new Date().toISOString() },
        ];
        setNotifications(demo);
        setUnreadCount(demo.filter(n => !n.is_read).length);
        return;
      }

      const params = new URLSearchParams({
        limit: '20',
        offset: '0',
        unreadOnly: unreadOnly.toString()
      });

      const response = await fetch(`https://api.glowytics.com/api/brands/${brandId}/notifications?${params}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setNotifications(data.notifications);
          setUnreadCount(data.unreadCount);
        }
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setNotificationLoading(false);
    }
  };

  const markNotificationAsRead = async (notificationId) => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;

      const response = await fetch(`https://api.glowytics.com/api/brands/${brandId}/notifications/${notificationId}/read`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include'
      });

      if (response.ok) {
        // Update local state
      startTransition(() => {
        setNotifications(prev => 
          prev.map(notif => 
            notif.id === notificationId 
              ? { ...notif, is_read: true, read_at: new Date().toISOString() }
              : notif
          )
        );
      });
        
        // Update unread count
        setUnreadCount(prev => Math.max(0, prev - 1));
      }
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const markAllNotificationsAsRead = async () => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;

      const response = await fetch(`https://api.glowytics.com/api/brands/${brandId}/notifications/mark-all-read`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include'
      });

      if (response.ok) {
        // Update local state
        startTransition(() => {
        setNotifications(prev => 
          prev.map(notif => ({ ...notif, is_read: true, read_at: new Date().toISOString() }))
        );
        setUnreadCount(0);
        });
      }
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
    }
  };

  const deleteNotification = async (notificationId) => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;

      const response = await fetch(`https://api.glowytics.com/api/brands/${brandId}/notifications/${notificationId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include'
      });

      if (response.ok) {
        // Remove from local state
        startTransition(() => {
        setNotifications(prev => prev.filter(notif => notif.id !== notificationId));
        });
        
        // Update unread count if the deleted notification was unread
        const deletedNotification = notifications.find(notif => notif.id === notificationId);
        if (deletedNotification && !deletedNotification.is_read) {
          startTransition(() => {
          setUnreadCount(prev => Math.max(0, prev - 1));
          });
        }
      }
    } catch (error) {
      console.error('Error deleting notification:', error);
    }
  };

  // DAILY COMPARISON NOTIFICATION
  const createTestNotifications = async () => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;

      // Step 1: Calculate yesterday and day before yesterday
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const dayBeforeYesterday = new Date(today);
      dayBeforeYesterday.setDate(today.getDate() - 2);
      
      const yesterdayStr = yesterday.toISOString().split('T')[0];
      const dayBeforeYesterdayStr = dayBeforeYesterday.toISOString().split('T')[0];

      // Step 2: Helper function to call unified endpoints
      const fetchUnifiedData = async (endpoint, startDate, endDate) => {
        try {
          const response = await fetch(`https://api.glowytics.com/api/google-ads/${endpoint}?dateRange=custom&startDate=${startDate}&endDate=${endDate}`, {
            headers: {
              'Content-Type': 'application/json',
              'X-Brand-ID': brandId
            },
            credentials: 'include'
          });
          
          if (response.ok) {
            const data = await response.json();
            return Array.isArray(data) ? data : [];
          }
          return [];
        } catch (error) {
          return [];
        }
      };

      // Helper: Fetch GA4 all-traffic totals for a given day
      const fetchGa4DailyTotals = async (dateStr) => {
        try {
          const url = `https://api.glowytics.com/api/google-ads/ga-traffic-source?dateRange=custom&startDate=${dateStr}&endDate=${dateStr}`;
          const response = await fetch(url, {
            headers: {
              'Content-Type': 'application/json',
              'X-Brand-ID': brandId
            },
            credentials: 'include'
          });
          if (!response.ok) return { sessions: 0, revenue: 0 };
          const data = await response.json();
          const rows = Array.isArray(data)
            ? data
            : Array.isArray(data?.detailedData)
              ? data.detailedData
              : [];
          return rows.reduce((acc, row) => {
            const sessions = Number(row.sessions ?? row.ga4_sessions ?? 0) || 0;
            const revenue = Number(row.totalRevenue ?? row.ga4_total_revenue ?? 0) || 0;
            acc.sessions += sessions;
            acc.revenue += revenue;
            return acc;
          }, { sessions: 0, revenue: 0 });
        } catch (e) {
          return { sessions: 0, revenue: 0 };
        }
      };

      // Step 3: Fetch data for both days
      const [yesterdayGoogleData, dayBeforeGoogleData, yesterdayMetaData, dayBeforeMetaData, yesterdayGa4Totals, dayBeforeGa4Totals] = await Promise.all([
        fetchUnifiedData('unified-googleads-ga4-performance', yesterdayStr, yesterdayStr),
        fetchUnifiedData('unified-googleads-ga4-performance', dayBeforeYesterdayStr, dayBeforeYesterdayStr),
        fetchUnifiedData('unified-meta-ga4-performance', yesterdayStr, yesterdayStr),
        fetchUnifiedData('unified-meta-ga4-performance', dayBeforeYesterdayStr, dayBeforeYesterdayStr),
        fetchGa4DailyTotals(yesterdayStr),
        fetchGa4DailyTotals(dayBeforeYesterdayStr)
      ]);

      // Step 4: Calculate totals for Google Ads and Analytics
      const calculateGoogleTotals = (data) => data.reduce((acc, day) => ({
        cost: acc.cost + (parseFloat(day.cost) || 0),
        revenue: acc.revenue + (parseFloat(day.conversions_value) || 0),
        clicks: acc.clicks + (parseInt(day.clicks) || 0),
        // Prefer GA4 field names; fallback to generic ones
        sessions: acc.sessions + (parseInt(day.ga4_sessions ?? day.sessions ?? 0) || 0),
        analyticsRevenue: acc.analyticsRevenue + (parseFloat(day.ga4_total_revenue ?? day.purchase_revenue ?? 0) || 0)
      }), { cost: 0, revenue: 0, clicks: 0, sessions: 0, analyticsRevenue: 0 });

      // Calculate totals for Meta Ads
      const calculateMetaTotals = (data) => data.reduce((acc, day) => ({
        cost: acc.cost + (parseFloat(day.spend) || 0),
        revenue: acc.revenue + (parseFloat(day.purchase_roas) * parseFloat(day.spend) || 0),
        clicks: acc.clicks + (parseInt(day.clicks) || 0)
      }), { cost: 0, revenue: 0, clicks: 0 });

      const yesterdayGoogle = calculateGoogleTotals(yesterdayGoogleData);
      const dayBeforeGoogle = calculateGoogleTotals(dayBeforeGoogleData);
      const yesterdayMeta = calculateMetaTotals(yesterdayMetaData);
      const dayBeforeMeta = calculateMetaTotals(dayBeforeMetaData);

      // Step 5: Calculate changes
      const calculateChange = (current, previous) => {
        if (previous === 0) return current > 0 ? 100 : 0;
        return ((current - previous) / previous) * 100;
      };

      const formatChange = (value) => {
        if (value > 0) return `+${value.toFixed(1)}%`;
        return `${value.toFixed(1)}%`;
      };

      const formatCurrency = (value) => Math.round(value).toLocaleString();
      const formatNumber = (value) => value.toLocaleString();

      const changes = {
        googleAds: {
          cost: yesterdayGoogle.cost,
          costChange: calculateChange(yesterdayGoogle.cost, dayBeforeGoogle.cost)
        },
        metaAds: {
          cost: yesterdayMeta.cost,
          costChange: calculateChange(yesterdayMeta.cost, dayBeforeMeta.cost)
        },
        analytics: {
          sessions: yesterdayGa4Totals.sessions,
          sessionsChange: calculateChange(yesterdayGa4Totals.sessions, dayBeforeGa4Totals.sessions),
          revenue: yesterdayGa4Totals.revenue,
          revenueChange: calculateChange(yesterdayGa4Totals.revenue, dayBeforeGa4Totals.revenue)
        },
        totals: {
          cost: yesterdayGoogle.cost + yesterdayMeta.cost,
          costChange: calculateChange(
            yesterdayGoogle.cost + yesterdayMeta.cost,
            dayBeforeGoogle.cost + dayBeforeMeta.cost
          )
        }
      };

      // Step 6: Format message
      const yesterdayDisplay = yesterday.toLocaleDateString('en-US', { 
        day: 'numeric', 
        month: 'long'
      });

      let message = `Date: ${yesterdayDisplay}

Google Ads: ${formatCurrency(changes.googleAds.cost)} (${formatChange(changes.googleAds.costChange)})
Meta Ads: ${formatCurrency(changes.metaAds.cost)} (${formatChange(changes.metaAds.costChange)})
GA4 Sessions: ${formatNumber(changes.analytics.sessions)} (${formatChange(changes.analytics.sessionsChange)})
GA4 Revenue: ${formatCurrency(changes.analytics.revenue)} (${formatChange(changes.analytics.revenueChange)})

Total Spend: ${formatCurrency(changes.totals.cost)} (${formatChange(changes.totals.costChange)})`;

      // Step 7: Create notification
      const dailySummaryNotification = {
        type: 'performance_alert',
        title: `Daily Performance Summary`,
        message: message,
        priority: 'normal',
        category: 'performance'
      };

      const response = await fetch(`https://api.glowytics.com/api/brands/${brandId}/notifications`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
        body: JSON.stringify(dailySummaryNotification)
      });

      if (response.ok) {
        // Refresh notifications
        setTimeout(() => {
          fetchNotifications();
        }, 500);
      } else {
        const error = await response.json();
        console.error('Failed to create daily summary notification:', error);
      }

    } catch (error) {
      console.error('Error in daily summary notification process:', error);
    }
  };

  // WEEKLY COMPARISON NOTIFICATION
  const createWeeklyComparison = async () => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;

            // Step 1: Calculate last completed week's Monday date
      const today = new Date();
      const dayOfWeek = today.getDay(); // 0 = Sunday, 1 = Monday, etc.
      
      // Always go back to last Monday (completed week)
      const daysToLastMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // If Sunday, go back 6 days
      const daysToLastCompletedMonday = daysToLastMonday + 7; // Go back one more week
      
      const lastCompletedMonday = new Date(today);
      lastCompletedMonday.setDate(today.getDate() - daysToLastCompletedMonday);
      const mondayStr = lastCompletedMonday.toISOString().split('T')[0];

      // Step 2: Fetch weekly comparison data
      const comparisonResponse = await fetch(`https://api.glowytics.com/api/google-ads/weekly-comparison?date=${mondayStr}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include'
      });

      if (!comparisonResponse.ok) {
        console.error('Failed to fetch weekly comparison');
        return;
      }

      const comparisonData = await comparisonResponse.json();
      if (!comparisonData.success || !comparisonData.comparison) {
        console.error('❌ Invalid comparison data structure');
        return;
      }

      const comparison = comparisonData.comparison;
      const changes = comparison.changes;

      // Step 3: Format the notification message
      const formatChange = (value) => {
        if (value > 0) return `+${value.toFixed(1)}%`;
        return `${value.toFixed(1)}%`;
      };

      const formatCurrency = (value) => Math.round(value).toLocaleString();
      const formatNumber = (value) => value.toLocaleString();

      const currentWeekStart = new Date(comparison.currentWeek.start).toLocaleDateString('en-US', { 
        day: 'numeric', 
        month: 'long' 
      });
      const currentWeekEnd = new Date(comparison.currentWeek.end).toLocaleDateString('en-US', { 
        day: 'numeric', 
        month: 'long' 
      });

      let message = `Week: ${currentWeekStart} - ${currentWeekEnd}

Google Ads: ${formatCurrency(changes.googleAds.cost)} (${formatChange(changes.googleAds.costChange)})
Meta Ads: ${formatCurrency(changes.metaAds.cost)} (${formatChange(changes.metaAds.costChange)})
GA4 Sessions: ${formatNumber(changes.analytics.sessions)} (${formatChange(changes.analytics.sessionsChange)})
GA4 Revenue: ${formatCurrency(changes.analytics.revenue)} (${formatChange(changes.analytics.revenueChange)})

Total Spend: ${formatCurrency(changes.totals.cost)} (${formatChange(changes.totals.costChange)})`;

      // Step 4: Create the weekly comparison notification
      const weeklyComparisonNotification = {
        type: 'performance_alert',
        title: `Weekly Performance Summary`,
        message: message,
        priority: 'normal',
        category: 'performance'
      };

      const response = await fetch(`https://api.glowytics.com/api/brands/${brandId}/notifications`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
        body: JSON.stringify(weeklyComparisonNotification)
      });

      if (response.ok) {
        
        // Refresh notifications
        setTimeout(() => {
          fetchNotifications();
        }, 500);
      } else {
        const error = await response.json();
        console.error('Failed to create weekly comparison notification:', error);
      }

    } catch (error) {
      console.error('Error in weekly comparison notification process:', error);
    }
  };

  // MONTHLY COMPARISON NOTIFICATION
  const createMonthlyComparison = async () => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;

      // Step 1: Calculate last month and month before that
      const today = new Date();
      const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1); // First day of last month
      const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of last month
      
      const monthBeforeLast = new Date(today.getFullYear(), today.getMonth() - 2, 1); // First day of month before last
      const monthBeforeLastEnd = new Date(today.getFullYear(), today.getMonth() - 1, 0); // Last day of month before last
      
      const lastMonthStartStr = lastMonth.toISOString().split('T')[0];
      const lastMonthEndStr = lastMonthEnd.toISOString().split('T')[0];
      const monthBeforeLastStartStr = monthBeforeLast.toISOString().split('T')[0];
      const monthBeforeLastEndStr = monthBeforeLastEnd.toISOString().split('T')[0];

      // Step 2: Helper function to call unified endpoints
      const fetchUnifiedData = async (endpoint, startDate, endDate) => {
        try {
          const response = await fetch(`https://api.glowytics.com/api/google-ads/${endpoint}?dateRange=custom&startDate=${startDate}&endDate=${endDate}`, {
            headers: {
              'Content-Type': 'application/json',
              'X-Brand-ID': brandId
            },
            credentials: 'include'
          });
          
          if (response.ok) {
            const data = await response.json();
            return Array.isArray(data) ? data : [];
          }
          return [];
        } catch (error) {
          return [];
        }
      };

      // Step 3: Fetch data for both months
      const [lastMonthGoogleData, monthBeforeGoogleData, lastMonthMetaData, monthBeforeMetaData] = await Promise.all([
        fetchUnifiedData('unified-googleads-ga4-performance', lastMonthStartStr, lastMonthEndStr),
        fetchUnifiedData('unified-googleads-ga4-performance', monthBeforeLastStartStr, monthBeforeLastEndStr),
        fetchUnifiedData('unified-meta-ga4-performance', lastMonthStartStr, lastMonthEndStr),
        fetchUnifiedData('unified-meta-ga4-performance', monthBeforeLastStartStr, monthBeforeLastEndStr)
      ]);

      // Step 4: Calculate totals for Google Ads and Analytics
      const calculateGoogleTotals = (data) => data.reduce((acc, day) => ({
        cost: acc.cost + (parseFloat(day.cost) || 0),
        revenue: acc.revenue + (parseFloat(day.conversions_value) || 0),
        clicks: acc.clicks + (parseInt(day.clicks) || 0),
        // keep previous monthly logic as-is; daily already uses GA4 totals from all traffic
        sessions: acc.sessions + (parseInt(day.sessions ?? day.ga4_sessions ?? 0) || 0),
        analyticsRevenue: acc.analyticsRevenue + (parseFloat(day.purchase_revenue ?? day.ga4_total_revenue ?? 0) || 0)
      }), { cost: 0, revenue: 0, clicks: 0, sessions: 0, analyticsRevenue: 0 });

      // Calculate totals for Meta Ads
      const calculateMetaTotals = (data) => data.reduce((acc, day) => ({
        cost: acc.cost + (parseFloat(day.spend) || 0),
        revenue: acc.revenue + (parseFloat(day.purchase_roas) * parseFloat(day.spend) || 0),
        clicks: acc.clicks + (parseInt(day.clicks) || 0)
      }), { cost: 0, revenue: 0, clicks: 0 });

      const lastMonthGoogle = calculateGoogleTotals(lastMonthGoogleData);
      const monthBeforeGoogle = calculateGoogleTotals(monthBeforeGoogleData);
      const lastMonthMeta = calculateMetaTotals(lastMonthMetaData);
      const monthBeforeMeta = calculateMetaTotals(monthBeforeMetaData);

      // Step 5: Calculate changes
      const calculateChange = (current, previous) => {
        if (previous === 0) return current > 0 ? 100 : 0;
        return ((current - previous) / previous) * 100;
      };

      const formatChange = (value) => {
        if (value > 0) return `+${value.toFixed(1)}%`;
        return `${value.toFixed(1)}%`;
      };

      const formatCurrency = (value) => Math.round(value).toLocaleString();
      const formatNumber = (value) => value.toLocaleString();

      const changes = {
        googleAds: {
          cost: lastMonthGoogle.cost,
          costChange: calculateChange(lastMonthGoogle.cost, monthBeforeGoogle.cost)
        },
        metaAds: {
          cost: lastMonthMeta.cost,
          costChange: calculateChange(lastMonthMeta.cost, monthBeforeMeta.cost)
        },
        analytics: {
          sessions: lastMonthGoogle.sessions,
          sessionsChange: calculateChange(lastMonthGoogle.sessions, monthBeforeGoogle.sessions),
          revenue: lastMonthGoogle.analyticsRevenue,
          revenueChange: calculateChange(lastMonthGoogle.analyticsRevenue, monthBeforeGoogle.analyticsRevenue)
        },
        totals: {
          cost: lastMonthGoogle.cost + lastMonthMeta.cost,
          costChange: calculateChange(
            lastMonthGoogle.cost + lastMonthMeta.cost,
            monthBeforeGoogle.cost + monthBeforeMeta.cost
          )
        }
      };

      // Step 6: Format message
      const lastMonthDisplay = lastMonth.toLocaleDateString('en-US', { 
        month: 'long',
        year: 'numeric'
      });

      let message = `Month: ${lastMonthDisplay}

Google Ads: ${formatCurrency(changes.googleAds.cost)} (${formatChange(changes.googleAds.costChange)})
Meta Ads: ${formatCurrency(changes.metaAds.cost)} (${formatChange(changes.metaAds.costChange)})
GA4 Sessions: ${formatNumber(changes.analytics.sessions)} (${formatChange(changes.analytics.sessionsChange)})
GA4 Revenue: ${formatCurrency(changes.analytics.revenue)} (${formatChange(changes.analytics.revenueChange)})

Total Spend: ${formatCurrency(changes.totals.cost)} (${formatChange(changes.totals.costChange)})`;

      // Step 7: Create notification
      const monthlyComparisonNotification = {
        type: 'performance_alert',
        title: `Monthly Performance Summary`,
        message: message,
        priority: 'normal',
        category: 'performance'
      };

      const response = await fetch(`https://api.glowytics.com/api/brands/${brandId}/notifications`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
        body: JSON.stringify(monthlyComparisonNotification)
      });

      if (response.ok) {
        // Refresh notifications
        setTimeout(() => {
          fetchNotifications();
        }, 500);
      } else {
        const error = await response.json();
        console.error('Failed to create monthly comparison notification:', error);
      }

    } catch (error) {
      console.error('Error in monthly comparison notification process:', error);
    }
  };
  
  // Yeni endpoint için useEffect ekleyelim
  useEffect(() => {
    console.log('🔄 USEEFFECT TRIGGERED - DATE RANGE CHANGED');
    console.log('🔄 Current dateRange:', dateRange);
    console.log('🔄 Current startDate:', startDate);
    console.log('🔄 Current endDate:', endDate);
    console.log('🔄 About to call API functions...');

    // Prevent accidental fallback requests while custom range is incomplete.
    if (dateRange === 'custom' && (!startDate || !endDate)) {
      return;
    }
    
    fetchUnifiedGoogleAdsData();
    fetchUnifiedMetaData();
    fetchGATrafficSourceData();
    fetchEventsData();
    fetchBrandLogo();
    fetchEcommerceData();
    fetchNotifications();
  }, [dateRange, startDate, endDate]);
  
  useEffect(() => {
    // Combined fetch for monthly data - eliminates duplicate API calls
    const fetchMonthlyDataCombined = async () => {
      setIsLoadingMonthly(true);
      setIsLoadingUnifiedCampaign(true);
      try {
        const brandId = localStorage.getItem('currentBrandId');
        if (!brandId) return;

        // Demo: provide 6-month platform-shaped monthly arrays
        if (brandId === DEMO_BRAND_ID) {
          const makeMonths = (n = 6) => {
            const out = [];
            const now = new Date();
            for (let i = n - 1; i >= 0; i--) {
              const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - i, 1));
              const ym = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-01`;
              out.push(ym);
            }
            return out;
          };
          const months = makeMonths(6);
          const google = months.map((m, idx) => ({
            date: m,
            ga4_sessions: 2500 + idx * 180,
            ga4_total_revenue: 120000 + idx * 9000,
            ga4_purchases: 180 + idx * 10,
            clicks: 3200 + idx * 200,
            cost: 45000 + idx * 2500,
            conversions: 220 + idx * 12,
            conversion_value: 100000 + idx * 8000,
            spend: 0,
            campaign_name: `G-Campaign-${idx + 1}`,
          }));
          const meta = months.map((m, idx) => ({
            date: m,
            ga4_sessions: 1800 + idx * 140,
            ga4_total_revenue: 90000 + idx * 7000,
            ga4_purchases: 130 + idx * 8,
            clicks: 2400 + idx * 160,
            cost: 0,
            conversions: 160 + idx * 9,
            conversion_value: 80000 + idx * 6500,
            spend: 36000 + idx * 2200,
            campaign_name: `M-Campaign-${idx + 1}`,
          }));
          // Use startTransition for non-urgent state updates
          startTransition(() => {
          setMonthlyGoogleAdsData(google);
          setMonthlyMetaAdsData(meta);
          });
          // Demo unified campaign data
          const now = new Date();
          const demoData = [];
          const campaigns = [
            { name: 'Brand Awareness Campaign', channel: 'Google Ads' },
            { name: 'Performance Max - Electronics', channel: 'Google Ads' },
            { name: 'Search - Generic Keywords', channel: 'Google Ads' },
            { name: 'Shopping - Best Sellers', channel: 'Google Ads' },
            { name: 'Meta - Retargeting', channel: 'Meta Ads' },
            { name: 'Meta - Lookalike Audiences', channel: 'Meta Ads' },
            { name: 'Meta - Video Views', channel: 'Meta Ads' },
            { name: 'Instagram - Stories', channel: 'Meta Ads' }
          ];
          for (let i = 0; i < 6; i++) {
            const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 5 + i, 1));
            const monthKey = d.toISOString().split('T')[0];
            campaigns.forEach((camp, cIdx) => {
              const isGoogle = camp.channel === 'Google Ads';
              const baseCost = isGoogle ? 45000 : 32000;
              const baseRevenue = isGoogle ? 185000 : 145000;
              demoData.push({
                month: monthKey,
                campaign_name: camp.name,
                channel: camp.channel,
                ga4_sessions: Math.round(3200 + i * 200 + cIdx * 150),
                ga4_total_revenue: Math.round((baseRevenue + i * 12000 + cIdx * 8000) * (0.9 + Math.random() * 0.2)),
                ga4_purchases: Math.round(250 + i * 20 + cIdx * 10),
                google_clicks: isGoogle ? Math.round(4200 + i * 300 + cIdx * 200) : 0,
                google_cost: isGoogle ? Math.round((baseCost + i * 3000) * (0.9 + Math.random() * 0.2)) : 0,
                google_conversions: isGoogle ? Math.round(280 + i * 15 + cIdx * 8) : 0,
                google_conversion_value: isGoogle ? Math.round((baseRevenue * 0.8 + i * 10000) * (0.9 + Math.random() * 0.2)) : 0,
                meta_clicks: !isGoogle ? Math.round(3100 + i * 250 + cIdx * 180) : 0,
                meta_cost: !isGoogle ? Math.round((baseCost + i * 2500) * (0.9 + Math.random() * 0.2)) : 0,
                meta_conversions: !isGoogle ? Math.round(210 + i * 12 + cIdx * 6) : 0,
                meta_conversion_value: !isGoogle ? Math.round((baseRevenue * 0.75 + i * 9000) * (0.9 + Math.random() * 0.2)) : 0,
              });
            });
          }
          startTransition(() => {
            setUnifiedCampaignData(demoData);
          });
          setIsLoadingMonthly(false);
          setIsLoadingUnifiedCampaign(false);
          return;
        }

        // Pull monthly-aggregated ONCE and use for both states (eliminates duplicate API call)
        const monthlyResp = await fetch(`https://api.glowytics.com/api/google-ads/unified-campaign-performance-monthly?dateRange=all`, {
          headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
          credentials: 'include',
        });
        const monthlyRows = monthlyResp.ok ? await monthlyResp.json() : [];

        // Transform monthly combined rows into previous per-platform shapes
        const googleData = [];
        const metaData = [];
        for (const row of monthlyRows) {
          const base = {
            date: row.month, // monthly timestamp
            ga4_sessions: row.ga4_sessions || 0,
            ga4_total_revenue: row.ga4_total_revenue || 0,
            ga4_purchases: row.ga4_purchases || 0,
            conversions: 0,
            conversion_value: 0,
            clicks: 0,
            cost: 0,
            spend: 0,
          };
          if ((row.channel || '').toLowerCase() === 'google ads') {
            googleData.push({
              ...base,
              clicks: row.google_clicks || 0,
              cost: row.google_cost || 0,
              conversions: row.google_conversions || 0,
              conversion_value: row.google_conversion_value || 0,
              campaign_name: row.campaign_name,
            });
          } else if ((row.channel || '').toLowerCase() === 'meta ads') {
            metaData.push({
              ...base,
              clicks: row.meta_clicks || 0,
              spend: row.meta_cost || 0,
              conversions: row.meta_conversions || 0,
              conversion_value: row.meta_conversion_value || 0,
              campaign_name: row.campaign_name,
            });
          }
        }

        // Use startTransition for non-blocking UI updates
        startTransition(() => {
        setMonthlyGoogleAdsData(googleData);
        setMonthlyMetaAdsData(metaData);
          setUnifiedCampaignData(monthlyRows); // Use same data - no duplicate API call!
        });

      } catch (error) {
        console.error("Error fetching monthly performance data:", error);
      } finally {
        setIsLoadingMonthly(false);
        setIsLoadingUnifiedCampaign(false);
      }
    };

    const fetchAllGaTrafficData = async () => {
      try {
        const brandId = localStorage.getItem('currentBrandId');
        if (!brandId) return;
        // Demo GA traffic source all data for special brand
        if (brandId === DEMO_BRAND_ID) {
          const now = new Date();
          const sources = [
            { source: 'google', medium: 'cpc' },
            { source: 'google', medium: 'organic' },
            { source: 'meta', medium: 'paid_social' },
            { source: 'instagram', medium: 'paid_social' },
            { source: 'direct', medium: '(none)' },
            { source: 'email', medium: 'newsletter' },
            { source: 'bing', medium: 'cpc' },
            { source: 'referral', medium: 'affiliate' }
          ];
          const detailedData = [];
          for (let i = 0; i < 30; i++) {
            const d = new Date(now);
            d.setDate(d.getDate() - (29 - i));
            const dateStr = d.toISOString().split('T')[0];
            sources.forEach((src, sIdx) => {
              const baseFactor = [1.5, 0.8, 1.2, 0.6, 0.4, 0.3, 0.25, 0.2][sIdx];
              detailedData.push({
                date: dateStr,
                source: src.source,
                medium: src.medium,
                sessions: Math.round((2500 * baseFactor) * (0.85 + Math.random() * 0.3)),
                eventCount: Math.round((150 * baseFactor) * (0.85 + Math.random() * 0.3)),
                totalRevenue: Math.round((98000 * baseFactor) * (0.85 + Math.random() * 0.3)),
              });
            });
          }
          setGaTrafficSourceAllData({ detailedData });
          return;
        }
        const response = await fetch(`https://api.glowytics.com/api/google-ads/ga-traffic-source?dateRange=all`, {
          headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
          credentials: 'include',
        });
        if(response.ok) {
          const data = await response.json();
          setGaTrafficSourceAllData(data);
        }
      } catch (error) {
        console.error("Error fetching all GA traffic data:", error);
      }
    };

    const fetchGaMonthlyCompact = async () => {
      try {
        const brandId = localStorage.getItem('currentBrandId');
        if (!brandId) return;
        // Demo monthly summary for special brand
        if (brandId === DEMO_BRAND_ID) {
          const now = new Date();
          const demoRows = Array.from({ length: 12 }, (_, i) => {
            const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 11 + i, 1));
            return {
              month: d.toISOString().split('T')[0],
              sessions: 75000 + i * 5000 + Math.random() * 8000,
              users: 52000 + i * 3500 + Math.random() * 5000,
              transactions: 2100 + i * 150 + Math.random() * 200,
              revenue: 1850000 + i * 120000 + Math.random() * 150000,
              bounceRate: 38 + Math.random() * 8,
              avgSessionDuration: 220 + Math.random() * 60
            };
          });
          setGaMonthlySummaryCompact(demoRows);
          return;
        }
        const res = await fetch(`https://api.glowytics.com/api/google-ads/ga-summary-monthly?dateRange=all`, {
          headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
          credentials: 'include',
        });
        if (res.ok) {
          const json = await res.json();
          setGaMonthlySummaryCompact(json?.rows || []);
        }
      } catch (e) {
        console.error('Error fetching GA monthly compact summary:', e);
        setGaMonthlySummaryCompact([]);
      }
    };

    const fetchGaWeeklyCompact = async () => {
      try {
        const brandId = localStorage.getItem('currentBrandId');
        if (!brandId) return;
        // Demo weekly summary for special brand
        if (brandId === DEMO_BRAND_ID) {
          const now = new Date();
          const demoRows = Array.from({ length: 12 }, (_, i) => {
            const d = new Date(now);
            d.setDate(d.getDate() - (11 - i) * 7);
            return {
              week_start: d.toISOString().split('T')[0],
              sessions: 18500 + i * 800 + Math.random() * 2000,
              users: 13500 + i * 600 + Math.random() * 1500,
              transactions: 520 + i * 30 + Math.random() * 50,
              revenue: 465000 + i * 25000 + Math.random() * 35000,
              bounceRate: 36 + Math.random() * 10,
              avgSessionDuration: 215 + Math.random() * 50
            };
          });
          setGaWeeklySummaryCompact(demoRows);
          return;
        }
        const res = await fetch(`https://api.glowytics.com/api/google-ads/ga-summary-weekly?dateRange=all`, {
          headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
          credentials: 'include',
        });
        if (res.ok) {
          const json = await res.json();
          setGaWeeklySummaryCompact(json?.rows || []);
        }
      } catch (e) {
        console.error('Error fetching GA weekly compact summary:', e);
        setGaWeeklySummaryCompact([]);
      }
    };

    const fetchGaDailyCompact = async () => {
      try {
        const brandId = localStorage.getItem('currentBrandId');
        if (!brandId) return;
        // Demo daily summary for special brand
        if (brandId === DEMO_BRAND_ID) {
          const now = new Date();
          const demoRows = Array.from({ length: 30 }, (_, i) => {
            const d = new Date(now);
            d.setDate(d.getDate() - (29 - i));
            const dayOfWeek = d.getDay();
            const weekendFactor = (dayOfWeek === 0 || dayOfWeek === 6) ? 1.15 : 1;
            return {
              date: d.toISOString().split('T')[0],
              sessions: Math.round((2650 + Math.random() * 600) * weekendFactor),
              users: Math.round((1950 + Math.random() * 450) * weekendFactor),
              transactions: Math.round((75 + Math.random() * 20) * weekendFactor),
              revenue: Math.round((66500 + Math.random() * 12000) * weekendFactor),
              bounceRate: 35 + Math.random() * 12,
              avgSessionDuration: 205 + Math.random() * 60
            };
          });
          setGaDailySummaryCompact(demoRows);
          return;
        }
        const res = await fetch(`https://api.glowytics.com/api/google-ads/ga-summary-daily?dateRange=all`, {
          headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
          credentials: 'include',
        });
        if (res.ok) {
          const json = await res.json();
          setGaDailySummaryCompact(json?.rows || []);
        }
      } catch (e) {
        console.error('Error fetching GA daily compact summary:', e);
        setGaDailySummaryCompact([]);
      }
    };

    // moved fetchGaPlatformDaily outside this effect scope

    const fetchGaPlatformMonthly = async () => {
      try {
        const brandId = localStorage.getItem('currentBrandId');
        if (!brandId) return;
        // Demo platform monthly for special brand
        if (brandId === DEMO_BRAND_ID) {
          const now = new Date();
          const demoRows = [];
          const platforms = ['mobile', 'desktop', 'tablet'];
          for (let i = 0; i < 6; i++) {
            const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 5 + i, 1));
            const monthKey = d.toISOString().split('T')[0];
            platforms.forEach((platform, pIdx) => {
              const baseFactor = pIdx === 0 ? 1.4 : pIdx === 1 ? 1 : 0.3;
              demoRows.push({
                month: monthKey,
                platform: platform,
                sessions: Math.round((25000 + i * 2000) * baseFactor),
                users: Math.round((18000 + i * 1500) * baseFactor),
                transactions: Math.round((700 + i * 50) * baseFactor),
                revenue: Math.round((620000 + i * 40000) * baseFactor),
              });
            });
          }
          setGaPlatformMonthly(demoRows);
          return;
        }
        const resp = await fetch(`https://api.glowytics.com/api/google-ads/ga-platform-monthly`, {
          headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
          credentials: 'include',
        });
        if (resp.ok) {
          const data = await resp.json();
          setGaPlatformMonthly(Array.isArray(data?.rows) ? data.rows : []);
        }
      } catch (e) {
        console.error('Error fetching GA platform monthly:', e);
        setGaPlatformMonthly([]);
      }
    };

    // NOTE: fetchUnifiedCampaignData removed - now combined into fetchMonthlyDataCombined to avoid duplicate API calls

    fetchMonthlyDataCombined();
    fetchAllGaTrafficData();
    fetchGaMonthlyCompact();
    fetchGaWeeklyCompact();
    fetchGaDailyCompact();
    fetchGaPlatformDaily();
    fetchGaPlatformMonthly();
    // Fetch last30 specialized view in parallel for future use (not affecting Channel Monthly Revenue)
    (async () => {
      try {
        const brandId = localStorage.getItem('currentBrandId');
        if (!brandId) return;
        const resp = await fetch(`https://api.glowytics.com/api/google-ads/unified-campaign-performance-last30`, {
          headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
          credentials: 'include',
        });
        if (resp.ok) {
          const data = await resp.json();
          setUnifiedCampaignLast30Data(data);
        }
      } catch (e) {
        console.error('Error prefetching last30 unified campaign data:', e);
      }
    })();
  }, []); // Sadece bileşen yüklendiğinde çalışır
  
  // (Removed synthetic current month injection; show exactly what backend returns)
  
  // Helper: format date as YYYY-MM-DD in local timezone (avoid UTC shift)
  const formatDateForAPI = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // (Removed MTD override; show exactly backend-provided monthly rows)

  // GA Platform Daily fetcher (component scope so it can be reused on filter changes)
  const fetchGaPlatformDaily = useCallback(async () => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;
      // Demo platform daily for special brand
      if (brandId === DEMO_BRAND_ID) {
        const now = new Date();
        const demoRows = [];
        const platforms = ['mobile', 'desktop', 'tablet'];
        const numDays = dateRange === 'today' ? 1 : dateRange === 'yesterday' ? 1 : dateRange === 'last7' ? 7 : dateRange === 'last30' ? 30 : 30;
        for (let i = 0; i < numDays; i++) {
          const d = new Date(now);
          d.setDate(d.getDate() - (numDays - 1 - i));
          const dateStr = d.toISOString().split('T')[0];
          const dayOfWeek = d.getDay();
          const weekendFactor = (dayOfWeek === 0 || dayOfWeek === 6) ? 1.12 : 1;
          platforms.forEach((platform, pIdx) => {
            const baseFactor = pIdx === 0 ? 1.5 : pIdx === 1 ? 1 : 0.25;
            demoRows.push({
              date: dateStr,
              platform: platform,
              sessions: Math.round((2800 * baseFactor * weekendFactor) * (0.9 + Math.random() * 0.2)),
              users: Math.round((2100 * baseFactor * weekendFactor) * (0.9 + Math.random() * 0.2)),
              transactions: Math.round((85 * baseFactor * weekendFactor) * (0.9 + Math.random() * 0.2)),
              revenue: Math.round((72000 * baseFactor * weekendFactor) * (0.9 + Math.random() * 0.2)),
            });
          });
        }
        setGaPlatformDaily(demoRows);
        return;
      }
      let url = `https://api.glowytics.com/api/google-ads/ga-platform-daily`;
      if (dateRange === 'custom' && startDate && endDate) {
        const s = formatDateForAPI(startDate);
        const e = formatDateForAPI(endDate);
        url += `?startDate=${s}&endDate=${e}`;
      } else {
        const today = new Date();
        const copy = (d) => new Date(d.getTime());
        const toYMD = (d) => {
          const y = d.getFullYear();
          const m = String(d.getMonth() + 1).padStart(2, '0');
          const dd = String(d.getDate()).padStart(2, '0');
          return `${y}-${m}-${dd}`;
        };
        let start = null, end = toYMD(today);
        if (dateRange === 'today') {
          start = end;
        } else if (dateRange === 'yesterday') {
          const y = copy(today); y.setDate(y.getDate() - 1);
          start = toYMD(y); end = toYMD(y);
        } else if (dateRange === 'last7') {
          const s7 = copy(today); s7.setDate(s7.getDate() - 6);
          start = toYMD(s7);
        } else if (dateRange === 'last30') {
          const s30 = copy(today); s30.setDate(s30.getDate() - 29);
          start = toYMD(s30);
        } else if (dateRange === 'last90') {
          const s90 = copy(today); s90.setDate(s90.getDate() - 89);
          start = toYMD(s90);
        }
        if (start) {
          url += `?startDate=${start}&endDate=${end}`;
        }
      }
      const resp = await fetch(url, {
        headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
        credentials: 'include',
      });
      if (resp.ok) {
        const data = await resp.json();
        setGaPlatformDaily(Array.isArray(data?.rows) ? data.rows : []);
      }
    } catch (e) {
      console.error('Error fetching GA platform daily:', e);
      setGaPlatformDaily([]);
    }
  }, [dateRange, startDate, endDate]);

  // Platform daily table should react to range changes (place after helpers to avoid temporal dead zone)
  useEffect(() => {
    if (dateRange === 'custom' && (!startDate || !endDate)) return;
    // reuse existing fetcher
    (async () => {
      try {
        await fetchGaPlatformDaily();
      } catch (e) {
        // no-op
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange, startDate, endDate]);

  const fetchUnifiedMetaData = async (customStartDate, customEndDate) => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.error('No brand ID found');
        return;
      }
      if (brandId === DEMO_BRAND_ID) {
        setIsLoadingUnifiedMetaAds(true);
        const demo = [
          { date: '2025-09-01', clicks: 900, ga4_sessions: 2200, ga4_total_revenue: 120000, conversion_value: 95000, spend: 35000, campaign_id: 'M-1' },
          { date: '2025-10-01', clicks: 1100, ga4_sessions: 2600, ga4_total_revenue: 140000, conversion_value: 115000, spend: 38000, campaign_id: 'M-2' },
        ];
        setUnifiedMetaAdsData(demo);
        setIsLoadingUnifiedMetaAds(false);
        return;
      }
      
      setIsLoadingUnifiedMetaAds(true);
      console.log('Fetching Unified Meta Ads & GA4 data...');

      let url;
      const effectiveStart = customStartDate || (dateRange === 'custom' ? startDate : null);
      const effectiveEnd = customEndDate || (dateRange === 'custom' ? endDate : null);
      if (effectiveStart && effectiveEnd) {
          const startDateStr = formatDateForAPI(effectiveStart);
          const endDateStr = formatDateForAPI(effectiveEnd);
          url = `https://api.glowytics.com/api/google-ads/unified-meta-ga4-performance?dateRange=custom&startDate=${startDateStr}&endDate=${endDateStr}`;
      } else {
          url = `https://api.glowytics.com/api/google-ads/unified-meta-ga4-performance?dateRange=${dateRange}`;
      }
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
      });
      
      if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      
      startTransition(() => {
      setUnifiedMetaAdsData(data);
      });
      console.log('========== UNIFIED META ADS / GA4 DATA ==========');
      console.log('Raw unified meta data:', data);
      console.log('========== END OF UNIFIED META ADS / GA4 DATA ==========');

    } catch (error) {
      console.error('Error fetching unified meta performance data:', error);
      setUnifiedMetaAdsData(null); // Clear data on error
    } finally {
      setIsLoadingUnifiedMetaAds(false);
    }
  };
  
  const fetchUnifiedGoogleAdsData = async (customStartDate, customEndDate) => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.error('No brand ID found');
        return;
      }
      if (brandId === DEMO_BRAND_ID) {
        setIsLoadingUnifiedGoogleAds(true);
        const demo = [
          { date: '2025-09-01', clicks: 1200, ga4_sessions: 3000, ga4_total_revenue: 150000, conversion_value: 120000, cost: 40000, campaign_id: 'G-1' },
          { date: '2025-10-01', clicks: 1400, ga4_sessions: 3400, ga4_total_revenue: 170000, conversion_value: 140000, cost: 45000, campaign_id: 'G-2' },
        ];
        setUnifiedGoogleAdsData(demo);
        setIsLoadingUnifiedGoogleAds(false);
        return;
      }
      
      setIsLoadingUnifiedGoogleAds(true);
      console.log('Fetching Unified Google Ads & GA4 data...');

      let url;
      const effectiveStart = customStartDate || (dateRange === 'custom' ? startDate : null);
      const effectiveEnd = customEndDate || (dateRange === 'custom' ? endDate : null);
      if (effectiveStart && effectiveEnd) {
          const startDateStr = formatDateForAPI(effectiveStart);
          const endDateStr = formatDateForAPI(effectiveEnd);
          url = `https://api.glowytics.com/api/google-ads/unified-googleads-ga4-performance?dateRange=custom&startDate=${startDateStr}&endDate=${endDateStr}`;
      } else {
          url = `https://api.glowytics.com/api/google-ads/unified-googleads-ga4-performance?dateRange=${dateRange}`;
      }
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
      });
      
      if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      
      startTransition(() => {
      setUnifiedGoogleAdsData(data);
      });
      console.log('========== UNIFIED GOOGLE ADS / GA4 DATA ==========');
      console.log('Raw unified data:', data);
      console.log('========== END OF UNIFIED GOOGLE ADS / GA4 DATA ==========');

    } catch (error) {
      console.error('Error fetching unified performance data:', error);
      setUnifiedGoogleAdsData(null); // Clear data on error
    } finally {
      setIsLoadingUnifiedGoogleAds(false);
    }
  };
  
  // GA Traffic Source verilerini çeken fonksiyon (custom dates ile)
  const fetchGATrafficSourceDataWithDates = async (customStartDate, customEndDate) => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.error('No brand ID found in localStorage for GA Traffic Source');
        return;
      }
      if (brandId === DEMO_BRAND_ID) {
        setIsLoadingGaTrafficSource(true);
        const demo = {
          detailedData: [
            { date: '2025-10-01', source: 'google', medium: 'cpc', sessions: 2100, eventCount: 130, totalRevenue: 98000 },
            { date: '2025-10-01', source: 'meta', medium: 'paid_social', sessions: 900, eventCount: 60, totalRevenue: 42000 },
            { date: '2025-10-02', source: 'google', medium: 'organic', sessions: 800, eventCount: 20, totalRevenue: 15000 },
          ],
          totals: { users: 3000, sessions: 3800, eventCount: 210, totalRevenue: 155000 }
        };
        setGaTrafficSourceData(demo);
        setIsLoadingGaTrafficSource(false);
        return;
      }
      
      setIsLoadingGaTrafficSource(true);
      console.log('Fetching GA Traffic Source data with custom dates...');
      
      const gaDateRange = 'custom';
      console.log(`Using date range parameter for GA Traffic Source: ${gaDateRange}`);
      
      // Custom date range için URL parametrelerini hazırla
      let apiUrl = `https://api.glowytics.com/api/google-ads/ga-traffic-source?dateRange=${gaDateRange}`;
      if (customStartDate && customEndDate) {
        const startDateStr = formatDateForAPI(customStartDate); // YYYY-MM-DD format
        const endDateStr = formatDateForAPI(customEndDate);
        apiUrl += `&startDate=${startDateStr}&endDate=${endDateStr}`;
        console.log(`Custom date range: ${startDateStr} to ${endDateStr}`);
      }
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
      });
      
      if (!response.ok) {
        throw new Error(`GA Traffic Source API error: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      
      // Veriyi state'e kaydet
      startTransition(() => {
      setGaTrafficSourceData(data);
      });
      setIsLoadingGaTrafficSource(false);
      
      console.log('========== GA TRAFFIC SOURCE DATA (CUSTOM DATES) ==========');
      console.log('Raw GA traffic source data:', data);
      console.log('========== END OF GA TRAFFIC SOURCE DATA (CUSTOM DATES) ==========');
    } catch (error) {
      console.error('Error fetching GA Traffic Source data with custom dates:', error);
      setIsLoadingGaTrafficSource(false);
    }
  };

  // GA Traffic Source verilerini çeken fonksiyon
  const fetchGATrafficSourceData = async () => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.error('No brand ID found in localStorage');
        return;
      }
      if (brandId === DEMO_BRAND_ID) {
        setIsLoadingGaTrafficSource(true);
        const demo = {
          detailedData: [
            { date: '2025-10-01', source: 'google', medium: 'cpc', sessions: 2000, eventCount: 120, totalRevenue: 90000 },
            { date: '2025-10-01', source: 'meta', medium: 'paid_social', sessions: 800, eventCount: 55, totalRevenue: 38000 },
            { date: '2025-10-02', source: 'google', medium: 'organic', sessions: 700, eventCount: 18, totalRevenue: 12000 },
          ],
          totals: { users: 2800, sessions: 3500, eventCount: 193, totalRevenue: 140000 }
        };
        setGaTrafficSourceData(demo);
        setIsLoadingGaTrafficSource(false);
        return;
      }
      
      setIsLoadingGaTrafficSource(true);
      console.log('🚀 FETCH GA TRAFFIC SOURCE DATA CALLED');
      console.log('📅 Current dateRange state:', dateRange);
      console.log('🏢 Brand ID:', brandId);

      let apiUrl = `https://api.glowytics.com/api/google-ads/ga-traffic-source?dateRange=${dateRange}`;
      if (dateRange === 'custom' && startDate && endDate) {
        const startStr = formatDateForAPI(startDate);
        const endStr = formatDateForAPI(endDate);
        apiUrl = `https://api.glowytics.com/api/google-ads/ga-traffic-source?dateRange=custom&startDate=${startStr}&endDate=${endStr}`;
      }
      console.log('🌐 Full API URL:', apiUrl);
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
      });
      
      console.log('📡 GA Traffic Response status:', response.status);
      
      if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      startTransition(() => {
      setGaTrafficSourceData(data);
      });
      setIsLoadingGaTrafficSource(false);
      
      console.log('========== GA TRAFFIC SOURCE DATA ==========');
      console.log('📊 Raw GA Traffic Source data:', data);
      console.log('📊 Data keys:', typeof data === 'object' ? Object.keys(data) : 'Not an object');
      console.log('========== END OF GA TRAFFIC SOURCE DATA ==========');
    } catch (error) {
      console.error('❌ Error fetching GA Traffic Source data:', error);
      setIsLoadingGaTrafficSource(false);
    }
  };

  // GA Device Performance (grouped by device) fetcher
  const fetchGADevicePerf = async () => {
    try {
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) return;
      
      // Demo device data for special brand
      if (brandId === DEMO_BRAND_ID) {
        setIsLoadingGaDevicePerf(true);
        const demoDevices = [
          { key: 'mobile', deviceCategory: 'mobile', sessions: 52000, users: 38500, transactions: 1250, revenue: 1180000, bounceRate: 45.2, avgSessionDuration: 185 },
          { key: 'desktop', deviceCategory: 'desktop', sessions: 28000, users: 22000, transactions: 980, revenue: 1450000, bounceRate: 35.8, avgSessionDuration: 320 },
          { key: 'tablet', deviceCategory: 'tablet', sessions: 5200, users: 4100, transactions: 145, revenue: 165000, bounceRate: 42.5, avgSessionDuration: 245 }
        ];
        setGaDevicePerf(demoDevices);
        setIsLoadingGaDevicePerf(false);
        return;
      }
      
      setIsLoadingGaDevicePerf(true);
      // Build URL based on current dateRange
      let apiUrl = `https://api.glowytics.com/api/google-ads/ga-device-performance?groupBy=device&dateRange=${dateRange}`;
      if (dateRange === 'custom' && startDate && endDate) {
        const startStr = formatDateForAPI(startDate);
        const endStr = formatDateForAPI(endDate);
        apiUrl = `https://api.glowytics.com/api/google-ads/ga-device-performance?groupBy=device&dateRange=custom&startDate=${startStr}&endDate=${endStr}`;
      }
      const res = await fetch(apiUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
        credentials: 'include'
      });
      if (!res.ok) throw new Error(`GA Device Perf API error: ${res.status} ${res.statusText}`);
      const json = await res.json();
      const rows = Array.isArray(json?.rows) ? json.rows : [];
      // Normalize device order for display
      const order = ['mobile', 'desktop', 'tablet'];
      const byKey = {};
      rows.forEach(r => {
        const key = (r.key || r.deviceCategory || '').toString().toLowerCase();
        byKey[key] = r;
      });
      const ordered = order
        .filter(k => byKey[k])
        .map(k => byKey[k]);
      setGaDevicePerf(ordered.length ? ordered : rows);
    } catch (e) {
      console.warn('GA Device Perf fetch failed:', e);
      setGaDevicePerf([]);
    } finally {
      setIsLoadingGaDevicePerf(false);
    }
  };

  // Fetch GA device perf when date range changes
  useEffect(() => {
    // For custom, wait until both dates are set
    if (dateRange === 'custom' && (!startDate || !endDate)) return;
    fetchGADevicePerf();
  }, [dateRange, startDate, endDate]);

  // Process funnel data from events
  const processFunnelData = (eventsData) => {
    // Define funnel steps in order
    const funnelSteps = [
      { eventName: 'view_item', displayName: 'Product Views', icon: Eye },
      { eventName: 'add_to_cart', displayName: 'Add to Cart', icon: ShoppingCart },
      { eventName: 'view_cart', displayName: 'View Cart', icon: MousePointerClick },
      { eventName: 'begin_checkout', displayName: 'Checkout', icon: CreditCard },
      { eventName: 'purchase', displayName: 'Purchase', icon: Package }
    ];

    // Extract event counts from API data
    const eventCounts = {};
    if (eventsData && eventsData.summaryByEvent) {
      eventsData.summaryByEvent.forEach(event => {
        eventCounts[event.eventName] = Number(event.totalEventCount || 0);
      });
    }

    console.log('=== FUNNEL PROCESSING ===');
    console.log('Event counts:', eventCounts);

    // Find the highest event count to use as base (usually view_item)
    let baseCount = Math.max(...funnelSteps.map(step => eventCounts[step.eventName] || 0));
    
    // If no events at all, use 0 as base
    if (baseCount === 0) {
      console.log('No event data found, using zero values');
    }

    // Build funnel steps with real data (or zeros)
    const funnelStepsWithData = [];

    funnelSteps.forEach((step, index) => {
      const count = eventCounts[step.eventName] || 0;
      
      // Calculate drop-off from previous step (not from base)
      let dropoff = 0;
      if (index > 0) {
        const prevCount = funnelStepsWithData[index - 1].value;
        if (prevCount > 0) {
          dropoff = ((prevCount - count) / prevCount * 100);
        }
      }

      funnelStepsWithData.push({
        name: step.displayName,
        value: count,
        dropoff: Math.round(dropoff * 10) / 10, // Drop-off from previous step
        icon: step.icon,
      });
    });

    console.log('Processed funnel steps:', funnelStepsWithData);

    // Calculate summary metrics
    const purchaseCount = eventCounts['purchase'] || 0;
    const totalRevenue = purchaseCount * 150; // Assume avg order value of 150
    const conversionRate = baseCount > 0 ? (purchaseCount / baseCount * 100) : 0;
    const dropoffRate = 100 - conversionRate;

    const summary = {
      conversionRate: Math.round(conversionRate * 10) / 10,
      avgTimeToConvert: "1.8", // Mock data
      dropoffRate: Math.round(dropoffRate * 10) / 10,
      revenue: totalRevenue,
      avgOrderValue: 150 // Mock data
    };

    console.log('Funnel summary:', summary);
    console.log('Base count (highest event):', baseCount);
    console.log('=== END FUNNEL PROCESSING ===');

    return {
      steps: funnelStepsWithData,
      summary: summary
    };
  };

  // Fetch GA Events Raw data for funnel
  const fetchEventsData = async () => {
    try {
      setEventsLoading(true);
      setFunnelLoading(true);
      setEventsError(null);
      
      const brandId = localStorage.getItem('currentBrandId');
      if (!brandId) {
        console.log('No brand ID found in localStorage');
        setEventsError('Brand ID not found');
        // Still process funnel with empty data
        const processedFunnel = processFunnelData(null);
        setFunnelData(processedFunnel);
        return;
      }
      
      // Demo funnel data for special brand
      if (brandId === DEMO_BRAND_ID) {
        const demoFunnel = {
          steps: [
            { name: 'Product Views', value: 45200, percentage: 100, dropoff: 0, icon: Eye, vsLastPeriod: 12.5 },
            { name: 'Add to Cart', value: 8150, percentage: 18.0, dropoff: 82.0, icon: ShoppingCart, vsLastPeriod: 8.3 },
            { name: 'View Cart', value: 5420, percentage: 12.0, dropoff: 33.5, icon: MousePointerClick, vsLastPeriod: 15.2 },
            { name: 'Checkout', value: 2980, percentage: 6.6, dropoff: 45.0, icon: CreditCard, vsLastPeriod: 6.8 },
            { name: 'Purchase', value: 1850, percentage: 4.1, dropoff: 37.9, icon: Package, vsLastPeriod: 11.2 }
          ],
          summary: {
            conversionRate: 4.1,
            avgTimeToConvert: "2.3",
            dropoffRate: 95.9,
            revenue: 1620000,
            avgOrderValue: 876
          }
        };
        setFunnelData(demoFunnel);
        setEventsData([]);
        setEventsLoading(false);
        setFunnelLoading(false);
        return;
      }
      
      console.log('🚀 FETCH EVENTS DATA CALLED');
      console.log('📅 Current dateRange state:', dateRange);
      console.log('🏢 Brand ID:', brandId);
      
      const apiUrl = `https://api.glowytics.com/api/google-ads/ga-events-raw?dateRange=${dateRange}`;
      console.log('🌐 Full API URL:', apiUrl);
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Brand-ID': brandId
        },
        credentials: 'include',
      });
      
      console.log('📡 Response status:', response.status);
      console.log('📡 Response headers:', Object.fromEntries(response.headers.entries()));
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Events API error response:', errorText);
        throw new Error(`API Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      
      console.log('========== GA EVENTS RAW DATA ==========');
      console.log('📊 Raw GA events data:', data);
      console.log('📊 Data length:', Array.isArray(data) ? data.length : 'Not an array');
      console.log('📊 Data keys:', typeof data === 'object' ? Object.keys(data) : 'Not an object');
      
      const processedFunnel = processFunnelData(data);
      console.log('✅ Updating funnel with processed data');
      setFunnelData(processedFunnel);
      
      setEventsData(data);
      console.log('========== END OF GA EVENTS RAW DATA ==========');
      setEventsError(null);
    } catch (error) {
      console.error('❌ Error fetching GA events data:', error.message);
      setEventsError(error.message || 'Failed to fetch events data');
      setEventsData(null);
      
      const processedFunnel = processFunnelData(null);
      setFunnelData(processedFunnel);
    } finally {
      setEventsLoading(false);
      setFunnelLoading(false);
    }
  };

  // Helper function to get API date range parameter
  const getApiDateRangeParam = (range) => {
    switch(range) {
      case 'today': return 'today';
      case 'yesterday': return 'yesterday';
      case 'last7': return 'last7';
      case 'last30': return 'last30';
      case 'last90': return 'last90';
      default: return 'last30';
    }
  };
  
  // Date range data configuration for all metrics
  const metricsDateRangeData = {
    today: {
      labels: Array.from({length: 24}, (_, i) => `${i}:00`),
      totalSales: {
        current: [25000, 18000, 12000, 8000, 5000, 6000, 15000, 35000, 65000, 87000, 98000, 110000, 105000, 95000, 85000, 92000, 97000, 102000, 90000, 75000, 60000, 45000, 35000, 28000],
        previous: [22000, 15000, 10000, 7000, 4500, 5500, 13000, 33000, 60000, 82000, 94000, 100000, 98000, 90000, 80000, 85000, 93000, 97000, 85000, 70000, 55000, 40000, 30000, 25000]
      },
      saleCount: {
        current: [5, 4, 3, 2, 1, 2, 4, 9, 15, 22, 25, 28, 26, 24, 21, 23, 25, 26, 23, 19, 15, 11, 8, 6],
        previous: [4, 3, 2, 2, 1, 2, 3, 8, 14, 20, 24, 26, 25, 22, 20, 21, 24, 25, 21, 18, 14, 10, 7, 5]
      },
      sessionCount: {
        current: [850, 650, 450, 350, 300, 450, 900, 1800, 3200, 4500, 5200, 5800, 5500, 5000, 4700, 5100, 5400, 5600, 4800, 3900, 2800, 1900, 1200, 950],
        previous: [800, 600, 400, 300, 250, 400, 850, 1700, 3000, 4300, 5000, 5500, 5200, 4800, 4500, 4900, 5200, 5400, 4600, 3700, 2600, 1800, 1100, 900]
      },
      conversionRate: {
        current: [0.62, 0.58, 0.55, 0.52, 0.48, 0.53, 0.60, 0.68, 0.72, 0.76, 0.78, 0.80, 0.78, 0.75, 0.74, 0.77, 0.79, 0.78, 0.76, 0.72, 0.68, 0.64, 0.60, 0.58],
        previous: [0.60, 0.56, 0.53, 0.50, 0.46, 0.51, 0.58, 0.66, 0.70, 0.74, 0.76, 0.78, 0.76, 0.73, 0.72, 0.75, 0.77, 0.76, 0.74, 0.70, 0.66, 0.62, 0.58, 0.56]
      },
      refundAmount: {
        current: [500, 400, 300, 200, 150, 200, 350, 800, 1500, 2200, 2800, 3000, 2800, 2600, 2500, 2700, 2800, 2900, 2700, 2200, 1800, 1300, 900, 600],
        previous: [450, 350, 250, 180, 130, 180, 320, 750, 1400, 2100, 2700, 2900, 2700, 2500, 2400, 2600, 2700, 2800, 2600, 2100, 1700, 1200, 850, 550]
      }
    },
    yesterday: {
      labels: Array.from({length: 24}, (_, i) => `${i}:00`),
      totalSales: {
        current: [26000, 19000, 13000, 9000, 6000, 7000, 16000, 36000, 67000, 88000, 99000, 112000, 108000, 97000, 87000, 94000, 99000, 104000, 92000, 77000, 62000, 46000, 36000, 29000],
        previous: [24000, 17000, 11000, 7500, 5000, 6000, 14000, 35000, 64000, 84000, 97000, 106000, 101000, 92000, 82000, 89000, 95000, 100000, 88000, 73000, 58000, 42000, 32000, 26000]
      },
      saleCount: {
        current: [6, 5, 3, 2, 1, 2, 4, 10, 16, 23, 26, 29, 27, 25, 22, 24, 26, 27, 24, 20, 16, 12, 9, 7],
        previous: [5, 4, 3, 2, 1, 2, 4, 9, 15, 22, 25, 28, 26, 24, 21, 23, 25, 26, 23, 19, 15, 11, 8, 6]
      },
      sessionCount: {
        current: [900, 700, 480, 370, 320, 480, 950, 1900, 3300, 4600, 5300, 5900, 5600, 5100, 4800, 5200, 5500, 5700, 4900, 4000, 2900, 2000, 1300, 1000],
        previous: [850, 650, 450, 350, 300, 450, 900, 1800, 3200, 4500, 5200, 5800, 5500, 5000, 4700, 5100, 5400, 5600, 4800, 3900, 2800, 1900, 1200, 950]
      },
      conversionRate: {
        current: [0.63, 0.59, 0.56, 0.53, 0.49, 0.54, 0.61, 0.69, 0.73, 0.77, 0.79, 0.81, 0.79, 0.76, 0.75, 0.78, 0.80, 0.79, 0.77, 0.73, 0.69, 0.65, 0.61, 0.59],
        previous: [0.62, 0.58, 0.55, 0.52, 0.48, 0.53, 0.60, 0.68, 0.72, 0.76, 0.78, 0.80, 0.78, 0.75, 0.74, 0.77, 0.79, 0.78, 0.76, 0.72, 0.68, 0.64, 0.60, 0.58]
      },
      refundAmount: {
        current: [520, 420, 320, 220, 170, 220, 370, 820, 1550, 2300, 2900, 3100, 2900, 2700, 2600, 2800, 2900, 3000, 2800, 2300, 1900, 1400, 950, 650],
        previous: [500, 400, 300, 200, 150, 200, 350, 800, 1500, 2200, 2800, 3000, 2800, 2600, 2500, 2700, 2800, 2900, 2700, 2200, 1800, 1300, 900, 600]
      }
    },
    last7: {
      // Generate actual dates for last 7 days
      labels: (() => {
        const dates = [];
        for (let i = 6; i >= 0; i--) {
          const date = new Date();
          date.setDate(date.getDate() - i);
          dates.push(date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' }));
        }
        return dates;
      })(),
      totalSales: {
        current: [750000, 850000, 920000, 880000, 1050000, 1200000, 980000],
        previous: [680000, 790000, 850000, 820000, 950000, 1100000, 900000]
      },
      saleCount: {
        current: [180, 195, 210, 205, 230, 260, 220],
        previous: [170, 185, 200, 195, 220, 245, 210]
      },
      sessionCount: {
        current: [23000, 25000, 28000, 26000, 32000, 38000, 29000],
        previous: [21000, 23000, 26000, 24000, 30000, 36000, 27000]
      },
      conversionRate: {
        current: [0.78, 0.76, 0.75, 0.77, 0.80, 0.82, 0.75],
        previous: [0.75, 0.73, 0.72, 0.74, 0.78, 0.80, 0.73]
      },
      refundAmount: {
        current: [35000, 38000, 42000, 40000, 45000, 52000, 41000],
        previous: [32000, 36000, 39000, 38000, 43000, 49000, 39000]
      }
    },
    last30: {
      // Generate actual dates for the month (every other day)
      labels: (() => {
        const dates = [];
        for (let i = 29; i >= 0; i -= 2) {
          const date = new Date();
          date.setDate(date.getDate() - i);
          dates.push(date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' }));
        }
        return dates;
      })(),
      totalSales: {
        current: [750000, 550000, 900000, 800000, 1050000, 1100000, 950000, 900000, 750000, 850000, 950000, 1100000, 1300000, 800000, 850000],
        previous: [820000, 900000, 700000, 650000, 850000, 950000, 1200000, 1300000, 1150000, 950000, 850000, 750000, 550000, 650000, 750000]
      },
      saleCount: {
        current: [175, 135, 210, 190, 230, 245, 225, 215, 185, 205, 225, 250, 280, 190, 200],
        previous: [190, 210, 175, 160, 195, 215, 260, 275, 255, 220, 200, 185, 145, 160, 180]
      },
      sessionCount: {
        current: [23000, 19000, 28000, 25000, 32000, 34000, 30000, 29000, 24000, 27000, 31000, 36000, 39000, 26000, 28000],
        previous: [25000, 28000, 23000, 21000, 27000, 29000, 35000, 37000, 33000, 29000, 26000, 24000, 19000, 21000, 23000]
      },
      conversionRate: {
        current: [0.72, 0.65, 0.78, 0.75, 0.82, 0.85, 0.80, 0.78, 0.74, 0.77, 0.80, 0.85, 0.90, 0.76, 0.78],
        previous: [0.78, 0.82, 0.76, 0.73, 0.79, 0.83, 0.88, 0.90, 0.85, 0.80, 0.76, 0.72, 0.65, 0.70, 0.75]
      },
      refundAmount: {
        current: [125000, 105000, 140000, 130000, 155000, 160000, 145000, 140000, 125000, 135000, 145000, 160000, 175000, 130000, 135000],
        previous: [135000, 145000, 125000, 120000, 140000, 150000, 170000, 175000, 160000, 145000, 135000, 125000, 110000, 120000, 125000]
      }
    },
    thisMonth: {
      // Generate daily data for the current month
      labels: (() => {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        const totalDays = lastDay.getDate();
        
        const dates = [];
        for (let day = 1; day <= totalDays; day++) {
          const date = new Date(now.getFullYear(), now.getMonth(), day);
          dates.push(date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' }));
        }
        
        return dates;
      })(),
      totalSales: {
        current: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => Math.floor(Math.random() * 200000) + 100000);
        })(),
        previous: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => Math.floor(Math.random() * 180000) + 90000);
        })()
      },
      saleCount: {
        current: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => Math.floor(Math.random() * 40) + 20);
        })(),
        previous: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => Math.floor(Math.random() * 35) + 18);
        })()
      },
      sessionCount: {
        current: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => Math.floor(Math.random() * 5000) + 3000);
        })(),
        previous: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => Math.floor(Math.random() * 4500) + 2800);
        })()
      },
      conversionRate: {
        current: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => (Math.random() * 0.15) + 0.7);
        })(),
        previous: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => (Math.random() * 0.14) + 0.68);
        })()
      },
      refundAmount: {
        current: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => Math.floor(Math.random() * 12000) + 5000);
        })(),
        previous: (() => {
          const now = new Date();
          const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
          return Array.from({ length: totalDays }, () => Math.floor(Math.random() * 11000) + 4800);
        })()
      }
    },
    custom: {
      // For custom date ranges, use a placeholder that will be replaced when the user selects a date range
      labels: (() => {
        // Default to last 15 days
        const dates = [];
        for (let i = 14; i >= 0; i--) {
          const date = new Date();
          date.setDate(date.getDate() - i);
          dates.push(date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' }));
        }
        return dates;
      })(),
      totalSales: {
        current: [750000, 550000, 900000, 800000, 1050000, 1100000, 950000, 900000, 750000, 850000, 950000, 1100000, 1300000, 800000, 850000],
        previous: [820000, 900000, 700000, 650000, 850000, 950000, 1200000, 1300000, 1150000, 950000, 850000, 750000, 550000, 650000, 750000]
      },
      saleCount: {
        current: [175, 135, 210, 190, 230, 245, 225, 215, 185, 205, 225, 250, 280, 190, 200],
        previous: [190, 210, 175, 160, 195, 215, 260, 275, 255, 220, 200, 185, 145, 160, 180]
      },
      sessionCount: {
        current: [23000, 19000, 28000, 25000, 32000, 34000, 30000, 29000, 24000, 27000, 31000, 36000, 39000, 26000, 28000],
        previous: [25000, 28000, 23000, 21000, 27000, 29000, 35000, 37000, 33000, 29000, 26000, 24000, 19000, 21000, 23000]
      },
      conversionRate: {
        current: [0.72, 0.65, 0.78, 0.75, 0.82, 0.85, 0.80, 0.78, 0.74, 0.77, 0.80, 0.85, 0.90, 0.76, 0.78],
        previous: [0.78, 0.82, 0.76, 0.73, 0.79, 0.83, 0.88, 0.90, 0.85, 0.80, 0.76, 0.72, 0.65, 0.70, 0.75]
      },
      refundAmount: {
        current: [125000, 105000, 140000, 130000, 155000, 160000, 145000, 140000, 125000, 135000, 145000, 160000, 175000, 130000, 135000],
        previous: [135000, 145000, 125000, 120000, 140000, 150000, 170000, 175000, 160000, 145000, 135000, 125000, 110000, 120000, 125000]
      }
    }
  };

  // Add chart data for different metrics - now uses the date range data
  const metricsChartData = {
    totalSales: {
      current: metricsDateRangeData[dateRange]?.totalSales?.current || [],
      previous: metricsDateRangeData[dateRange]?.totalSales?.previous || [],
      yAxisPrefix: '₺',
      yAxisFormat: (value) => '₺' + (value / 1000000).toFixed(1) + 'M',
      tooltipFormat: (value) => '₺' + value.toLocaleString()
    },
    saleCount: {
      current: metricsDateRangeData[dateRange]?.saleCount?.current || [],
      previous: metricsDateRangeData[dateRange]?.saleCount?.previous || [],
      yAxisPrefix: '',
      yAxisFormat: (value) => value.toLocaleString(),
      tooltipFormat: (value) => value.toLocaleString()
    },
    sessionCount: {
      current: metricsDateRangeData[dateRange]?.sessionCount?.current || [],
      previous: metricsDateRangeData[dateRange]?.sessionCount?.previous || [],
      yAxisPrefix: '',
      yAxisFormat: (value) => (value / 1000).toFixed(0) + 'K',
      tooltipFormat: (value) => value.toLocaleString()
    },
    conversionRate: {
      current: metricsDateRangeData[dateRange]?.conversionRate?.current || [],
      previous: metricsDateRangeData[dateRange]?.conversionRate?.previous || [],
      yAxisPrefix: '%',
      yAxisFormat: (value) => value.toFixed(2) + '%',
      tooltipFormat: (value) => value.toFixed(2) + '%'
    },
    refundAmount: {
      current: metricsDateRangeData[dateRange]?.refundAmount?.current || [],
      previous: metricsDateRangeData[dateRange]?.refundAmount?.previous || [],
      yAxisPrefix: '₺',
      yAxisFormat: (value) => '₺' + (value / 1000).toFixed(0) + 'K',
      tooltipFormat: (value) => '₺' + value.toLocaleString()
    }
  };

  // Function to get active metric title
  const getActiveMetricTitle = () => {
    const metricTitle = (() => {
      switch(activeMetric) {
        case 'conversionRate': return 'Users';
        case 'saleCount': return 'Sessions';
        case 'refundAmount': return 'Transactions';
        case 'sessionCount': return 'Conversion Rate';
        case 'totalSales': return 'Revenue';
        default: return 'Users';
      }
    })();
    
    return `${metricTitle} (${getDateRangeTitle()})`;
  };

  // Function to get the date range title
  const getDateRangeTitle = () => {
    switch(dateRange) {
      case 'today': return 'Today';
      case 'yesterday': return 'Yesterday';
      case 'last7': return 'Last 7 Days';
      case 'last30': return 'Last 30 Days';
      case 'thisMonth': return 'This Month';
      case 'custom': return startDate && endDate ? 
        `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}` : 'Custom Range';
      default: return 'Today';
    }
  };

  // Günün saatine göre selamlama metni belirleyen fonksiyon
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) {
      return "Good morning";
    } else if (hour >= 12 && hour < 18) {
      return "Good afternoon";
    } else {
      return "Good evening";
    }
  };

  const dateFilters = [
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last7', label: '7 Days' },
    { value: 'last30', label: '30 Days' },
    { value: 'thisMonth', label: 'This Month' },
    { value: 'lastMonth', label: 'Last Month' },
    { value: 'last90', label: '90 Days' },
    { value: 'all', label: 'All Time' }
  ];

  const gaDateFilters = [
    { value: 'yesterday', label: 'Yesterday' },
    { value: '7days', label: '7 Days' },
    { value: '30days', label: '30 Days' },
    { value: '90days', label: '90 Days' }
  ];

  // Function to handle custom date range changes
  const handleCustomDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      // Calculate the difference in days
      const diffTime = Math.abs(end - start);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      
      // Generate labels for each day in the range
      const customLabels = [];
      const customTotalSalesCurrent = [];
      const customTotalSalesPrevious = [];
      const customSaleCountCurrent = [];
      const customSaleCountPrevious = [];
      const customSessionCountCurrent = [];
      const customSessionCountPrevious = [];
      const customConversionRateCurrent = [];
      const customConversionRatePrevious = [];
      const customRefundAmountCurrent = [];
      const customRefundAmountPrevious = [];
      
      // Generate data for each day
      for (let i = 0; i < diffDays; i++) {
        const date = new Date(start);
        date.setDate(date.getDate() + i);
        customLabels.push(date.toLocaleDateString('en-US', { day: 'numeric', month: 'short' }));
        
        // Generate random data for each day
        // In a real app, you would fetch actual data from an API
        customTotalSalesCurrent.push(Math.floor(Math.random() * 500000) + 500000);
        customTotalSalesPrevious.push(Math.floor(Math.random() * 500000) + 500000);
        customSaleCountCurrent.push(Math.floor(Math.random() * 150) + 150);
        customSaleCountPrevious.push(Math.floor(Math.random() * 150) + 150);
        customSessionCountCurrent.push(Math.floor(Math.random() * 10000) + 20000);
        customSessionCountPrevious.push(Math.floor(Math.random() * 10000) + 20000);
        customConversionRateCurrent.push(Math.random() * 0.3 + 0.6);
        customConversionRatePrevious.push(Math.random() * 0.3 + 0.6);
        customRefundAmountCurrent.push(Math.floor(Math.random() * 50000) + 100000);
        customRefundAmountPrevious.push(Math.floor(Math.random() * 50000) + 100000);
      }
      
      // Update the custom date range data
      const updatedDateRangeData = { ...metricsDateRangeData };
      updatedDateRangeData.custom = {
        labels: customLabels,
        totalSales: {
          current: customTotalSalesCurrent,
          previous: customTotalSalesPrevious
        },
        saleCount: {
          current: customSaleCountCurrent,
          previous: customSaleCountPrevious
        },
        sessionCount: {
          current: customSessionCountCurrent,
          previous: customSessionCountPrevious
        },
        conversionRate: {
          current: customConversionRateCurrent,
          previous: customConversionRatePrevious
        },
        refundAmount: {
          current: customRefundAmountCurrent,
          previous: customRefundAmountPrevious
        }
      };
      
      // Update the date range
      setDateRange('custom');
      setIsCustomDateOpen(false);
      
      // Update the metrics date range data
      Object.assign(metricsDateRangeData, updatedDateRangeData);
      
      // Custom date range seçildiğinde API'leri yeniden çağır
      console.log('Custom date range selected, fetching new data...');
      // Pass the dates directly to avoid state update timing issues
      fetchUnifiedGoogleAdsData(start, end);
      fetchUnifiedMetaData(start, end);
      fetchGATrafficSourceDataWithDates(start, end);
    }
  };

  // Birden fazla elementi sayfalara bölerek export eden fonksiyon

  // Brand Logo Component
  const BrandLogo = () => (
    <div className="flex items-center">
      {logoUrl ? (
        <img 
          src={logoUrl} 
          alt="Brand Logo" 
          className="h-8 w-auto object-contain" 
        />
      ) : (
        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
          <span className="text-white text-sm font-bold">
            {user?.name?.charAt(0) || 'G'}
          </span>
        </div>
      )}
    </div>
  );

  // Notification Modal Component
  const NotificationModal = () => {
    // unreadCount artık state'den geliyor, local hesaplama yapmaya gerek yok
    
    const getNotificationIcon = (type, priority = 'normal', message = '') => {
      // Platform-specific icons for performance alerts
      if (type === 'performance_alert') {
        if (message.includes('Google Ads Performance')) {
          return <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />;
        }
        if (message.includes('Meta Ads Performance')) {
          return <img src="/6033716.png" alt="Meta Ads" className="w-5 h-5 object-contain" />;
        }
        if (message.includes('GA4 Analytics')) {
          return <img src="/GA4logoicon.svg" alt="GA4" className="w-5 h-5 object-contain" />;
        }
        // Weekly Performance Review - use chart icon
        if (message.includes('Weekly Performance Review') || message.includes('Week:')) {
          return <TrendingUp className="w-5 h-5 text-blue-500" />;
        }
      }
      
      switch(type) {
        case 'sync_success':
          return <Target className="w-5 h-5 text-green-500" />;
        case 'sync_failed':
          return <AlertTriangle className="w-5 h-5 text-red-500" />;
        case 'budget_alert':
          return <AlertTriangle className="w-5 h-5 text-orange-500" />;
        case 'performance_alert':
          return <TrendingUp className="w-5 h-5 text-yellow-500" />;
        case 'ai_suggestion':
          return <Lightbulb className="w-5 h-5 text-purple-500" />;
        case 'system':
          return <Settings className="w-5 h-5 text-blue-500" />;
        // Legacy support for old types
        case 'warning':
          return <AlertTriangle className="w-5 h-5 text-orange-500" />;
        case 'success':
          return <Target className="w-5 h-5 text-green-500" />;
        case 'info':
          return <Info className="w-5 h-5 text-blue-500" />;
        default:
          // Priority based fallback
          if (priority === 'urgent') return <AlertTriangle className="w-5 h-5 text-red-500" />;
          if (priority === 'high') return <AlertTriangle className="w-5 h-5 text-orange-500" />;
          return <Bell className="w-5 h-5 text-gray-500" />;
      }
    };

    const getCategoryColor = (category) => {
      switch(category) {
        // New API categories
        case 'sync':
          return 'bg-green-100 text-green-700';
        case 'campaign':
          return 'bg-blue-100 text-blue-700';
        case 'budget':
          return 'bg-orange-100 text-orange-700';
        case 'performance':
          return 'bg-yellow-100 text-yellow-700';
        case 'ai':
          return 'bg-purple-100 text-purple-700';
        case 'system':
          return 'bg-gray-100 text-gray-700';
        // Legacy categories for backward compatibility
        case 'Google Ads':
          return 'bg-red-100 text-red-700';
        case 'Meta Ads':
          return 'bg-blue-100 text-blue-700';
        case 'AI Insights':
          return 'bg-purple-100 text-purple-700';
        case 'Inventory':
          return 'bg-orange-100 text-orange-700';
        case 'Reports':
          return 'bg-gray-100 text-gray-700';
        default:
          return 'bg-gray-100 text-gray-700';
      }
    };
    
    // Parse formatted performance notification messages into structured data
    const parsePerformanceMessage = (message) => {
      if (!message || typeof message !== 'string') {
        return { periodLabel: '', metrics: [] };
      }
      const lines = message.split('\n').map(l => l.trim()).filter(Boolean);
      let periodLabel = '';
      const metrics = [];

      const periodLine = lines.find(l => l.startsWith('Date:') || l.startsWith('Week:') || l.startsWith('Month:'));
      if (periodLine) {
        const idx = periodLine.indexOf(':');
        periodLabel = periodLine.slice(idx + 1).trim();
      }

      const metricRegex = /^([A-Za-z0-9\s]+):\s*([0-9.,]+)\s*\(([-+]?\d+\.?\d*%)\)/;
      for (const line of lines) {
        const match = line.match(metricRegex);
        if (match) {
          const label = match[1].trim();
          const value = match[2].trim();
          const change = match[3].trim();
          metrics.push({ label, value, change });
        }
      }
      return { periodLabel, metrics };
    };

    const getChangePillStyles = (changeStr) => {
      if (!changeStr) return 'bg-gray-50 text-gray-600';
      if (changeStr.startsWith('+')) return 'bg-green-50 text-green-700';
      if (changeStr.startsWith('-')) return 'bg-red-50 text-red-700';
      return 'bg-gray-50 text-gray-700';
    };

    const MetricLabel = ({ text, hint }) => (
      <div className="flex items-center gap-1 text-xs text-gray-600">
        <span>{text}</span>
        {hint && (
          <span className="px-1 py-0.5 text-[9px] rounded bg-gray-100 text-gray-500 border border-gray-200">{hint}</span>
        )}
      </div>
    );

    const PerformanceNotificationCard = ({ notification }) => {
      const { periodLabel, metrics } = parsePerformanceMessage(notification.message);
      const isUnread = !notification.is_read;
      return (
        <div className={`${isUnread ? 'border-blue-200 bg-blue-50/40' : 'border-gray-100 bg-white'} rounded-lg border p-4 shadow-sm hover:shadow transition-colors`}>
          <div className="flex items-start justify-between">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-0.5">
                {getNotificationIcon(notification.type, notification.priority, notification.message)}
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <h4 className="text-sm font-semibold text-gray-800">{notification.title}</h4>
                  {notification.priority === 'urgent' && (
                    <span className="inline-flex px-1.5 py-0.5 text-[10px] font-semibold rounded-full bg-red-100 text-red-700">URGENT</span>
                  )}
                  {notification.category && (
                    <span className={`inline-flex px-2 py-0.5 text-[10px] font-medium rounded-full ${getCategoryColor(notification.category)}`}>
                      {notification.category}
                    </span>
                  )}
                </div>
                {periodLabel && (
                  <div className="text-xs text-gray-500 mt-0.5">{periodLabel}</div>
                )}
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-[10px] text-gray-500">{notification.created_at ? new Date(notification.created_at).toLocaleDateString() : ''}</span>
              {isUnread && <div className="w-2 h-2 bg-blue-500 rounded-full" />}
            </div>
          </div>
          {metrics.length > 0 ? (
            <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
              {metrics.map((m) => {
                const hint = m.label === 'Google Ads' || m.label === 'Meta Ads' ? 'Cost' : undefined;
                return (
                  <div key={m.label} className="flex items-center justify-between rounded-md border border-gray-100 bg-white px-3 py-2">
                  <MetricLabel text={m.label} hint={hint} />
                  <div className="flex items-center gap-2">
                    <div className="text-sm font-semibold text-gray-800 tabular-nums">{m.value}</div>
                    <span className={`inline-flex px-1.5 py-0.5 text-[11px] font-medium rounded ${getChangePillStyles(m.change)}`}>{m.change}</span>
                  </div>
                </div>
                );
              })}
            </div>
          ) : (
            <p className="text-sm text-gray-600 mt-2 leading-relaxed">{notification.message}</p>
          )}
        </div>
      );
    };

    if (!isNotificationOpen) return null;

    return (
      <div className="fixed inset-0 z-50">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-25" 
          onClick={() => setIsNotificationOpen(false)}
        />
        
        {/* Modal */}
        <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] max-w-[90vw] bg-white rounded-xl shadow-2xl border border-gray-200 max-h-[80vh] flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <div className="flex items-center gap-3">
              <Bell className="w-5 h-5 text-gray-600" />
              <h3 className="text-lg font-semibold text-gray-800">Notifications</h3>
              {unreadCount > 0 && (
                <span className="px-2 py-1 text-xs font-bold text-white bg-red-500 rounded-full">
                  {unreadCount}
                </span>
              )}
            </div>
            <div className="flex items-center gap-2">
              {/* Daily Summary Button - Development only */}
              <button
                onClick={createTestNotifications}
                className="text-xs px-3 py-1 text-blue-600 hover:text-blue-800 font-medium border border-blue-200 rounded-md hover:bg-blue-50 transition-colors"
                title="Create daily summary notification for yesterday"
              >
                Daily Summary
              </button>
              {/* Weekly Comparison Button - Development only */}
              <button
                onClick={createWeeklyComparison}
                className="text-xs px-3 py-1 text-purple-600 hover:text-purple-800 font-medium border border-purple-200 rounded-md hover:bg-purple-50 transition-colors"
                title="Create weekly comparison notification"
              >
                Weekly Comparison
              </button>
              {/* Monthly Comparison Button - Development only */}
              <button
                onClick={createMonthlyComparison}
                className="text-xs px-3 py-1 text-green-600 hover:text-green-800 font-medium border border-green-200 rounded-md hover:bg-green-50 transition-colors"
                title="Create monthly comparison notification"
              >
                Monthly Comparison
              </button>
              {unreadCount > 0 && (
                <button
                  onClick={markAllNotificationsAsRead}
                  className="text-xs px-3 py-1 text-blue-600 hover:text-blue-800 font-medium border border-blue-200 rounded-md hover:bg-blue-50 transition-colors"
                >
                  Mark All Read
                </button>
              )}
              <button
                onClick={() => setIsNotificationOpen(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
                </svg>
              </button>
            </div>
          </div>

          {/* Notifications List */}
          <div className="flex-1 overflow-y-auto">
            {notificationLoading ? (
              <div className="flex flex-col items-center justify-center py-12 text-gray-500">
                <Loader2 className="w-8 h-8 mb-4 text-gray-400 animate-spin" />
                <p className="text-sm">Loading notifications...</p>
              </div>
            ) : notifications.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-12 text-gray-500">
                <Bell className="w-12 h-12 mb-4 text-gray-300" />
                <p className="text-sm">No notifications yet</p>
              </div>
            ) : (
              <div className="space-y-2 p-2">
                {notifications.map((notification) => (
                  <div
                    key={notification.id}
                    className="cursor-pointer"
                    onClick={() => {
                      if (!notification.is_read) {
                        markNotificationAsRead(notification.id);
                      }
                      if (notification.action_url) {
                        window.location.href = notification.action_url;
                      }
                    }}
                  >
                    {notification.type === 'performance_alert' ? (
                      <PerformanceNotificationCard notification={notification} />
                    ) : (
                      <div className={`p-4 rounded-lg border ${!notification.is_read ? 'border-blue-200 bg-blue-50/40' : 'border-gray-100 bg-white'} hover:shadow-sm transition`}>
                        <div className="flex items-start gap-3">
                          <div className="flex-shrink-0 mt-0.5">
                            {getNotificationIcon(notification.type, notification.priority, notification.message)}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-start justify-between mb-1">
                              <h4 className={`text-sm font-medium text-gray-800 ${!notification.is_read ? 'font-semibold' : ''}`}>{notification.title}</h4>
                              {!notification.is_read && <div className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0 mt-2"></div>}
                            </div>
                            <p className="text-sm text-gray-600 mb-2 leading-relaxed">{notification.message}</p>
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-2">
                                {notification.category && (
                                  <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getCategoryColor(notification.category)}`}>{notification.category}</span>
                                )}
                                {notification.action_label && (
                                  <span className="text-xs text-blue-600 font-medium">{notification.action_label} →</span>
                                )}
                              </div>
                              <span className="text-xs text-gray-500">{notification.created_at ? new Date(notification.created_at).toLocaleDateString() : ''}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="p-4 border-t border-gray-200">
            <button className="w-full text-sm text-blue-600 hover:text-blue-700 font-medium">
              Mark all as read
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  
    // Tarih aralığını görüntülenebilir metne dönüştüren yardımcı fonksiyon
  const getDateRangeDisplayText = (range) => {
    switch(range) {
      case 'today': return 'Today';
      case 'yesterday': return 'Yesterday';
      case 'last7': return 'Last 7 Days';
      case 'last30': return 'Last 30 Days';
      case 'last90': return 'Last 90 Days';
      case 'all': return 'All Time';
      case 'custom': return startDate && endDate ? 
        `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}` : 'Custom Range';
      default: return 'Last 30 Days';
    }
  };

  // Function to generate chart data from GA4 data (current vs previous window)
  const generateGA4ChartData = (metric) => {
    if (!gaTrafficSourceData?.detailedData) {
      return { labels: [], current: [], previous: [] };
    }

    const windows = getComparisonWindows();
    if (!windows) return { labels: [], current: [], previous: [] };

    // Helper: list of YYYY-MM-DD between start..end inclusive
    const enumerateDates = (startStr, endStr) => {
      const dates = [];
      const d = new Date(startStr);
      const end = new Date(endStr);
      while (d <= end) {
        dates.push(formatDateYYYYMMDD(d));
        d.setDate(d.getDate() + 1);
      }
      return dates;
    };

    // Helper: sum metric for a given date in a source array
    const sumMetricForDate = (source, dateStr, metricKey) => {
      if (!Array.isArray(source)) return 0;
      if (metricKey === 'sessionCount') {
        // conversion rate per day
        let sessions = 0;
        let transactions = 0;
        source.forEach(item => {
          const d = typeof item.date === 'string' ? (item.date.includes('T') ? item.date.split('T')[0] : item.date) : formatDateYYYYMMDD(new Date(item.date));
          if (d === dateStr) {
            sessions += Number(item.sessions) || 0;
            transactions += Number(item.eventCount) || 0;
          }
        });
        return sessions > 0 ? (transactions / sessions) * 100 : 0;
      }

      let sum = 0;
      source.forEach(item => {
        const d = typeof item.date === 'string' ? (item.date.includes('T') ? item.date.split('T')[0] : item.date) : formatDateYYYYMMDD(new Date(item.date));
        if (d !== dateStr) return;
        switch (metricKey) {
          case 'totalSales':
            sum += Number(item.totalRevenue) || 0;
            break;
          case 'saleCount':
            sum += Number(item.sessions) || 0;
            break;
          case 'conversionRate':
            sum += Number(item.users) || 0;
            break;
          case 'refundAmount':
            sum += Number(item.eventCount) || 0;
            break;
          default:
            sum += Number(item.totalRevenue) || 0;
        }
      });
      return sum;
    };

    const currentDates = enumerateDates(windows.current.start, windows.current.end);
    const prevDates = enumerateDates(windows.previous.start, windows.previous.end);
    const labels = currentDates.map((s, idx) => {
      const cur = new Date(s).toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
      const prev = prevDates[idx] ? new Date(prevDates[idx]).toLocaleDateString('en-US', { day: 'numeric', month: 'short' }) : '';
      return `${cur} | ${prev}`;
    });

    const currentSource = gaTrafficSourceData.detailedData;
    const previousSource = (gaTrafficSourceAllData?.detailedData?.length ? gaTrafficSourceAllData.detailedData : gaTrafficSourceData.detailedData);

    const current = currentDates.map(d => sumMetricForDate(currentSource, d, metric));
    const previous = prevDates.map(d => sumMetricForDate(previousSource, d, metric));

    return { labels, current, previous };
  };

  // Get chart data (GA4 or fallback to static)
  const getChartData = (metric) => {
    if (gaTrafficSourceData?.detailedData) {
      const ga4Data = generateGA4ChartData(metric);
      return {
        labels: ga4Data.labels,
        datasets: [
          {
            label: 'Current',
            data: ga4Data.current,
            borderColor: '#3b82f6',
            backgroundColor: 'rgba(59, 130, 246, 0.1)',
            tension: 0.4,
            pointRadius: 0,
            pointHoverRadius: 4,
            borderWidth: 2.5,
            fill: true
          },
          {
            label: 'Previous',
            data: ga4Data.previous,
            borderColor: '#9CA3AF',
            backgroundColor: 'rgba(156, 163, 175, 0.15)',
            tension: 0.4,
            pointRadius: 0,
            pointHoverRadius: 3,
            borderWidth: 2,
            fill: false,
            borderDash: [4, 4]
          }
        ]
      };
    } else {
      return {
        labels: [],
        datasets: [
          {
            label: 'Daily Data',
            data: [],
            borderColor: '#3b82f6',
            backgroundColor: 'rgba(59, 130, 246, 0.1)',
            tension: 0.4,
            pointRadius: 0,
            pointHoverRadius: 4,
            borderWidth: 2.5,
            fill: true
          }
        ]
      };
    }
  };

  // Memoize GA daily totals to avoid recomputation in tables
  const gaDailyTotalsMap = useMemo(() => {
    if (!gaTrafficSourceData?.detailedData) return null;
    const map = new Map(); // dateStr -> { revenue, sessions, transactions }
    for (const item of gaTrafficSourceData.detailedData) {
      const d = typeof item.date === 'string' ? (item.date.includes('T') ? item.date.split('T')[0] : item.date) : formatDateYYYYMMDD(new Date(item.date));
      if (!map.has(d)) {
        map.set(d, { revenue: 0, sessions: 0, transactions: 0 });
      }
      const agg = map.get(d);
      agg.revenue += Number(item.totalRevenue) || 0;
      agg.sessions += Number(item.sessions) || 0;
      agg.transactions += Number(item.eventCount) || 0;
    }
    return map;
  }, [gaTrafficSourceData]);

  // Helper: format Date to YYYY-MM-DD (local time)
  const formatDateYYYYMMDD = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Helper: add days
  const addDays = (dateObj, delta) => {
    const d = new Date(dateObj);
    d.setDate(d.getDate() + delta);
    return d;
  };

  // Compute current and previous windows based on selected dateRange
  const getComparisonWindows = () => {
    let currentStart = null;
    let currentEnd = null;

    const today = new Date();
    const todayStr = formatDateYYYYMMDD(today);

    switch (dateRange) {
      case 'today': {
        const d = new Date();
        currentStart = formatDateYYYYMMDD(d);
        currentEnd = currentStart;
        break;
      }
      case 'yesterday': {
        const y = addDays(new Date(), -1);
        const yStr = formatDateYYYYMMDD(y);
        currentStart = yStr;
        currentEnd = yStr;
        break;
      }
      case 'last7': {
        // Exclude today; include yesterday as the last day
        const end = addDays(new Date(), -1);
        const start = addDays(end, -6);
        currentStart = formatDateYYYYMMDD(start);
        currentEnd = formatDateYYYYMMDD(end);
        break;
      }
      case 'last30': {
        const end = new Date();
        const start = addDays(end, -29);
        currentStart = formatDateYYYYMMDD(start);
        currentEnd = formatDateYYYYMMDD(end);
        break;
      }
      case 'last90': {
        const end = new Date();
        const start = addDays(end, -89);
        currentStart = formatDateYYYYMMDD(start);
        currentEnd = formatDateYYYYMMDD(end);
        break;
      }
      case 'thisMonth': {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = now;
        currentStart = formatDateYYYYMMDD(start);
        currentEnd = formatDateYYYYMMDD(end);
        break;
      }
      case 'lastMonth': {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const end = new Date(now.getFullYear(), now.getMonth(), 0);
        currentStart = formatDateYYYYMMDD(start);
        currentEnd = formatDateYYYYMMDD(end);
        break;
      }
      case 'custom': {
        if (startDate && endDate) {
          currentStart = formatDateYYYYMMDD(new Date(startDate));
          currentEnd = formatDateYYYYMMDD(new Date(endDate));
        }
        break;
      }
      default: {
        // Fallback: treat unknown as last30
        const end = new Date();
        const start = addDays(end, -29);
        currentStart = formatDateYYYYMMDD(start);
        currentEnd = formatDateYYYYMMDD(end);
      }
    }

    if (!currentStart || !currentEnd) return null;

    // Compute previous window with same inclusive length
    const startObj = new Date(currentStart);
    const endObj = new Date(currentEnd);
    const lengthDays = Math.round((endObj - startObj) / (1000 * 60 * 60 * 24)) + 1;
    const prevEnd = addDays(startObj, -1);
    const prevStart = addDays(prevEnd, -(lengthDays - 1));

    return {
      current: { start: currentStart, end: currentEnd },
      previous: { start: formatDateYYYYMMDD(prevStart), end: formatDateYYYYMMDD(prevEnd) }
    };
  };

  // Aggregate GA4 metrics within a date window
  const aggregateGA4ForWindow = (startStr, endStr) => {
    const source = gaTrafficSourceAllData?.detailedData?.length
      ? gaTrafficSourceAllData.detailedData
      : (gaTrafficSourceData?.detailedData || []);
    if (!source.length) return { users: 0, sessions: 0, eventCount: 0, totalRevenue: 0 };
    const within = (d) => d >= startStr && d <= endStr;
    return source.reduce((acc, item) => {
      const d = typeof item.date === 'string' ? (item.date.includes('T') ? item.date.split('T')[0] : item.date) : formatDateYYYYMMDD(new Date(item.date));
      if (!within(d)) return acc;
      acc.users += Number(item.users) || 0;
      acc.sessions += Number(item.sessions) || 0;
      acc.eventCount += Number(item.eventCount) || 0;
      acc.totalRevenue += Number(item.totalRevenue) || 0;
      return acc;
    }, { users: 0, sessions: 0, eventCount: 0, totalRevenue: 0 });
  };

  // Compute percentage trend for a metric based on current vs previous window
  const trendPercentages = useMemo(() => {
    const windows = getComparisonWindows();
    if (!windows) return { users: 0, sessions: 0, eventCount: 0, totalRevenue: 0, conversionRate: 0 };
    const curAgg = aggregateGA4ForWindow(windows.current.start, windows.current.end);
    const prevAgg = aggregateGA4ForWindow(windows.previous.start, windows.previous.end);
    const pct = (cur, prev) => (prev === 0 ? 0 : ((cur - prev) / prev) * 100);
        const curRate = curAgg.sessions > 0 ? (curAgg.eventCount / curAgg.sessions) * 100 : 0;
        const prevRate = prevAgg.sessions > 0 ? (prevAgg.eventCount / prevAgg.sessions) * 100 : 0;
    return {
      users: pct(curAgg.users, prevAgg.users),
      sessions: pct(curAgg.sessions, prevAgg.sessions),
      eventCount: pct(curAgg.eventCount, prevAgg.eventCount),
      totalRevenue: pct(curAgg.totalRevenue, prevAgg.totalRevenue),
      conversionRate: pct(curRate, prevRate)
    };
  }, [gaTrafficSourceAllData, gaTrafficSourceData, dateRange, startDate, endDate]);

  // Memoized aggregates for current and previous windows for quick UI access
  const comparisonAggregates = React.useMemo(() => {
    const windows = getComparisonWindows();
    if (!windows) return null;
    const cur = aggregateGA4ForWindow(windows.current.start, windows.current.end);
    const prev = aggregateGA4ForWindow(windows.previous.start, windows.previous.end);
    const curCR = cur.sessions > 0 ? (cur.eventCount / cur.sessions) * 100 : 0;
    const prevCR = prev.sessions > 0 ? (prev.eventCount / prev.sessions) * 100 : 0;
    return { cur, prev, curCR, prevCR };
  }, [gaTrafficSourceAllData, gaTrafficSourceData, dateRange, startDate, endDate]);

  // Label for the currently selected window (e.g., Sep 8 – Sep 14)
  const getSelectedRangeDatesLabel = () => {
    const windows = getComparisonWindows();
    if (!windows) return '';
    const fmt = (str) => new Date(str).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const sameDay = windows.current.start === windows.current.end;
    if (sameDay) return fmt(windows.current.end);
    return `${fmt(windows.current.start)} – ${fmt(windows.current.end)}`;
  };

  // Process GA Traffic Source data for the table
  const trafficSourcesAnalytics = useMemo(() => {
    if (!gaTrafficSourceData?.detailedData || gaTrafficSourceData.detailedData.length === 0) {
      return { tableData: [], totals: null };
    }

    const sourceGroups = {};
    for (const item of gaTrafficSourceData.detailedData) {
      const source = item.source || 'Others';
      const medium = item.medium || 'none';
      const key = `${source} / ${medium}`;
      if (!sourceGroups[key]) {
        sourceGroups[key] = {
          source,
          medium,
          sourcemedium: key,
          type: medium === 'organic' ? 'organic' : medium === 'cpc' ? 'cpc' : medium === 'social' ? 'social' : medium === 'email' ? 'email' : medium === 'referral' ? 'referral' : 'direct',
          sessions: 0,
          transactions: 0,
          revenue: 0,
          users: 0,
          iconBg: medium === 'organic' ? 'bg-blue-100' : medium === 'cpc' ? 'bg-red-100' : medium === 'social' ? 'bg-indigo-100' : medium === 'email' ? 'bg-amber-100' : medium === 'referral' ? 'bg-pink-100' : 'bg-green-100',
          iconColor: medium === 'organic' ? 'text-blue-600' : medium === 'cpc' ? 'text-red-600' : medium === 'social' ? 'text-indigo-600' : medium === 'email' ? 'text-amber-600' : medium === 'referral' ? 'text-pink-600' : 'text-green-600',
        };
      }
      sourceGroups[key].sessions += Number(item.sessions) || 0;
      sourceGroups[key].transactions += Number(item.eventCount) || 0;
      sourceGroups[key].revenue += Number(item.totalRevenue) || 0;
      sourceGroups[key].users += Number(item.users) || 0;
    }

    const allSourceMediums = Object.values(sourceGroups).sort((a, b) => b.sessions - a.sessions);
    const top20 = allSourceMediums.slice(0, 20);
    const othersData = allSourceMediums.slice(20);

    if (othersData.length > 0) {
      const othersGroup = {
        source: 'Others',
        medium: 'mixed',
        sourcemedium: 'Others / mixed',
        type: 'others',
        sessions: othersData.reduce((sum, item) => sum + item.sessions, 0),
        transactions: othersData.reduce((sum, item) => sum + item.transactions, 0),
        revenue: othersData.reduce((sum, item) => sum + item.revenue, 0),
        users: othersData.reduce((sum, item) => sum + item.users, 0),
        iconBg: 'bg-gray-100',
        iconColor: 'text-gray-600',
      };
      top20.push(othersGroup);
    }

    const processedData = top20.map(group => ({
        source: group.source,
        medium: group.medium,
        sourcemedium: group.sourcemedium,
        type: group.type,
        sessions: group.sessions,
        transactions: group.transactions,
        revenue: group.revenue,
      conversionRate: group.sessions > 0 ? (group.transactions / group.sessions * 100) : 0,
        iconBg: group.iconBg,
      iconColor: group.iconColor,
    }));

    const totals = processedData.reduce((acc, item) => {
      acc.sessions += item.sessions;
      acc.transactions += item.transactions;
      acc.revenue += item.revenue;
      return acc;
    }, { sessions: 0, transactions: 0, revenue: 0 });
    const totalsWithCr = { ...totals, conversionRate: totals.sessions > 0 ? (totals.transactions / totals.sessions * 100) : 0 };

    return { tableData: processedData, totals: totalsWithCr };
  }, [gaTrafficSourceData]);

  const googleAdsSummary = useMemo(() => {
    if (!unifiedGoogleAdsData || unifiedGoogleAdsData.length === 0) {
      return {
        totalClicks: 0,
        totalSessions: 0,
        totalConversions: 0,
        totalGa4Purchases: 0,
        totalGa4Revenue: 0,
        totalGoogleAdsRevenue: 0,
        totalCost: 0,
        campaignCount: 0,
        cpc: 0,
        cps: 0,
        roas: 0,
      };
    }

    const totals = unifiedGoogleAdsData.reduce((acc, item) => {
      acc.totalClicks += item.clicks || 0;
      acc.totalSessions += item.ga4_sessions || 0;
      acc.totalConversions += item.conversions || 0;
      acc.totalGa4Purchases += item.ga4_purchases || 0;
      acc.totalGa4Revenue += item.ga4_total_revenue || 0;
      acc.totalGoogleAdsRevenue += item.conversion_value || 0;
      acc.totalCost += item.cost || 0;
      return acc;
    }, {
      totalClicks: 0,
      totalSessions: 0,
      totalConversions: 0,
      totalGa4Purchases: 0,
      totalGa4Revenue: 0,
      totalGoogleAdsRevenue: 0,
      totalCost: 0,
    });

    const campaignIds = new Set(unifiedGoogleAdsData.map(item => item.campaign_id));

    const cpc = totals.totalClicks > 0 ? totals.totalCost / totals.totalClicks : 0;
    const cps = totals.totalSessions > 0 ? totals.totalCost / totals.totalSessions : 0;
    const roas = totals.totalCost > 0 ? totals.totalGoogleAdsRevenue / totals.totalCost : 0;

    return {
      ...totals,
      campaignCount: campaignIds.size,
      cpc: cpc,
      cps: cps,
      roas: roas,
    };
  }, [unifiedGoogleAdsData]);

  const metaAdsSummary = useMemo(() => {
    if (!unifiedMetaAdsData || unifiedMetaAdsData.length === 0) {
      return {
        totalClicks: 0,
        totalSessions: 0,
        totalConversions: 0,
        totalGa4Purchases: 0,
        totalGa4Revenue: 0,
        totalMetaRevenue: 0,
        totalSpend: 0,
        campaignCount: 0,
        cpc: 0,
        cps: 0,
        roas: 0,
      };
    }

    const totals = unifiedMetaAdsData.reduce((acc, item) => {
      acc.totalClicks += item.clicks || 0;
      acc.totalSessions += item.ga4_sessions || 0;
      acc.totalConversions += item.conversions || 0;
      acc.totalGa4Purchases += item.ga4_purchases || 0;
      acc.totalGa4Revenue += item.ga4_total_revenue || 0;
      acc.totalMetaRevenue += item.conversion_value || 0;
      acc.totalSpend += item.spend || 0;
      return acc;
    }, {
      totalClicks: 0,
      totalSessions: 0,
      totalConversions: 0,
      totalGa4Purchases: 0,
      totalGa4Revenue: 0,
      totalMetaRevenue: 0,
      totalSpend: 0,
    });

    const campaignIds = new Set(unifiedMetaAdsData.map(item => item.campaign_id));

    const cpc = totals.totalClicks > 0 ? totals.totalSpend / totals.totalClicks : 0;
    const cps = totals.totalSessions > 0 ? totals.totalSpend / totals.totalSessions : 0;
    const roas = totals.totalSpend > 0 ? totals.totalMetaRevenue / totals.totalSpend : 0;

    return {
      ...totals,
      campaignCount: campaignIds.size,
      cpc: cpc,
      cps: cps,
      roas: roas,
    };
  }, [unifiedMetaAdsData]);

  const criteoAdsSummary = useMemo(() => {
    const empty = { totalClicks: 0, totalSessions: 0, totalConversions: 0, totalGa4Revenue: 0, totalCriteoRevenue: 0, totalCost: 0, cpc: 0, cps: 0, roas: 0 };
    if (!unifiedCampaignData || unifiedCampaignData.length === 0) return empty;

    let criteoRows = unifiedCampaignData.filter(r => (r.channel || '').toLowerCase() === 'criteo');

    if (dateRange !== 'all' && criteoRows.length > 0) {
      const now = new Date();
      let rangeStart, rangeEnd;
      if (dateRange === 'yesterday') {
        rangeStart = new Date(now); rangeStart.setDate(now.getDate() - 1); rangeStart.setHours(0,0,0,0);
        rangeEnd = new Date(rangeStart); rangeEnd.setHours(23,59,59,999);
      } else if (dateRange === 'last7') {
        rangeStart = new Date(now); rangeStart.setDate(now.getDate() - 7); rangeStart.setHours(0,0,0,0);
        rangeEnd = now;
      } else if (dateRange === 'last30') {
        rangeStart = new Date(now); rangeStart.setDate(now.getDate() - 30); rangeStart.setHours(0,0,0,0);
        rangeEnd = now;
      } else if (dateRange === 'last90') {
        rangeStart = new Date(now); rangeStart.setDate(now.getDate() - 90); rangeStart.setHours(0,0,0,0);
        rangeEnd = now;
      } else if (dateRange === 'custom' && startDate && endDate) {
        rangeStart = new Date(startDate);
        rangeEnd = new Date(endDate);
      }
      if (rangeStart && rangeEnd) {
        const rStartMonth = new Date(rangeStart.getFullYear(), rangeStart.getMonth(), 1);
        const rEndMonth = new Date(rangeEnd.getFullYear(), rangeEnd.getMonth(), 1);
        criteoRows = criteoRows.filter(r => {
          const m = new Date(r.month);
          const mMonth = new Date(m.getFullYear(), m.getMonth(), 1);
          return mMonth >= rStartMonth && mMonth <= rEndMonth;
        });
      }
    }

    if (criteoRows.length === 0) return empty;

    const totals = criteoRows.reduce((acc, item) => {
      acc.totalClicks += Number(item.criteo_clicks || 0);
      acc.totalSessions += Number(item.ga4_sessions || 0);
      acc.totalConversions += Number(item.criteo_conversions || 0);
      acc.totalGa4Revenue += Number(item.ga4_total_revenue || 0);
      acc.totalCriteoRevenue += Number(item.criteo_conversion_value || 0);
      acc.totalCost += Number(item.criteo_cost || 0);
      return acc;
    }, { totalClicks: 0, totalSessions: 0, totalConversions: 0, totalGa4Revenue: 0, totalCriteoRevenue: 0, totalCost: 0 });
    const cpc = totals.totalClicks > 0 ? totals.totalCost / totals.totalClicks : 0;
    const cps = totals.totalSessions > 0 ? totals.totalCost / totals.totalSessions : 0;
    const roas = totals.totalCost > 0 ? totals.totalCriteoRevenue / totals.totalCost : 0;
    return { ...totals, cpc, cps, roas };
  }, [unifiedCampaignData, dateRange, startDate, endDate]);

  const monthlyPerformanceData = useMemo(() => {
    // Extract 'YYYY-MM' without UTC shifting and PRESERVE incoming order
    const getMonthKeyLocal = (dateValue) => {
      if (!dateValue) return '';
      if (typeof dateValue === 'string') {
        const s = dateValue.trim();
        const m = s.match(/^(\d{4})-(\d{2})/);
        if (m) return `${m[1]}-${m[2]}`;
        const d = new Date(s);
        if (isNaN(d)) return '';
        const y = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        return `${y}-${mm}`;
      }
      const d = new Date(dateValue);
      if (isNaN(d)) return '';
      const y = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      return `${y}-${mm}`;
    };
    // Format month label, shifting display by +1 month per backend convention
    const formatMonthLabelPlusOne = (monthKey) => {
      if (!monthKey || !/^\d{4}-\d{2}$/.test(monthKey)) return '';
      const [yy, mm] = monthKey.split('-').map(Number);
      const date = new Date(yy, (mm - 1) + 1, 1); // +1 month for display
      return date.toLocaleString('default', { month: 'long', year: 'numeric' });
    };

    const processPlatformData = (data, platformName) => {
        if (!Array.isArray(data) || data.length === 0) return null;

        const monthOrder = [];
        const monthlyTotals = data.reduce((acc, item) => {
            const month = getMonthKeyLocal(item.date);
            if (!month) return acc;
            if (!acc[month]) {
                acc[month] = { cost: 0, clicks: 0, conversions: 0, revenue: 0, ga4_sessions: 0, ga4_total_revenue: 0, ga4_purchases: 0 };
                monthOrder.push(month); // preserve first-seen order from incoming data
            }
            acc[month].cost += (item.cost || item.spend || 0);
            acc[month].clicks += item.clicks || 0;
            acc[month].conversions += item.conversions || 0;
            acc[month].revenue += item.conversion_value || 0;
            acc[month].ga4_sessions += item.ga4_sessions || 0;
            acc[month].ga4_total_revenue += item.ga4_total_revenue || 0;
            acc[month].ga4_purchases += item.ga4_purchases || 0;
            return acc;
        }, {});

        // Compute totals using exactly the incoming month order (no filtering)
        const orderFinal = monthOrder.slice();
        const platformTotals = orderFinal.reduce((acc, key) => {
            const m = monthlyTotals[key] || {};
            acc.cost += m.cost || 0;
            acc.clicks += m.clicks || 0;
            acc.conversions += m.conversions || 0;
            acc.revenue += m.revenue || 0;
            acc.ga4_sessions += m.ga4_sessions || 0;
            acc.ga4_total_revenue += m.ga4_total_revenue || 0;
            acc.ga4_purchases += m.ga4_purchases || 0;
            return acc;
        }, { cost: 0, clicks: 0, conversions: 0, revenue: 0, ga4_sessions: 0, ga4_total_revenue: 0, ga4_purchases: 0 });

        const monthsData = orderFinal.map((monthStr, index) => {
            const monthData = monthlyTotals[monthStr];
            const prevMonthStr = orderFinal[index + 1];
            const prevMonthData = prevMonthStr ? monthlyTotals[prevMonthStr] : null;

            const roas = monthData.cost > 0 ? monthData.revenue / monthData.cost : 0;
            let roasChange = null;
            if (prevMonthData) {
                const prevRoas = prevMonthData.cost > 0 ? prevMonthData.revenue / prevMonthData.cost : 0;
                if (prevRoas > 0) {
                    roasChange = ((roas - prevRoas) / prevRoas) * 100;
                }
            }

            // Compute display month key (shifted +1) for USD rate lookup
            const [rawY, rawM] = monthStr.split('-').map(Number);
            const shiftedDate = new Date(rawY, rawM, 1); // +1 month (rawM is already 0-based+1, so rawM = next month)
            const displayMonthKey = `${shiftedDate.getFullYear()}-${String(shiftedDate.getMonth() + 1).padStart(2, '0')}`;

            return {
                month: formatMonthLabelPlusOne(monthStr),
                displayMonthKey,
                cost: monthData.cost,
                clicks: monthData.clicks,
                conversions: monthData.conversions,
                revenue: monthData.revenue,
                ga4_sessions: monthData.ga4_sessions,
                ga4_total_revenue: monthData.ga4_total_revenue,
                ga4_purchases: monthData.ga4_purchases,
                cpc: monthData.clicks > 0 ? monthData.cost / monthData.clicks : 0,
                cps: monthData.ga4_sessions > 0 ? monthData.cost / monthData.ga4_sessions : 0,
                cpa: monthData.conversions > 0 ? monthData.cost / monthData.conversions : 0,
                cr: monthData.clicks > 0 ? (monthData.conversions / monthData.clicks) * 100 : 0,
                ga4_roas: monthData.cost > 0 ? monthData.ga4_total_revenue / monthData.cost : 0,
                roas: roas,
                roasChange: roasChange,
            };
        });

        return {
            totals: {
                ...platformTotals,
                cpc: platformTotals.clicks > 0 ? platformTotals.cost / platformTotals.clicks : 0,
                cps: platformTotals.ga4_sessions > 0 ? platformTotals.cost / platformTotals.ga4_sessions : 0,
                cpa: platformTotals.conversions > 0 ? platformTotals.cost / platformTotals.conversions : 0,
                cr: platformTotals.clicks > 0 ? (platformTotals.conversions / platformTotals.clicks) * 100 : 0,
                ga4_roas: platformTotals.cost > 0 ? platformTotals.ga4_total_revenue / platformTotals.cost : 0,
                roas: platformTotals.cost > 0 ? platformTotals.revenue / platformTotals.cost : 0,
            },
            months: monthsData,
        };
    };

    const googleData = processPlatformData(monthlyGoogleAdsData);
    const metaData = processPlatformData(monthlyMetaAdsData);

    if (!googleData && !metaData) return null;

    const overallTotal = {
        cost: (googleData?.totals.cost || 0) + (metaData?.totals.cost || 0),
        clicks: (googleData?.totals.clicks || 0) + (metaData?.totals.clicks || 0),
        conversions: (googleData?.totals.conversions || 0) + (metaData?.totals.conversions || 0),
        revenue: (googleData?.totals.revenue || 0) + (metaData?.totals.revenue || 0),
        ga4_sessions: (googleData?.totals.ga4_sessions || 0) + (metaData?.totals.ga4_sessions || 0),
        ga4_total_revenue: (googleData?.totals.ga4_total_revenue || 0) + (metaData?.totals.ga4_total_revenue || 0),
        ga4_purchases: (googleData?.totals.ga4_purchases || 0) + (metaData?.totals.ga4_purchases || 0),
    };
    
    overallTotal.cpc = overallTotal.clicks > 0 ? overallTotal.cost / overallTotal.clicks : 0;
    overallTotal.cps = overallTotal.ga4_sessions > 0 ? overallTotal.cost / overallTotal.ga4_sessions : 0;
    overallTotal.cpa = overallTotal.conversions > 0 ? overallTotal.cost / overallTotal.conversions : 0;
    overallTotal.cr = overallTotal.clicks > 0 ? (overallTotal.conversions / overallTotal.clicks) * 100 : 0;
    overallTotal.ga4_roas = overallTotal.cost > 0 ? overallTotal.ga4_total_revenue / overallTotal.cost : 0;
    overallTotal.roas = overallTotal.cost > 0 ? overallTotal.revenue / overallTotal.cost : 0;

    return {
        'Google Ads': googleData,
        'Meta Ads': metaData,
        'Total': overallTotal,
    };
  }, [monthlyGoogleAdsData, monthlyMetaAdsData]);

  const allCostsByMonth = useMemo(() => {
    if (!monthlyPerformanceData) return {};
    const costsByMonth = {};
    const googleMonths = monthlyPerformanceData['Google Ads']?.months || [];
    const metaMonths = monthlyPerformanceData['Meta Ads']?.months || [];
    const addPlatformMonths = (monthsArr) => {
      monthsArr.forEach((m) => {
        const key = m.month;
        const cost = Number(m.cost || 0);
        costsByMonth[key] = (costsByMonth[key] || 0) + cost;
      });
    };
    addPlatformMonths(googleMonths);
    addPlatformMonths(metaMonths);
    return costsByMonth;
  }, [monthlyPerformanceData]);

  const totalAllCosts = useMemo(() => {
    return Number(monthlyPerformanceData?.Total?.cost || 0);
  }, [monthlyPerformanceData]);

  // Monthly Platform → Category (Performance vs Branding) breakdown for the duplicated table
  const monthlyPlatformCategoryData = useMemo(() => {
    // Extract 'YYYY-MM' without UTC shifting and PRESERVE incoming order
    const getMonthKeyLocal = (dateValue) => {
      if (!dateValue) return '';
      if (typeof dateValue === 'string') {
        const s = dateValue.trim();
        const m = s.match(/^(\d{4})-(\d{2})/);
        if (m) return `${m[1]}-${m[2]}`;
        const d = new Date(s);
        if (isNaN(d)) return '';
        const y = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        return `${y}-${mm}`;
      }
      const d = new Date(dateValue);
      if (isNaN(d)) return '';
      const y = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      return `${y}-${mm}`;
    };
    // Format month label, shifting display by +1 month
    const formatMonthLabelPlusOne = (monthKey) => {
      if (!monthKey || !/^\d{4}-\d{2}$/.test(monthKey)) return '';
      const [yy, mm] = monthKey.split('-').map(Number);
      const date = new Date(yy, (mm - 1) + 1, 1);
      return date.toLocaleString('default', { month: 'long', year: 'numeric' });
    };
    const buildCategoryStruct = (rows) => {
      if (!Array.isArray(rows) || rows.length === 0) return null;
      const buckets = { Performance: {}, Branding: {} };
      const orderPerf = [];
      const orderBrand = [];
      const toCategory = (item) => {
        const name = (item.campaign_name || '').toString().toLowerCase();
        const objective = (item.campaign_objective || '').toString().toLowerCase();
        // Name-based patterns
        const perfNameHit = name.includes('performance') || name.includes('performans') || name.includes('perf');
        const brandNameHit = name.includes('branding') || name.includes('brand') || name.includes('awareness');
        if (perfNameHit) return 'Performance';
        if (brandNameHit) return 'Branding';
        // Objective-based fallback (Meta often has objectives)
        const perfObjHit = ['sales','conversion','conversions','leads','traffic','purchase'].some(k => objective.includes(k));
        const brandObjHit = ['awareness','reach','brand'].some(k => objective.includes(k));
        if (perfObjHit) return 'Performance';
        if (brandObjHit) return 'Branding';
        return null;
      };

      for (const item of rows) {
        const cat = toCategory(item);
        if (!cat) continue;
        const monthKey = getMonthKeyLocal(item.date);
        const bucket = buckets[cat];
        if (!bucket[monthKey]) {
          bucket[monthKey] = { cost: 0, clicks: 0, conversions: 0, revenue: 0, ga4_sessions: 0, ga4_total_revenue: 0, ga4_purchases: 0 };
          if (cat === 'Performance') orderPerf.push(monthKey);
          else orderBrand.push(monthKey);
        }
        const m = bucket[monthKey];
        m.cost += (item.cost || item.spend || 0);
        m.clicks += item.clicks || 0;
        m.conversions += item.conversions || 0;
        m.revenue += item.conversion_value || 0;
        m.ga4_sessions += item.ga4_sessions || 0;
        m.ga4_total_revenue += item.ga4_total_revenue || 0;
        m.ga4_purchases += item.ga4_purchases || 0;
      }

      const buildStruct = (bucket) => {
        // Preserve original month order seen in rows
        const months = bucket === buckets.Performance ? orderPerf : orderBrand;
        const totals = { cost: 0, clicks: 0, conversions: 0, revenue: 0, ga4_sessions: 0, ga4_total_revenue: 0, ga4_purchases: 0 };
        const rowsOut = months.map((monthStr, idx) => {
          const v = bucket[monthStr];
          totals.cost += v.cost;
          totals.clicks += v.clicks;
          totals.conversions += v.conversions;
          totals.revenue += v.revenue;
          totals.ga4_sessions += v.ga4_sessions;
          totals.ga4_total_revenue += v.ga4_total_revenue;
          totals.ga4_purchases += v.ga4_purchases;

          const prevMonthStr = months[idx + 1];
          const prev = prevMonthStr ? bucket[prevMonthStr] : null;
          const roas = v.cost > 0 ? v.revenue / v.cost : 0;
          let roasChange = null;
          if (prev) {
            const prevRoas = prev.cost > 0 ? prev.revenue / prev.cost : 0;
            if (prevRoas > 0) roasChange = ((roas - prevRoas) / prevRoas) * 100;
          }

          // Compute display month key (shifted +1) for USD rate lookup
          const [rawY2, rawM2] = monthStr.split('-').map(Number);
          const shiftedDate2 = new Date(rawY2, rawM2, 1);
          const displayMonthKey = `${shiftedDate2.getFullYear()}-${String(shiftedDate2.getMonth() + 1).padStart(2, '0')}`;

          return {
            month: formatMonthLabelPlusOne(monthStr),
            displayMonthKey,
            cost: v.cost,
            clicks: v.clicks,
            conversions: v.conversions,
            revenue: v.revenue,
            ga4_sessions: v.ga4_sessions,
            ga4_total_revenue: v.ga4_total_revenue,
            ga4_purchases: v.ga4_purchases,
            cpc: v.clicks > 0 ? v.cost / v.clicks : 0,
            cps: v.ga4_sessions > 0 ? v.cost / v.ga4_sessions : 0,
            cpa: v.conversions > 0 ? v.cost / v.conversions : 0,
            cr: v.clicks > 0 ? (v.conversions / v.clicks) * 100 : 0,
            ga4_roas: v.cost > 0 ? v.ga4_total_revenue / v.cost : 0,
            roas,
            roasChange
          };
        });

        const totalsEnriched = {
          ...totals,
          cpc: totals.clicks > 0 ? totals.cost / totals.clicks : 0,
          cps: totals.ga4_sessions > 0 ? totals.cost / totals.ga4_sessions : 0,
          cpa: totals.conversions > 0 ? totals.cost / totals.conversions : 0,
          cr: totals.clicks > 0 ? (totals.conversions / totals.clicks) * 100 : 0,
          ga4_roas: totals.cost > 0 ? totals.ga4_total_revenue / totals.cost : 0,
          roas: totals.cost > 0 ? totals.revenue / totals.cost : 0,
        };
        return { totals: totalsEnriched, months: rowsOut };
      };

      const perf = buildStruct(buckets.Performance);
      const brand = buildStruct(buckets.Branding);
      const total = {
        cost: (perf?.totals.cost || 0) + (brand?.totals.cost || 0),
        clicks: (perf?.totals.clicks || 0) + (brand?.totals.clicks || 0),
        conversions: (perf?.totals.conversions || 0) + (brand?.totals.conversions || 0),
        revenue: (perf?.totals.revenue || 0) + (brand?.totals.revenue || 0),
        ga4_sessions: (perf?.totals.ga4_sessions || 0) + (brand?.totals.ga4_sessions || 0),
        ga4_total_revenue: (perf?.totals.ga4_total_revenue || 0) + (brand?.totals.ga4_total_revenue || 0),
        ga4_purchases: (perf?.totals.ga4_purchases || 0) + (brand?.totals.ga4_purchases || 0),
      };
      total.cpc = total.clicks > 0 ? total.cost / total.clicks : 0;
      total.cps = total.ga4_sessions > 0 ? total.cost / total.ga4_sessions : 0;
      total.cpa = total.conversions > 0 ? total.cost / total.conversions : 0;
      total.cr = total.clicks > 0 ? (total.conversions / total.clicks) * 100 : 0;
      total.ga4_roas = total.cost > 0 ? total.ga4_total_revenue / total.cost : 0;
      total.roas = total.cost > 0 ? total.revenue / total.cost : 0;

      return { Performance: perf, Branding: brand, Total: total };
    };

    const googleStruct = buildCategoryStruct(monthlyGoogleAdsData || []);
    const metaStruct = buildCategoryStruct(monthlyMetaAdsData || []);
    if (!googleStruct && !metaStruct) return null;

    const overall = {
      cost: (googleStruct?.Total.cost || 0) + (metaStruct?.Total.cost || 0),
      clicks: (googleStruct?.Total.clicks || 0) + (metaStruct?.Total.clicks || 0),
      conversions: (googleStruct?.Total.conversions || 0) + (metaStruct?.Total.conversions || 0),
      revenue: (googleStruct?.Total.revenue || 0) + (metaStruct?.Total.revenue || 0),
      ga4_sessions: (googleStruct?.Total.ga4_sessions || 0) + (metaStruct?.Total.ga4_sessions || 0),
      ga4_total_revenue: (googleStruct?.Total.ga4_total_revenue || 0) + (metaStruct?.Total.ga4_total_revenue || 0),
      ga4_purchases: (googleStruct?.Total.ga4_purchases || 0) + (metaStruct?.Total.ga4_purchases || 0),
    };
    overall.cpc = overall.clicks > 0 ? overall.cost / overall.clicks : 0;
    overall.cps = overall.ga4_sessions > 0 ? overall.cost / overall.ga4_sessions : 0;
    overall.cpa = overall.conversions > 0 ? overall.cost / overall.conversions : 0;
    overall.cr = overall.clicks > 0 ? (overall.conversions / overall.clicks) * 100 : 0;
    overall.ga4_roas = overall.cost > 0 ? overall.ga4_total_revenue / overall.cost : 0;
    overall.roas = overall.cost > 0 ? overall.revenue / overall.cost : 0;

    return {
      'Google Ads': googleStruct,
      'Meta Ads': metaStruct,
      'Total': overall,
    };
  }, [monthlyGoogleAdsData, monthlyMetaAdsData]);

  const channelMonthlyRevenue = useMemo(() => {
    if (!unifiedCampaignData) return null;

    const channels = [...new Set(unifiedCampaignData.map(item => item.channel || 'Unknown'))];
    const initialChannelData = channels.reduce((acc, channel) => {
      acc[channel] = { revenue: 0, sessions: 0, transactions: 0, cost: 0 };
      return acc;
    }, {});

    const pivotData = unifiedCampaignData.reduce((acc, item) => {
      const dateOrMonth = item.month || item.date;
      const month = new Date(dateOrMonth).toLocaleString('default', { month: 'long', year: 'numeric' });
      const channel = item.channel || 'Unknown';
      const revenue = Number(item.ga4_total_revenue || 0);
      const sessions = Number(item.ga4_sessions || 0);
      const transactions = Number(item.ga4_purchases || 0);
      const googleCost = Number(item.google_cost || 0);
      const metaCost = Number(item.meta_cost || 0);
      const criteoCost = Number(item.criteo_cost || 0);
      const totalCost = googleCost + metaCost + criteoCost;

      if (!acc[month]) {
        acc[month] = { 
          ...JSON.parse(JSON.stringify(initialChannelData)), 
          Total: { revenue: 0, sessions: 0, transactions: 0, cost: 0 }
        };
      }
      
      if (acc[month][channel]) {
        acc[month][channel].revenue += revenue;
        acc[month][channel].sessions += sessions;
        acc[month][channel].transactions += transactions;
      }
      
      if (channel === 'Google Ads') acc[month][channel].cost += googleCost;
      if (channel === 'Meta Ads') acc[month][channel].cost += metaCost;
      if (channel === 'Criteo') acc[month][channel].cost += criteoCost;

      acc[month].Total.revenue += revenue;
      acc[month].Total.sessions += sessions;
      acc[month].Total.transactions += transactions;
      acc[month].Total.cost += totalCost;

      return acc;
    }, {});
    
    const sortedMonths = Object.keys(pivotData).sort((a, b) => new Date(b) - new Date(a));

    const tableData = sortedMonths.map(month => ({
      month,
      ...pivotData[month]
    }));

    const initialTotals = { Total: { revenue: 0, sessions: 0, transactions: 0, cost: 0 }};
    channels.forEach(ch => initialTotals[ch] = { revenue: 0, sessions: 0, transactions: 0, cost: 0 });

    const totals = tableData.reduce((acc, row) => {
        channels.forEach(channel => {
            acc[channel].revenue += row[channel].revenue;
            acc[channel].sessions += row[channel].sessions;
            acc[channel].transactions += row[channel].transactions;
            acc[channel].cost += row[channel].cost;
        });
        acc.Total.revenue += row.Total.revenue;
        acc.Total.sessions += row.Total.sessions;
        acc.Total.transactions += row.Total.transactions;
        acc.Total.cost += row.Total.cost;
        return acc;
    }, initialTotals);

    return {
      headers: ['Month', ...channels, 'Total'],
      rows: tableData,
      totals: totals
    }

  }, [unifiedCampaignData]);

  const gaMonthlySummary = useMemo(() => {
    if (!Array.isArray(gaMonthlySummaryCompact)) return null;
    const rows = [...gaMonthlySummaryCompact];
    // most recent first by date
    rows.sort((a, b) => new Date(b.month) - new Date(a.month));
    const monthlyData = rows.map(r => {
      const conversionRate = (Number(r.sessions || 0) > 0)
        ? (Number(r.transactions || 0) / Number(r.sessions || 0)) * 100
        : 0;
      const d = new Date(r.month);
      const displayMonthKey = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      return {
        month: d.toLocaleString('default', { month: 'long', year: 'numeric' }),
        displayMonthKey,
        sessions: Number(r.sessions || 0),
        users: Number(r.users || 0),
        totalRevenue: Number(r.revenue || 0),
        eventCount: Number(r.transactions || 0),
        conversionRate
      };
    });
    const totals = monthlyData.reduce((acc, m) => {
      acc.sessions += m.sessions;
      acc.users += m.users;
      acc.eventCount += m.eventCount;
      acc.totalRevenue += m.totalRevenue;
      return acc;
    }, { sessions: 0, users: 0, eventCount: 0, totalRevenue: 0 });
    totals.conversionRate = totals.sessions > 0 ? (totals.eventCount / totals.sessions) * 100 : 0;
    return { monthlyData, totals };
  }, [gaMonthlySummaryCompact]);

  // Weekly revenue by weekday (Mon..Sun) pivot using GA4 detailed data
  const weeklyRevenueByWeekday = useMemo(() => {
    if (!Array.isArray(gaDailySummaryCompact)) return null;
    const pivotMap = new Map(); // key: week_start -> { isoWeek, rev[], sess[], trans[], dates[] }
    for (const r of gaDailySummaryCompact) {
      const weekKey = r.week_start || r.date;
      if (!pivotMap.has(weekKey)) {
        pivotMap.set(weekKey, {
          isoWeek: Number(r.iso_week || 0),
          rev: Array(7).fill(0),
          sess: Array(7).fill(0),
          trans: Array(7).fill(0),
          dates: Array(7).fill(null),
        });
      }
      const agg = pivotMap.get(weekKey);
      const idx = Math.max(0, Math.min(6, (Number(r.iso_dow || 1) - 1))); // 0..6
      agg.rev[idx] += Number(r.revenue || 0);
      agg.sess[idx] += Number(r.sessions || 0);
      agg.trans[idx] += Number(r.transactions || 0);
      agg.dates[idx] = r.date;
    }
    // Sort by week_start desc and limit to last 10
    const rows = Array.from(pivotMap.entries())
      .sort((a, b) => new Date(b[0]) - new Date(a[0]))
      .slice(0, 10)
      .map(([weekStart, agg]) => {
        let days = [];
        let total = 0;
        if (weeklyMetric === 'revenue') {
          days = agg.rev;
          total = agg.rev.reduce((s, v) => s + (Number(v) || 0), 0);
        } else if (weeklyMetric === 'sessions') {
          days = agg.sess;
          total = agg.sess.reduce((s, v) => s + (Number(v) || 0), 0);
        } else if (weeklyMetric === 'transactions') {
          days = agg.trans;
          total = agg.trans.reduce((s, v) => s + (Number(v) || 0), 0);
        } else {
          days = agg.sess.map((sVal, idx) => sVal > 0 ? (agg.trans[idx] / sVal) * 100 : 0);
          const totalSess = agg.sess.reduce((s, v) => s + (Number(v) || 0), 0);
          const totalTrans = agg.trans.reduce((s, v) => s + (Number(v) || 0), 0);
          total = totalSess > 0 ? (totalTrans / totalSess) * 100 : 0;
        }
        return {
          weekKey: `W${String(agg.isoWeek || '')}`,
          days,
          dates: agg.dates,
          total
        };
      });
    return rows;
  }, [gaDailySummaryCompact, weeklyMetric]);

  // Table B: Week-over-Week summary totals and deltas
  const weeklyWoWSummary = useMemo(() => {
    if (!Array.isArray(gaWeeklySummaryCompact)) return null;
    // most recent first
    const arr = [...gaWeeklySummaryCompact].sort((a, b) => new Date(b.week) - new Date(a.week));
    const rows = arr.map((r, idx, a) => {
      const revenue = Number(r.revenue || 0);
      const sessions = Number(r.sessions || 0);
      const transactions = Number(r.transactions || 0);
      const cr = sessions > 0 ? (transactions / sessions) * 100 : 0;
      const prev = a[idx + 1];
      const pct = (cur, prevVal) => {
        if (!prevVal || prevVal === 0) return 0;
        return ((cur - prevVal) / prevVal) * 100;
      };
      const deltas = prev ? {
        rev: pct(revenue, Number(prev.revenue || 0)),
        trans: pct(transactions, Number(prev.transactions || 0)),
        sess: pct(sessions, Number(prev.sessions || 0)),
        cr: pct(cr, (Number(prev.sessions || 0) > 0 ? (Number(prev.transactions || 0) / Number(prev.sessions || 0)) * 100 : 0))
      } : { rev: 0, trans: 0, sess: 0, cr: 0 };
      // ISO week label from date (W01..W53)
      const dateObj = new Date(r.week);
      const getISOWeek = (d) => {
        const dt = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        const dayNum = dt.getUTCDay() || 7;
        dt.setUTCDate(dt.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(dt.getUTCFullYear(), 0, 1));
        return Math.ceil((((dt - yearStart) / 86400000) + 1) / 7);
      };
      const weekKey = `W${String(getISOWeek(dateObj)).padStart(2, '0')}`;
      return { weekKey, revenue, sessions, transactions, cr, deltas };
    });
    return rows.slice(0, 10);
  }, [gaWeeklySummaryCompact]);

  const togglePlatform = (platform) => {
    setExpandedPlatforms(prev => 
      prev.includes(platform) ? prev.filter(p => p !== platform) : [...prev, platform]
    );
  };

  const togglePlatform2 = (platform) => {
    setExpandedPlatforms2(prev => prev.includes(platform) ? prev.filter(p => p !== platform) : [...prev, platform]);
  };

  const toggleCategory2 = (catKey) => {
    setExpandedCategories2(prev => ({ ...prev, [catKey]: !prev[catKey] }));
  };

  const formatStat = (num) => {
    if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
    if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
    return num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };

  // Compact number formatter (tr-TR): 4,2K · 49K · 363,7K · 13,7M
  const formatNumberCompact = (num) => {
    const n = Number(num || 0);
    if (n >= 1000000) {
      return `${(n / 1000000).toLocaleString('tr-TR', { maximumFractionDigits: 1, minimumFractionDigits: 0 })}M`;
    }
    if (n >= 100000) {
      return `${(n / 1000).toLocaleString('tr-TR', { maximumFractionDigits: 1, minimumFractionDigits: 0 })}K`;
    }
    if (n >= 10000) {
      return `${Math.round(n / 1000).toLocaleString('tr-TR')}K`;
    }
    if (n >= 1000) {
      return `${(n / 1000).toLocaleString('tr-TR', { maximumFractionDigits: 1, minimumFractionDigits: 1 })}K`;
    }
    return Math.round(n).toLocaleString('tr-TR');
  };

  // Compact currency formatter using above rules
  const formatCurrencyCompact = (num) => {
    const n = Number(num || 0);
    if (n >= 1000000) return `₺${(n / 1000000).toLocaleString('tr-TR', { maximumFractionDigits: 1, minimumFractionDigits: 0 })}M`;
    if (n >= 100000) return `₺${(n / 1000).toLocaleString('tr-TR', { maximumFractionDigits: 1, minimumFractionDigits: 0 })}K`;
    if (n >= 10000) return `₺${Math.round(n / 1000).toLocaleString('tr-TR')}K`;
    if (n >= 1000) return `₺${(n / 1000).toLocaleString('tr-TR', { maximumFractionDigits: 1, minimumFractionDigits: 1 })}K`;
    return `₺${Math.round(n).toLocaleString('tr-TR')}`;
  };

  // Currency per-unit (CPC/CPA/CPS) formatter: no decimals, no K/M
  const formatCurrencyUnit = (num) => {
    const n = Number(num || 0);
    return `₺${n.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  // Currency per-unit with two decimals (for CPC/CPS)
  const formatCurrencyUnitTwo = (num) => {
    const n = Number(num || 0);
    return `₺${n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const productViewsValue = funnelData.steps.find(step => step.name === 'Product Views')?.value || 0;
  const addToCartValue = funnelData.steps.find(step => step.name === 'Add to Cart')?.value || 0;
  const checkoutValue = funnelData.steps.find(step => step.name === 'Checkout')?.value || 0;
  const purchaseValue = funnelData.steps.find(step => step.name === 'Purchase')?.value || 0;

  const conversionRate = productViewsValue > 0 ? (purchaseValue / productViewsValue) * 100 : 0;
  const addToCartRate = productViewsValue > 0 ? (addToCartValue / productViewsValue) * 100 : 0;
  const checkoutRate = addToCartValue > 0 ? (checkoutValue / addToCartValue) * 100 : 0;
  const checkoutToPurchaseRate = checkoutValue > 0 ? (purchaseValue / checkoutValue) * 100 : 0;

  const fetchEcommerceData = async () => {
    setIsLoadingEcommerce({ products: true, categories: true, daily: true });
    const brandId = localStorage.getItem('currentBrandId');
    if (!brandId) {
      setIsLoadingEcommerce({ products: false, categories: false, daily: false });
      return;
    }
    if (brandId === DEMO_BRAND_ID) {
      try {
        const demoTop = [
          { itemName: 'Klasik Deri Sneaker - Beyaz', itemBrand: 'Premium Collection', totalRevenue: 285000, totalItemsPurchased: 152 },
          { itemName: 'Koşu Ayakkabısı Pro Max', itemBrand: 'Sport Line', totalRevenue: 248000, totalItemsPurchased: 98 },
          { itemName: 'Yürüyüş Botu Outdoor', itemBrand: 'Adventure Gear', totalRevenue: 195000, totalItemsPurchased: 65 },
          { itemName: 'Platform Sneaker Kadın', itemBrand: 'Trend Fashion', totalRevenue: 178000, totalItemsPurchased: 89 },
          { itemName: 'Deri Bot Kışlık Siyah', itemBrand: 'Winter Collection', totalRevenue: 156000, totalItemsPurchased: 52 },
          { itemName: 'Basketbol Ayakkabısı High Top', itemBrand: 'Sport Line', totalRevenue: 142000, totalItemsPurchased: 48 },
          { itemName: 'Casual Oxford Erkek', itemBrand: 'Classic Wear', totalRevenue: 128000, totalItemsPurchased: 82 },
          { itemName: 'Kadın Spor Ayakkabı Pembe', itemBrand: 'Active Style', totalRevenue: 115000, totalItemsPurchased: 64 },
          { itemName: 'Trekking Ayakkabısı Pro', itemBrand: 'Adventure Gear', totalRevenue: 98000, totalItemsPurchased: 32 },
          { itemName: 'Slip-On Loafer Kahverengi', itemBrand: 'Comfort Plus', totalRevenue: 85000, totalItemsPurchased: 68 },
        ];
        const demoCats = [
          { itemCategory: 'Ayakkabı > Sneaker > Günlük', totalRevenue: 485000 },
          { itemCategory: 'Ayakkabı > Spor > Koşu', totalRevenue: 362000 },
          { itemCategory: 'Ayakkabı > Bot > Outdoor', totalRevenue: 298000 },
          { itemCategory: 'Ayakkabı > Kadın > Platform', totalRevenue: 245000 },
          { itemCategory: 'Ayakkabı > Klasik > Oxford', totalRevenue: 178000 },
          { itemCategory: 'Ayakkabı > Çocuk > Okul', totalRevenue: 125000 },
        ];
        // Generate daily data for last 30 days
        const today = new Date();
        const dailyData = [];
        for (let i = 29; i >= 0; i--) {
          const date = new Date(today);
          date.setDate(date.getDate() - i);
          const variance = 0.7 + Math.random() * 0.6;
          dailyData.push({
            date: date.toISOString().split('T')[0],
            revenue: Math.round(52000 * variance),
            transactions: Math.round(28 * variance),
            sessions: Math.round(4500 * variance),
            users: Math.round(3200 * variance),
          });
        }
        const totals = {
          revenue: dailyData.reduce((s, d) => s + d.revenue, 0),
          transactions: dailyData.reduce((s, d) => s + d.transactions, 0),
          sessions: dailyData.reduce((s, d) => s + d.sessions, 0),
          users: dailyData.reduce((s, d) => s + d.users, 0),
        };
        const demoDaily = { data: dailyData, totals, changes: { revenue: 12.5, transactions: 8.3, sessions: 15.2, users: 11.8 } };
        setTopProducts(demoTop);
        setCategoryPerformance(demoCats);
        setDailyProductData(demoDaily);
      } finally {
        setIsLoadingEcommerce({ products: false, categories: false, daily: false });
      }
      return;
    }

    try {
      let topProductsUrl = `https://api.glowytics.com/api/google-ads/top10-daily-performance?dateRange=${dateRange}`;
      let categoryUrl = `https://api.glowytics.com/api/google-ads/monthly-category-summary?dateRange=${dateRange}`;
      let dailyPerformanceUrl = `https://api.glowytics.com/api/google-ads/daily-product-performance?dateRange=${dateRange}`;
      if (dateRange === 'custom' && startDate && endDate) {
        const startStr = formatDateForAPI(startDate);
        const endStr = formatDateForAPI(endDate);
        topProductsUrl = `https://api.glowytics.com/api/google-ads/top10-daily-performance?dateRange=custom&startDate=${startStr}&endDate=${endStr}`;
        categoryUrl = `https://api.glowytics.com/api/google-ads/monthly-category-summary?dateRange=custom&startDate=${startStr}&endDate=${endStr}`;
        dailyPerformanceUrl = `https://api.glowytics.com/api/google-ads/daily-product-performance?dateRange=custom&startDate=${startStr}&endDate=${endStr}`;
      }

      // Top 10 Products
      const topProductsPromise = fetch(topProductsUrl, {
        headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
        credentials: 'include',
      }).then(res => res.ok ? res.json() : []);
      
      // Category Performance
      const categoryPromise = fetch(categoryUrl, {
        headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
        credentials: 'include',
      }).then(res => res.ok ? res.json() : { data: [], totals: {} });

      // Daily Product Performance for chart and KPIs
      const dailyPerformancePromise = fetch(dailyPerformanceUrl, {
        headers: { 'Content-Type': 'application/json', 'X-Brand-ID': brandId },
        credentials: 'include',
      }).then(res => res.ok ? res.json() : { data: [], totals: {}, changes: {} });


      const [topProductsData, categoryData, dailyData] = await Promise.all([topProductsPromise, categoryPromise, dailyPerformancePromise]);
      
      setTopProducts(topProductsData);
      setCategoryPerformance(categoryData.data || []);
      setDailyProductData(dailyData);

      setIsLoadingEcommerce({ products: false, categories: false, daily: false });

    } catch (error) {
      console.error("Error fetching e-commerce data:", error);
      setIsLoadingEcommerce({ products: false, categories: false, daily: false });
    }
  };

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#f5f5f7]" id="main-content">
      {/* Header Section */}
      <div className="flex flex-col gap-6 mb-8">
        {/* Üst Kısım */}
        <div className="flex flex-col space-y-4 lg:flex-row lg:items-center lg:justify-between lg:space-y-0">
          <div>
            <h1 className="text-xl md:text-2xl font-bold text-gray-800">{getGreeting()} {user?.name || 'User'} 👋</h1>
            
          </div>
          {/* Desktop View - Compact Dropdown */}
          <div className="hidden lg:flex flex-row items-center gap-3 relative">
            {/* Selected Date Span */}
            <div className="text-xs text-gray-500 px-2 py-1">
              {getSelectedRangeDatesLabel()}
            </div>

            {/* Date Range Dropdown */}
            <Menu as="div" className="relative">
              <Menu.Button className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors">
                <Calendar className="w-4 h-4" />
                <span>
                  {dateRange === 'custom' && startDate && endDate ? (
                    `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
                  ) : (
                    dateFilters.find(f => f.value === dateRange)?.label || 'Select Range'
                  )}
                </span>
                <ChevronDown className="w-4 h-4" />
              </Menu.Button>
              <Menu.Items className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-gray-200 z-50 py-1">
                {dateFilters.map((filter) => (
                  <Menu.Item key={filter.value}>
                    {({ active }) => (
                      <button
                        onClick={() => {
                          console.log('🎯 DATE RANGE BUTTON CLICKED:', filter.value);
                          setDateRange(filter.value);
                          setIsCustomDateOpen(false);
                        }}
                        className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                          active ? 'bg-blue-50 text-blue-600' : 'text-gray-700'
                        } ${dateRange === filter.value ? 'bg-blue-50 text-blue-600 font-medium' : ''}`}
                      >
                        {filter.label}
                      </button>
                    )}
                  </Menu.Item>
                ))}
                <div className="border-t border-gray-100 my-1"></div>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={() => {
                        setIsCustomDateOpen(!isCustomDateOpen);
                        setDateRange('custom');
                      }}
                      className={`w-full text-left px-4 py-2 text-sm transition-colors flex items-center gap-2 ${
                        active ? 'bg-blue-50 text-blue-600' : 'text-gray-700'
                      } ${dateRange === 'custom' ? 'bg-blue-50 text-blue-600 font-medium' : ''}`}
                    >
                      <Calendar className="w-4 h-4" />
                      Custom Range
                    </button>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Menu>


            {/* Custom Date Picker */}
            {isCustomDateOpen && dateRange === 'custom' && (
              <div className="absolute right-0 top-full mt-2 z-50">
                <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-4">
                  <DatePicker
                    selected={startDate}
                    onChange={handleCustomDateChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    inline
                    calendarClassName="bg-white"
                    monthClassName="text-gray-800"
                    dayClassName={date =>
                      date >= startDate && date <= endDate
                        ? "bg-blue-50 text-blue-600"
                        : undefined
                    }
                  />
                </div>
              </div>
            )}
            {/* Notification Bell */}
            <div className="relative">
              <button 
                onClick={() => setIsNotificationOpen(!isNotificationOpen)}
                className="flex items-center justify-center w-10 h-10 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors"
              >
                <Bell className="w-5 h-5 text-gray-600" />
                {unreadCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
                    <span className="text-xs text-white font-bold">
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  </span>
                )}
              </button>
            </div>

            {/* Brand Logo */}
            <div className="ml-2">
              <BrandLogo />
            </div>
          </div>

          {/* Mobile View - Compact Dropdown */}
          <div className="lg:hidden">
            <div className="relative">
              <select 
                value={dateRange}
                onChange={(e) => {
                  setDateRange(e.target.value);
                }}
                className="w-full px-4 py-2.5 text-sm font-medium bg-white border border-gray-200 rounded-xl text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none pr-10"
              >
                {dateFilters.map((filter) => (
                  <option key={filter.value} value={filter.value}>
                    {filter.label}
                  </option>
                ))}
                <option value="custom">Custom Range</option>
              </select>
              <ChevronDown className="absolute right-3 top-3 h-4 w-4 text-gray-400 pointer-events-none" />
            </div>
            
            {/* Custom Date Picker for Mobile */}
            {dateRange === 'custom' && (
              <div className="mt-3">
                <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-4">
                  <DatePicker
                    selected={startDate}
                    onChange={handleCustomDateChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    inline
                    calendarClassName="bg-white"
                    monthClassName="text-gray-800"
                    dayClassName={date =>
                      date >= startDate && date <= endDate
                        ? "bg-blue-50 text-blue-600"
                        : undefined
                    }
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Tarih Filtresi - Bu bölümü kaldırıyorum */}
      </div>

      {/* Today's Tips Banner - temporarily removed */}
      {/* Platform Performans Kartları - Yeni ve Daha Efektif Tasarım */}
      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ${(hasIkasConnected || hasShopifyConnected || hasWooConnected || hasAdjustConnected) ? 'xl:grid-cols-4' : 'xl:grid-cols-3'} gap-4 mb-6 items-stretch`}>
        {/* Card: Ads Summary (Google + Meta in one) */}
        <Card className="rounded-2xl overflow-hidden p-3 min-w-0 lg:col-span-2 xl:col-span-2 bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
          <div className="flex justify-between items-center mb-2">
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-1">
              <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5" />
              <img src="/6033716.png" alt="Meta Ads" className="w-5 h-5" />
              <img src="/CRcriteopng.png" alt="Criteo" className="w-5 h-5 object-contain" />
              </div>
              <h2 className="font-medium text-gray-800 text-sm">Ads Summary</h2>
            </div>
            <div className="text-xs text-gray-500">{getDateRangeDisplayText(dateRange)}</div>
          </div>
          <div className="bg-blue-50/40 rounded-xl p-3 border border-blue-100">
            {(isLoadingUnifiedGoogleAds || isLoadingUnifiedMetaAds) ? (
              <div className="flex justify-center items-center h-[150px]">
                <div className="loading-logo-container">
                  <img src="/logoicon.png" alt="Glowytics Logo" className="loading-logo" />
                </div>
              </div>
            ) : (
              <>
                {(() => {
                  const g = googleAdsSummary || {};
                  const m = metaAdsSummary || {};
                  const c = criteoAdsSummary || {};
                  const total = {
                    sessions: (g.totalSessions || 0) + (m.totalSessions || 0) + (c.totalSessions || 0),
                    clicks: (g.totalClicks || 0) + (m.totalClicks || 0) + (c.totalClicks || 0),
                    conversions: (g.totalConversions || 0) + (m.totalConversions || 0) + (c.totalConversions || 0),
                    ga4Rev: (g.totalGa4Revenue || 0) + (m.totalGa4Revenue || 0) + (c.totalGa4Revenue || 0),
                    revenue: (g.totalGoogleAdsRevenue || 0) + (m.totalMetaRevenue || 0) + (c.totalCriteoRevenue || 0),
                    cost: (g.totalCost || 0) + (m.totalSpend || 0) + (c.totalCost || 0),
                    cpc: 0,
                    cps: 0
                  };
                  const totalClicks = (g.totalClicks || 0) + (m.totalClicks || 0) + (c.totalClicks || 0);
                  const totalSessions = (g.totalSessions || 0) + (m.totalSessions || 0) + (c.totalSessions || 0);
                  total.cpc = totalClicks > 0
                    ? (((g.cpc || 0) * (g.totalClicks || 0)) + ((m.cpc || 0) * (m.totalClicks || 0)) + ((c.cpc || 0) * (c.totalClicks || 0))) / totalClicks
                    : 0;
                  total.cps = totalSessions > 0
                    ? (((g.cps || 0) * (g.totalSessions || 0)) + ((m.cps || 0) * (m.totalSessions || 0)) + ((c.cps || 0) * (c.totalSessions || 0))) / totalSessions
                    : 0;
                  return (
                    <div className="overflow-x-auto">
                      <table className="w-full text-xs">
                        <thead className="sticky top-0 z-10 bg-white">
                          <tr className="border-b border-blue-200">
                            <th className="text-left py-1 px-1 text-gray-600 font-medium w-32">Platform</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Sessions</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Clicks</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Cost</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Conv.</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">GA4 Revenue</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Revenue</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">CPC</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">CPS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-b border-gray-100">
                            <td className="py-1 px-1 text-gray-800 font-medium flex items-center gap-1">
                              <img src="/google_ads-512.webp" alt="Google" className="w-3.5 h-3.5" /> Google Ads
                            </td>
                            <td className="py-1 px-1 text-right text-gray-800">{(g.totalSessions || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-gray-800">{(g.totalClicks || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-red-600">₺{Math.round(g.totalCost || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-gray-800">{Math.round(g.totalConversions || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-green-600">₺{Math.round(g.totalGa4Revenue || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-orange-600">₺{Math.round(g.totalGoogleAdsRevenue || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-blue-600">₺{(g.cpc || 0).toFixed(2)}</td>
                            <td className="py-1 px-1 text-right text-purple-600">₺{(g.cps || 0).toFixed(2)}</td>
                          </tr>
                          <tr className="border-b border-gray-100">
                            <td className="py-1 px-1 text-gray-800 font-medium flex items-center gap-1">
                              <img src="/6033716.png" alt="Meta" className="w-3.5 h-3.5" /> Meta Ads
                            </td>
                            <td className="py-1 px-1 text-right text-gray-800">{(m.totalSessions || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-gray-800">{(m.totalClicks || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-red-600">₺{Math.round(m.totalSpend || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-gray-800">{Math.round(m.totalConversions || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-green-600">₺{Math.round(m.totalGa4Revenue || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-orange-600">₺{Math.round(m.totalMetaRevenue || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-blue-600">₺{(m.cpc || 0).toFixed(2)}</td>
                            <td className="py-1 px-1 text-right text-purple-600">₺{(m.cps || 0).toFixed(2)}</td>
                          </tr>
                          {(c.totalCost > 0 || c.totalSessions > 0) && (
                          <tr className="border-b border-gray-100">
                            <td className="py-1 px-1 text-gray-800 font-medium flex items-center gap-1">
                              <img src="/CRcriteopng.png" alt="Criteo" className="w-3.5 h-3.5 object-contain" /> Criteo
                            </td>
                            <td className="py-1 px-1 text-right text-gray-800">{(c.totalSessions || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-gray-800">{(c.totalClicks || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-red-600">₺{Math.round(c.totalCost || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-gray-800">{Math.round(c.totalConversions || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-green-600">₺{Math.round(c.totalGa4Revenue || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-orange-600">₺{Math.round(c.totalCriteoRevenue || 0).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-blue-600">₺{(c.cpc || 0).toFixed(2)}</td>
                            <td className="py-1 px-1 text-right text-purple-600">₺{(c.cps || 0).toFixed(2)}</td>
                          </tr>
                          )}
                          <tr>
                            <td className="py-1 px-1 text-gray-800 font-semibold">Total</td>
                            <td className="py-1 px-1 text-right text-gray-800 font-semibold">{total.sessions.toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-gray-800 font-semibold">{total.clicks.toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-red-700 font-semibold">₺{Math.round(total.cost).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-gray-800 font-semibold">{Math.round(total.conversions).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-green-700 font-semibold">₺{Math.round(total.ga4Rev).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-orange-700 font-semibold">₺{Math.round(total.revenue).toLocaleString()}</td>
                            <td className="py-1 px-1 text-right text-blue-700 font-semibold">₺{total.cpc.toFixed(2)}</td>
                            <td className="py-1 px-1 text-right text-purple-700 font-semibold">₺{total.cps.toFixed(2)}</td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                  );
                })()}
              </>
            )}
                    </div>
          {/* GA4 compact totals row (styled like summary cards) */}
          {(() => {
            const cur = (comparisonAggregates && comparisonAggregates.cur) ? comparisonAggregates.cur : { sessions: 0, eventCount: 0, totalRevenue: 0 };
            const cr = cur.sessions > 0 ? ((cur.eventCount / cur.sessions) * 100).toFixed(2) : '0.00';
            return (
              <div className="mt-2">
                <div className="bg-blue-50/40 rounded-xl p-1.5 border border-blue-100">
                  <div className="grid grid-cols-5 items-center gap-1">
                    {/* Top row: GA4 label + metric labels */}
                    <div className="flex items-center gap-1">
                      <img src="/GA4logoicon.svg" alt="GA4" className="w-3.5 h-3.5" />
                      <span className="text-[11px] font-medium text-gray-700">GA4</span>
                      </div>
                    <div className="text-[10px] text-gray-500 text-center">Sessions</div>
                    <div className="text-[10px] text-gray-500 text-center">Transactions</div>
                    <div className="text-[10px] text-gray-500 text-center">CR</div>
                    <div className="text-[10px] text-gray-500 text-center">Revenue</div>
                    {/* Bottom row: values aligned under labels */}
                    <div></div>
                    <div className="text-[11px] font-semibold text-gray-800 text-center">{Math.round(cur.sessions || 0).toLocaleString()}</div>
                    <div className="text-[11px] font-semibold text-gray-800 text-center">{Math.round(cur.eventCount || 0).toLocaleString()}</div>
                    <div className="text-[11px] font-semibold text-purple-700 text-center">{cr}%</div>
                    <div className="text-[11px] font-semibold text-green-600 text-center">₺{Math.round(cur.totalRevenue || 0).toLocaleString()}</div>
                    </div>
                  </div>
                  {/* Platform vs Device split */}
                  <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                    {/* Left: Platform daily aggregated within range */}
                    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                      <table className="w-full text-[11px]">
                        <thead className="bg-gray-50">
                          <tr className="text-gray-600">
                            <th className="text-left py-1.5 px-2 text-[9px] font-normal">Platform</th>
                            <th className="text-right py-1.5 px-2 text-[9px] font-normal">Sessions</th>
                            <th className="text-right py-1.5 px-2 text-[9px] font-normal">Transactions</th>
                            <th className="text-right py-1.5 px-2 text-[9px] font-normal">CR</th>
                            <th className="text-right py-1.5 px-2 text-[9px] font-normal">Revenue</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            const rows = Array.isArray(gaPlatformDaily) ? gaPlatformDaily : [];
                            // aggregate per platform within current result window
                            const agg = {};
                            rows.forEach(r => {
                              const key = (r.platform || 'unknown').toString();
                              if (!agg[key]) agg[key] = { sessions: 0, transactions: 0, revenue: 0 };
                              agg[key].sessions += Number(r.sessions || 0);
                              agg[key].transactions += Number(r.transactions || 0);
                              agg[key].revenue += Number(r.revenue || 0);
                            });
                            const pretty = (p) => {
                              const s = (p || '').toLowerCase();
                              if (s.includes('google')) return 'Google Ads';
                              if (s.includes('meta') || s.includes('facebook')) return 'Meta Ads';
                              if (s.includes('tiktok')) return 'TikTok Ads';
                              return p || 'Unknown';
                            };
                            const aggRows = Object.keys(agg).map(k => ({ platform: k, ...agg[k] }));
                            if (aggRows.length === 0) {
                              return (
                                <tr><td colSpan="5" className="py-2 px-2 text-center text-gray-500">No platform data</td></tr>
                              );
                            }
                            return aggRows
                              .sort((a, b) => b.revenue - a.revenue)
                              .map((r, i) => {
                                const cr = r.sessions > 0 ? ((r.transactions / r.sessions) * 100).toFixed(2) : '0.00';
                                return (
                                  <tr key={`${r.platform}-${i}`} className="border-t">
                                    <td className="py-1.5 px-2 text-gray-800">{pretty(r.platform)}</td>
                                    <td className="py-1.5 px-2 text-right text-gray-800">{formatNumberCompact(r.sessions)}</td>
                                    <td className="py-1.5 px-2 text-right text-gray-800">{Math.round(r.transactions).toLocaleString()}</td>
                                    <td className="py-1.5 px-2 text-right text-purple-700">{cr}%</td>
                                    <td className="py-1.5 px-2 text-right text-green-600">₺{Math.round(r.revenue).toLocaleString()}</td>
                                  </tr>
                                );
                              });
                          })()}
                        </tbody>
                      </table>
                    </div>
                    {/* Right: Device breakdown */}
                    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                      {isLoadingGaDevicePerf ? (
                        <div className="p-3 text-xs text-gray-500">Loading device breakdown...</div>
                      ) : (
                        <table className="w-full text-[11px]">
                          <thead className="bg-gray-50">
                            <tr className="text-gray-600">
                              <th className="text-left py-1.5 px-2 text-[9px] font-normal">Device</th>
                              <th className="text-right py-1.5 px-2 text-[9px] font-normal">Sessions</th>
                              <th className="text-right py-1.5 px-2 text-[9px] font-normal">Transactions</th>
                              <th className="text-right py-1.5 px-2 text-[9px] font-normal">CR</th>
                              <th className="text-right py-1.5 px-2 text-[9px] font-normal">Revenue</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(gaDevicePerf || []).map((row, idx) => {
                              const dev = (row.key || row.deviceCategory || '').toString();
                              const sess = Number(row.sessions || 0);
                              const trx = Number(row.transactions || 0);
                              const rev = Number(row.totalRevenue || 0);
                              const crd = sess > 0 ? ((trx / sess) * 100).toFixed(2) : '0.00';
                              return (
                                <tr key={`${dev}-${idx}`} className="border-t">
                                  <td className="py-1.5 px-2 text-gray-800 capitalize">{dev || 'Unknown'}</td>
                                  <td className="py-1.5 px-2 text-right text-gray-800">{formatNumberCompact(sess)}</td>
                                  <td className="py-1.5 px-2 text-right text-gray-800">{trx.toLocaleString()}</td>
                                  <td className="py-1.5 px-2 text-right text-purple-700">{crd}%</td>
                                  <td className="py-1.5 px-2 text-right text-green-600">₺{Math.round(rev).toLocaleString()}</td>
                                </tr>
                              );
                            })}
                            {(gaDevicePerf || []).length === 0 && (
                              <tr>
                                <td colSpan="5" className="py-2 px-2 text-center text-gray-500">No device data</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                      </div>
            );
          })()}
        </Card>
        
        {/* Card 3: Live Channels */}
        <Card className="rounded-2xl overflow-hidden p-3 min-w-0 h-full flex flex-col bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Activity className="w-4 h-4 text-blue-500" />
              <h2 className="font-medium text-gray-800 text-sm">Live Channels</h2>
            </div>
            <button
              onClick={fetchLiveTodaySummaries}
              disabled={loadingLive}
              className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
              title="Refresh"
            >
              {loadingLive ? <Loader2 className="w-3.5 h-3.5 animate-spin text-gray-400" /> : <RefreshCw className="w-3.5 h-3.5 text-gray-400" />}
            </button>
          </div>
          <div className="space-y-2.5 overflow-y-auto flex-1">
            {/* Google Ads */}
            <div className="p-2.5 rounded-xl bg-gray-50/80">
              <div className="flex items-center gap-2 mb-1.5">
                <img src="/google_ads-512.webp" alt="Google Ads" className="w-4 h-4" />
                <span className="text-[11px] font-semibold text-gray-700">Google Ads</span>
              </div>
              {liveGads ? (
                <div className="grid grid-cols-3 gap-2">
                  {(() => {
                    const cmps = Array.isArray(liveGads.campaigns) ? liveGads.campaigns : [];
                    const sum = (key) => cmps.reduce((s, c) => s + (Number(c[key] || 0)), 0);
                    const spend = Number(liveGads.cost || 0);
                    const convValue = Number((liveGads.revenue ?? liveGads.conversion_value) ?? sum('conversion_value'));
                    const roas = (typeof liveGads.roas === 'number' && isFinite(liveGads.roas)) ? liveGads.roas : (spend > 0 ? (convValue / spend) : 0);
                    return (
                      <>
                        <div>
                          <div className="text-[10px] text-gray-500">Spend</div>
                          <div className="text-xs font-bold text-red-600">₺{Math.round(spend).toLocaleString()}</div>
                        </div>
                        <div>
                          <div className="text-[10px] text-gray-500">Revenue</div>
                          <div className="text-xs font-bold text-green-700">{formatCurrencyCompact(convValue)}</div>
                        </div>
                        <div>
                          <div className="text-[10px] text-gray-500">ROAS</div>
                          <div className="text-xs font-bold text-purple-700">{roas > 0 ? `${roas.toFixed(2)}x` : '-'}</div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              ) : (
                <div className="text-[10px] text-gray-400">{loadingLive ? 'Loading…' : 'No data'}</div>
              )}
            </div>

            {/* Meta Ads */}
            <div className="p-2.5 rounded-xl bg-gray-50/80">
              <div className="flex items-center gap-2 mb-1.5">
                <img src="/6033716.png" alt="Meta Ads" className="w-4 h-4" />
                <span className="text-[11px] font-semibold text-gray-700">Meta Ads</span>
              </div>
              {liveMeta ? (
                <div className="grid grid-cols-3 gap-2">
                  {(() => {
                    const cmps = Array.isArray(liveMeta.campaigns) ? liveMeta.campaigns : [];
                    const sum = (key) => cmps.reduce((s, c) => s + (Number(c[key] || 0)), 0);
                    const spend = Number(liveMeta.cost || 0);
                    const convValue = sum('conversion_value');
                    return (
                      <>
                        <div>
                          <div className="text-[10px] text-gray-500">Spend</div>
                          <div className="text-xs font-bold text-red-600">₺{Math.round(spend).toLocaleString()}</div>
                        </div>
                        <div>
                          <div className="text-[10px] text-gray-500">Revenue</div>
                          <div className="text-xs font-bold text-green-700">{formatCurrencyCompact(convValue)}</div>
                        </div>
                        <div>
                          <div className="text-[10px] text-gray-500">ROAS</div>
                          <div className="text-xs font-bold text-purple-700">{spend > 0 ? `${(convValue / spend).toFixed(2)}x` : '-'}</div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              ) : (
                <div className="text-[10px] text-gray-400">{loadingLive ? 'Loading…' : 'No data'}</div>
              )}
            </div>

            {/* GA4 */}
            <div className="p-2.5 rounded-xl bg-gray-50/80">
              <div className="flex items-center gap-2 mb-1.5">
                <img src="/GA4logoicon.svg" alt="GA4" className="w-4 h-4" />
                <span className="text-[11px] font-semibold text-gray-700">GA4</span>
              </div>
              {liveGa4 ? (
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <div className="text-[10px] text-gray-500">Sessions</div>
                    <div className="text-xs font-bold text-gray-800">{Number(liveGa4.sessions || 0).toLocaleString()}</div>
                  </div>
                  <div>
                    <div className="text-[10px] text-gray-500">Revenue</div>
                    <div className="text-xs font-bold text-green-700">₺{Math.round(Number(liveGa4.revenue || 0)).toLocaleString()}</div>
                  </div>
                  <div>
                    <div className="text-[10px] text-gray-500">CR</div>
                    <div className="text-xs font-bold text-purple-700">
                      {Number(liveGa4.sessions || 0) > 0
                        ? `${((Number(liveGa4.purchases || 0) / Number(liveGa4.sessions || 0)) * 100).toFixed(2)}%`
                        : '-'}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-[10px] text-gray-400">{loadingLive ? 'Loading…' : 'No data'}</div>
              )}
            </div>

            {/* Ikas */}
            {hasIkasConnected && (
              <div className="p-2.5 rounded-xl bg-gray-50/80">
                <div className="flex items-center gap-2 mb-1.5">
                  <img src="/ikaslogoicon.png" alt="Ikas" className="w-4 h-4 rounded-md" />
                  <span className="text-[11px] font-semibold text-gray-700">Ikas</span>
                </div>
                {liveIkas ? (
                  <div className="grid grid-cols-3 gap-2">
                    <div>
                      <div className="text-[10px] text-gray-500">Revenue</div>
                      <div className="text-xs font-bold text-green-700">₺{Math.round(liveIkas.revenue).toLocaleString()}</div>
                    </div>
                    <div>
                      <div className="text-[10px] text-gray-500">Orders</div>
                      <div className="text-xs font-bold text-gray-800">{Number(liveIkas.orders || 0).toLocaleString()}</div>
                    </div>
                    <div>
                      <div className="text-[10px] text-gray-500">Items</div>
                      <div className="text-xs font-bold text-gray-800">{Number(liveIkas.items || 0).toLocaleString()}</div>
                    </div>
                  </div>
                ) : (
                  <div className="text-[10px] text-gray-400">{loadingLive ? 'Loading…' : 'No data'}</div>
                )}
              </div>
            )}

            {/* Shopify */}
            {hasShopifyConnected && (
              <div className="p-2.5 rounded-xl bg-gray-50/80">
                <div className="flex items-center gap-2 mb-1.5">
                  <img src="/shopify_glyph.svg" alt="Shopify" className="w-4 h-4" />
                  <span className="text-[11px] font-semibold text-gray-700">Shopify</span>
                </div>
                {liveShopify ? (
                  <div className="grid grid-cols-3 gap-2">
                    <div>
                      <div className="text-[10px] text-gray-500">Revenue</div>
                      <div className="text-xs font-bold text-green-700">₺{Math.round(liveShopify.revenue).toLocaleString()}</div>
                    </div>
                    <div>
                      <div className="text-[10px] text-gray-500">Orders</div>
                      <div className="text-xs font-bold text-gray-800">{Number(liveShopify.orders || 0).toLocaleString()}</div>
                    </div>
                    <div>
                      <div className="text-[10px] text-gray-500">Items</div>
                      <div className="text-xs font-bold text-gray-800">{Number(liveShopify.items || 0).toLocaleString()}</div>
                    </div>
                  </div>
                ) : (
                  <div className="text-[10px] text-gray-400">{loadingLive ? 'Loading…' : 'No data'}</div>
                )}
              </div>
            )}

            {/* WooCommerce */}
            {hasWooConnected && (
              <div className="p-2.5 rounded-xl bg-gray-50/80">
                <div className="flex items-center gap-2 mb-1.5">
                  <img src="/woocommerceicon.png" alt="WooCommerce" className="w-4 h-4 rounded" />
                  <span className="text-[11px] font-semibold text-gray-700">WooCommerce</span>
                </div>
                {liveWoo ? (
                  <div className="grid grid-cols-3 gap-2">
                    <div>
                      <div className="text-[10px] text-gray-500">Revenue</div>
                      <div className="text-xs font-bold text-green-700">₺{Math.round(liveWoo.revenue).toLocaleString()}</div>
                    </div>
                    <div>
                      <div className="text-[10px] text-gray-500">Orders</div>
                      <div className="text-xs font-bold text-gray-800">{Number(liveWoo.orders || 0).toLocaleString()}</div>
                    </div>
                    <div>
                      <div className="text-[10px] text-gray-500">Items</div>
                      <div className="text-xs font-bold text-gray-800">{Number(liveWoo.items || 0).toLocaleString()}</div>
                    </div>
                  </div>
                ) : (
                  <div className="text-[10px] text-gray-400">{loadingLive ? 'Loading…' : 'No data'}</div>
                )}
              </div>
            )}
          </div>
        </Card>

        {/* Card 4: IKAS Summary (conditional) */}
        {hasIkasConnected && (
          <Card className="rounded-2xl overflow-hidden p-3 min-w-0 bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
            <div className="flex justify-between items-center mb-2">
              <div className="flex items-center gap-2">
                <img src="/ikaslogoicon.png" alt="Ikas" className="w-5 h-5 rounded-md" />
                <h2 className="font-medium text-gray-800 text-sm">Ikas Summary</h2>
                <a
                  href="/ikas/overview"
                  className="ml-2 text-[10px] px-2 py-0.5 rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50"
                  title="View more details"
                >
                  View details
                </a>
              </div>
              <div className="text-xs text-gray-500">{getDateRangeDisplayText(dateRange)}</div>
            </div>
            <div className="bg-blue-50/40 rounded-xl p-3 border border-blue-100">
              {isLoadingIkasSummary ? (
                <div className="flex justify-center items-center h-[150px]">
                  <div className="loading-logo-container">
                    <img src="/logoicon.png" alt="Glowytics Logo" className="loading-logo" />
                  </div>
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-3 gap-2">
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Revenue</div>
                      <div className="text-sm font-bold text-green-600">
                        ₺{(ikasSummary?.revenue || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Orders</div>
                      <div className="text-sm font-bold text-gray-800">
                        {(ikasSummary?.orders || 0).toLocaleString()}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Items</div>
                      <div className="text-sm font-bold text-gray-800">
                        {(ikasSummary?.items || 0).toLocaleString()}
                      </div>
                    </div>
                  </div>
                  {/* Daily breakdown (compact) */}
                  <div className="mt-2 pt-2 border-t border-blue-100">
                    <div className="max-h-44 overflow-y-auto">
                      <table className="w-full text-[11px]">
                        <thead className="sticky top-0 bg-white">
                          <tr className="border-b border-blue-200">
                            <th className="text-left py-1 px-1 text-gray-600 font-medium">Date</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Revenue</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Orders</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Items</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ikasDailyRows.map((r, idx) => {
                            const d = r.day || r.date;
                            return (
                              <tr key={idx} className="border-b border-gray-100">
                                <td className="py-1 px-1 text-gray-700">
                                  {d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '-'}
                                </td>
                                <td className="py-1 px-1 text-right text-green-700">
                                  {formatCurrencyCompact(Number(r.revenue || 0))}
                                </td>
                                <td className="py-1 px-1 text-right text-gray-800">
                                  {Number(r.orders_count || 0).toLocaleString()}
                                </td>
                                <td className="py-1 px-1 text-right text-gray-800">
                                  {Number(r.items_count || 0).toLocaleString()}
                                </td>
                              </tr>
                            );
                          })}
                          {ikasDailyRows.length === 0 && (
                            <tr>
                              <td colSpan="4" className="py-2 text-center text-gray-500">No daily data</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Card>
        )}
        {/* Shopify Summary (conditional) */}
        {hasShopifyConnected && (
          <Card className="rounded-2xl overflow-hidden p-3 min-w-0 bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
            <div className="flex justify-between items-center mb-2">
              <div className="flex items-center gap-2">
                <img src="/shopify_glyph.svg" alt="Shopify" className="w-5 h-5" />
                <h2 className="font-medium text-gray-800 text-sm">Shopify Summary</h2>
                <a
                  href="/shopify/overview"
                  className="ml-2 text-[10px] px-2 py-0.5 rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50"
                  title="View more details"
                >
                  View details
                </a>
              </div>
              <div className="text-xs text-gray-500">{getDateRangeDisplayText(dateRange)}</div>
            </div>
            <div className="bg-blue-50/40 rounded-xl p-3 border border-blue-100">
              {isLoadingShopifySummary ? (
                <div className="flex justify-center items-center h-[150px]">
                  <div className="loading-logo-container">
                    <img src="/logoicon.png" alt="Glowytics Logo" className="loading-logo" />
                  </div>
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-3 gap-2">
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Revenue</div>
                      <div className="text-sm font-bold text-green-600">
                        ₺{(shopifySummary?.revenue || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Orders</div>
                      <div className="text-sm font-bold text-gray-800">
                        {(shopifySummary?.orders || 0).toLocaleString()}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Items</div>
                      <div className="text-sm font-bold text-gray-800">
                        {(shopifySummary?.items || 0).toLocaleString()}
                      </div>
                    </div>
                  </div>
                  {/* Daily breakdown (compact) */}
                  <div className="mt-2 pt-2 border-t border-blue-100">
                    <div className="max-h-44 overflow-y-auto">
                      <table className="w-full text-[11px]">
                        <thead className="sticky top-0 bg-white">
                          <tr className="border-b border-blue-200">
                            <th className="text-left py-1 px-1 text-gray-600 font-medium">Date</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Revenue</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Orders</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Items</th>
                          </tr>
                        </thead>
                        <tbody>
                          {shopifyDailyRows.map((r, idx) => {
                            const d = r.day || r.date;
                            return (
                              <tr key={idx} className="border-b border-gray-100">
                                <td className="py-1 px-1 text-gray-700">
                                  {d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '-'}
                                </td>
                                <td className="py-1 px-1 text-right text-green-700">
                                  {formatCurrencyCompact(Number(r.revenue || 0))}
                                </td>
                                <td className="py-1 px-1 text-right text-gray-800">
                                  {Number(r.orders_count || 0).toLocaleString()}
                                </td>
                                <td className="py-1 px-1 text-right text-gray-800">
                                  {Number(r.items_count || 0).toLocaleString()}
                                </td>
                              </tr>
                            );
                          })}
                          {shopifyDailyRows.length === 0 && (
                            <tr>
                              <td colSpan="4" className="py-2 text-center text-gray-500">No daily data</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Card>
        )}
        {/* WooCommerce Summary (conditional) */}
        {hasWooConnected && (
          <Card className="rounded-2xl overflow-hidden p-3 min-w-0 bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
            <div className="flex justify-between items-center mb-2">
              <div className="flex items-center gap-2">
                <img src="/woocommerceicon.png" alt="WooCommerce" className="w-5 h-5 rounded-md" />
                <h2 className="font-medium text-gray-800 text-sm">WooCommerce Summary</h2>
                <a
                  href="/woocommerce/overview"
                  className="ml-2 text-[10px] px-2 py-0.5 rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50"
                  title="View more details"
                >
                  View details
                </a>
              </div>
              <div className="text-xs text-gray-500">{getDateRangeDisplayText(dateRange)}</div>
            </div>
            <div className="bg-blue-50/40 rounded-xl p-3 border border-blue-100">
              {isLoadingWooSummary ? (
                <div className="flex justify-center items-center h-[150px]">
                  <div className="loading-logo-container">
                    <img src="/logoicon.png" alt="Glowytics Logo" className="loading-logo" />
                  </div>
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-3 gap-2">
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Revenue</div>
                      <div className="text-sm font-bold text-green-600">
                        ₺{(wooSummary?.revenue || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Orders</div>
                      <div className="text-sm font-bold text-gray-800">
                        {(wooSummary?.orders || 0).toLocaleString()}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Items</div>
                      <div className="text-sm font-bold text-gray-800">
                        {(wooSummary?.items || 0).toLocaleString()}
                      </div>
                    </div>
                  </div>
                  {/* Daily breakdown (compact) */}
                  <div className="mt-2 pt-2 border-t border-blue-100">
                    <div className="max-h-44 overflow-y-auto">
                      <table className="w-full text-[11px]">
                        <thead className="sticky top-0 bg-white">
                          <tr className="border-b border-blue-200">
                            <th className="text-left py-1 px-1 text-gray-600 font-medium">Date</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Revenue</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Orders</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Items</th>
                          </tr>
                        </thead>
                        <tbody>
                          {wooDailyRows.map((r, idx) => {
                            const d = r.day || r.date;
                            return (
                              <tr key={idx} className="border-b border-gray-100">
                                <td className="py-1 px-1 text-gray-700">
                                  {d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '-'}
                                </td>
                                <td className="py-1 px-1 text-right text-green-700">
                                  {formatCurrencyCompact(Number(r.revenue || 0))}
                                </td>
                                <td className="py-1 px-1 text-right text-gray-800">
                                  {Number(r.orders_count || 0).toLocaleString()}
                                </td>
                                <td className="py-1 px-1 text-right text-gray-800">
                                  {Number(r.items_count || 0).toLocaleString()}
                                </td>
                              </tr>
                            );
                          })}
                          {wooDailyRows.length === 0 && (
                            <tr>
                              <td colSpan="4" className="py-2 text-center text-gray-500">No daily data</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Card>
        )}
        {/* Adjust Summary (conditional) */}
        {hasAdjustConnected && (
          <Card className="rounded-2xl overflow-hidden p-3 min-w-0 bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
            <div className="flex justify-between items-center mb-2">
              <div className="flex items-center gap-2">
                <img src="/adjustlogopng.png" alt="Adjust" className="w-5 h-5 rounded" />
                <h2 className="font-medium text-gray-800 text-sm">Adjust Summary</h2>
              </div>
              <div className="text-xs text-gray-500">{getDateRangeDisplayText(dateRange)}</div>
            </div>
            <div className="bg-blue-50/40 rounded-xl p-3 border border-blue-100">
              {isLoadingAdjustSummary ? (
                <div className="flex justify-center items-center h-[150px]">
                  <div className="loading-logo-container">
                    <img src="/logoicon.png" alt="Glowytics Logo" className="loading-logo" />
                  </div>
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-3 gap-2">
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Revenue</div>
                      <div className="text-sm font-bold text-green-600">
                        ₺{(adjustSummary?.revenue || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Installs</div>
                      <div className="text-sm font-bold text-gray-800">
                        {(adjustSummary?.installs || 0).toLocaleString()}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-600 mb-0.5">Purchases</div>
                      <div className="text-sm font-bold text-gray-800">
                        {(adjustSummary?.purchases || 0).toLocaleString()}
                      </div>
                    </div>
                  </div>
                  {/* Daily breakdown (compact) */}
                  <div className="mt-2 pt-2 border-t border-blue-100">
                    <div className="max-h-44 overflow-y-auto">
                      <table className="w-full text-[11px]">
                        <thead className="sticky top-0 bg-white">
                          <tr className="border-b border-blue-200">
                            <th className="text-left py-1 px-1 text-gray-600 font-medium">Date</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Revenue</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Installs</th>
                            <th className="text-right py-1 px-1 text-gray-600 font-medium">Purchases</th>
                          </tr>
                        </thead>
                        <tbody>
                          {adjustDailyRows.map((r, idx) => {
                            const d = r.day || r.date;
                            return (
                              <tr key={idx} className="border-b border-gray-100">
                                <td className="py-1 px-1 text-gray-700">
                                  {d ? new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '-'}
                                </td>
                                <td className="py-1 px-1 text-right text-green-700">
                                  {formatCurrencyCompact(Number(r.all_revenue || r.revenue || 0))}
                                </td>
                                <td className="py-1 px-1 text-right text-gray-800">
                                  {Number(r.installs || 0).toLocaleString()}
                                </td>
                                <td className="py-1 px-1 text-right text-gray-800">
                                  {Number(r.purchases || 0).toLocaleString()}
                                </td>
                              </tr>
                            );
                          })}
                          {adjustDailyRows.length === 0 && (
                            <tr>
                              <td colSpan="4" className="py-2 text-center text-gray-500">No daily data</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              )}
            </div>
          </Card>
        )}
      </div>
      {/* New Performance Metrics Chart Section */}
      <div className="mb-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Chart Section - 2 birim */}
          <div className="lg:col-span-2 min-w-0">
            <Card className="p-3 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] h-full min-w-0">
              {/* Metrics Selection */}
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3 mb-4">
            {isLoadingGaTrafficSource ? (
              // Loading state for all cards
              [...Array(5)].map((_, index) => (
                <div key={index} className="relative p-3 rounded-lg border border-gray-200 animate-pulse">
                  <div className="flex items-center justify-between mb-2">
                    <div className="h-3 bg-gray-200 rounded w-16"></div>
                    <div className="h-4 bg-gray-200 rounded w-12"></div>
                  </div>
                  <div className="h-6 bg-gray-200 rounded w-20"></div>
                </div>
              ))
            ) : (
              <>
                <div 
                  className={`relative p-2 sm:p-3 rounded-lg border cursor-pointer hover:shadow-md transition-all group ${activeMetric === 'conversionRate' ? 'border-blue-500 bg-blue-50/30' : 'border-gray-200'}`}
                  onClick={() => setActiveMetric('conversionRate')}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">Users</span>
                    <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${(() => {
                      const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                      if (!hasData) return 'bg-gray-50 text-gray-600';
                      return trendPercentages.users >= 0 ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600';
                    })()}`}>
                      {(() => {
                        const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                        if (!hasData) return '0%';
                        const t = trendPercentages.users;
                        return `${t >= 0 ? '▲' : '▼'} ${Math.round(Math.abs(t))}%`;
                      })()}
                    </span>
                  </div>
                  <div className="mt-1 text-sm sm:text-base font-bold text-gray-800">
                    {gaTrafficSourceData?.totals?.users?.toLocaleString() || '0'}
                  </div>
                  {comparisonAggregates && (
                    <div className="mt-0.5 text-[10px] text-gray-500">
                      Prev: {Math.round(comparisonAggregates.prev.users).toLocaleString()}
                    </div>
                  )}
                  <div className={`absolute inset-0 border-b-2 border-blue-600 rounded-b-none rounded-t-lg transition-opacity ${activeMetric === 'conversionRate' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}></div>
                </div>
                
                <div 
                  className={`relative p-3 rounded-lg border cursor-pointer hover:shadow-md transition-all group ${activeMetric === 'saleCount' ? 'border-blue-500 bg-blue-50/30' : 'border-gray-200'}`}
                  onClick={() => setActiveMetric('saleCount')}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">Sessions</span>
                    <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${(() => {
                      const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                      if (!hasData) return 'bg-gray-50 text-gray-600';
                      return trendPercentages.sessions >= 0 ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600';
                    })()}`}>
                      {(() => {
                        const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                        if (!hasData) return '0%';
                        const t = trendPercentages.sessions;
                        return `${t >= 0 ? '▲' : '▼'} ${Math.round(Math.abs(t))}%`;
                      })()}
                    </span>
                  </div>
                  <div className="mt-1 text-base font-bold text-gray-800">
                    {gaTrafficSourceData?.totals?.sessions?.toLocaleString() || '0'}
                  </div>
                  {comparisonAggregates && (
                    <div className="mt-0.5 text-[10px] text-gray-500">
                      Prev: {Math.round(comparisonAggregates.prev.sessions).toLocaleString()}
                    </div>
                  )}
                  <div className={`absolute inset-0 border-b-2 border-blue-600 rounded-b-none rounded-t-lg transition-opacity ${activeMetric === 'saleCount' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}></div>
                </div>
                
                <div 
                  className={`relative p-3 rounded-lg border cursor-pointer hover:shadow-md transition-all group ${activeMetric === 'refundAmount' ? 'border-blue-500 bg-blue-50/30' : 'border-gray-200'}`}
                  onClick={() => setActiveMetric('refundAmount')}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">Transactions</span>
                    <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${(() => {
                      const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                      if (!hasData) return 'bg-gray-50 text-gray-600';
                      return trendPercentages.eventCount >= 0 ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600';
                    })()}`}>
                      {(() => {
                        const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                        if (!hasData) return '0%';
                        const t = trendPercentages.eventCount;
                        return `${t >= 0 ? '▲' : '▼'} ${Math.round(Math.abs(t))}%`;
                      })()}
                    </span>
                  </div>
                  <div className="mt-1 text-base font-bold text-gray-800">
                    {gaTrafficSourceData?.totals?.eventCount?.toLocaleString() || '0'}
                  </div>
                  {comparisonAggregates && (
                    <div className="mt-0.5 text-[10px] text-gray-500">
                      Prev: {Math.round(comparisonAggregates.prev.eventCount).toLocaleString()}
                    </div>
                  )}
                  <div className={`absolute inset-0 border-b-2 border-blue-600 rounded-b-none rounded-t-lg transition-opacity ${activeMetric === 'refundAmount' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}></div>
                </div>
                
                <div 
                  className={`relative p-3 rounded-lg border cursor-pointer hover:shadow-md transition-all group ${activeMetric === 'sessionCount' ? 'border-blue-500 bg-blue-50/30' : 'border-gray-200'}`}
                  onClick={() => setActiveMetric('sessionCount')}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">Conversion Rate</span>
                    <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${(() => {
                      const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                      if (!hasData) return 'bg-gray-50 text-gray-600';
                      return trendPercentages.conversionRate >= 0 ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600';
                    })()}`}>
                      {(() => {
                        const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                        if (!hasData) return '0%';
                        const t = trendPercentages.conversionRate;
                        return `${t >= 0 ? '▲' : '▼'} ${Math.round(Math.abs(t))}%`;
                      })()}
                    </span>
                  </div>
                  <div className="mt-1 text-base font-bold text-gray-800">
                    {(() => {
                      if (!gaTrafficSourceData?.totals) return '0.00%';
                      const sessions = gaTrafficSourceData.totals.sessions || 0;
                      const transactions = gaTrafficSourceData.totals.eventCount || 0;
                      const conversionRate = sessions > 0 ? (transactions / sessions) * 100 : 0;
                      return conversionRate.toFixed(2) + '%';
                    })()}
                  </div>
                  {comparisonAggregates && (
                    <div className="mt-0.5 text-[10px] text-gray-500">
                      Prev: {Math.round(comparisonAggregates.prevCR)}%
                    </div>
                  )}
                  <div className={`absolute inset-0 border-b-2 border-blue-600 rounded-b-none rounded-t-lg transition-opacity ${activeMetric === 'sessionCount' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}></div>
                </div>
                
                <div 
                  className={`relative p-3 rounded-lg border cursor-pointer hover:shadow-md transition-all group ${activeMetric === 'totalSales' ? 'border-blue-500 bg-blue-50/30' : 'border-gray-200'}`}
                  onClick={() => setActiveMetric('totalSales')}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">Revenue</span>
                    <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${(() => {
                      const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                      if (!hasData) return 'bg-gray-50 text-gray-600';
                      return trendPercentages.totalRevenue >= 0 ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600';
                    })()}`}>
                      {(() => {
                        const hasData = (gaTrafficSourceAllData?.detailedData?.length || gaTrafficSourceData?.detailedData?.length);
                        if (!hasData) return '0%';
                        const t = trendPercentages.totalRevenue;
                        return `${t >= 0 ? '▲' : '▼'} ${Math.round(Math.abs(t))}%`;
                      })()}
                    </span>
                  </div>
                  <div className="mt-1 text-base font-bold text-gray-800">
                    ₺{gaTrafficSourceData?.totals?.totalRevenue?.toLocaleString(undefined, {maximumFractionDigits: 0}) || '0'}
                  </div>
                  {comparisonAggregates && (
                    <div className="mt-0.5 text-[10px] text-gray-500">
                      Prev: ₺{Math.round(comparisonAggregates.prev.totalRevenue).toLocaleString()}
                    </div>
                  )}
                  <div className={`absolute inset-0 border-b-2 border-blue-600 rounded-b-none rounded-t-lg transition-opacity ${activeMetric === 'totalSales' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}></div>
                </div>
              </>
            )}
          </div>
          
          {/* Chart Controls */}
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <h3 className="text-base font-medium text-gray-800">{getActiveMetricTitle()}</h3>
            </div>
          </div>
          
          {/* Line Chart */}
          <div className="h-[220px] sm:h-[260px] overflow-hidden">
            <LineChart 
              data={getChartData(activeMetric)}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                  padding: { top: 6, bottom: 40, left: 12, right: 12 }
                },
                plugins: {
                  legend: {
                    display: false
                  },
                  tooltip: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                      label: function(context) {
                        if (context.parsed.y !== null) {
                          // Format based on active metric
                          let formattedValue;
                          switch(activeMetric) {
                            case 'conversionRate':
                              formattedValue = context.parsed.y.toLocaleString() + ' users';
                              break;
                            case 'saleCount':
                              formattedValue = context.parsed.y.toLocaleString() + ' sessions';
                              break;
                            case 'refundAmount':
                              formattedValue = context.parsed.y.toLocaleString() + ' transactions';
                              break;
                            case 'sessionCount':
                              formattedValue = context.parsed.y.toFixed(2) + '%';
                              break;
                            case 'totalSales':
                              formattedValue = '₺' + context.parsed.y.toLocaleString();
                              break;
                            default:
                              formattedValue = context.parsed.y.toLocaleString();
                          }
                          return formattedValue;
                        }
                        return '';
                      }
                    }
                  }
                },
                interaction: {
                  mode: 'index',
                  intersect: false
                },
                scales: {
                  x: {
                    offset: false,
                    grid: {
                      display: false
                    },
                    ticks: {
                      // Customize x-axis ticks based on the date range
                      maxRotation: 45,
                      minRotation: 0,
                      autoSkip: true,
                      autoSkipPadding: 8,
                      maxTicksLimit: dateRange === 'today' || dateRange === 'yesterday' ? 12 :
                                      dateRange === 'last7' ? 7 : 
                                      dateRange === 'thisMonth' ? 15 : 10,
                      padding: 6,
                      font: {
                        size: 9
                      }
                    }
                  },
                  y: {
                    grid: {
                      borderDash: [2, 4],
                      color: '#e5e7eb'
                    },
                    ticks: {
                      callback: function(value) {
                        return metricsChartData[activeMetric].yAxisFormat(value);
                      },
                      font: {
                        size: 9
                      }
                    }
                  }
                }
              }}
            />
          </div>
            </Card>
          </div>

          {/* Daily Performance Table - 1 birim */}
          <div className="lg:col-span-1 min-w-0">
            <Card className="p-4 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] min-w-0 h-full">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl">
                  <TrendingUp className="w-4 h-4 text-white" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-800">Daily Performance</h3>
                  <p className="text-xs text-gray-500">
                    {dateRange === 'today' ? 'Today' :
                     dateRange === 'yesterday' ? 'Yesterday' :
                     dateRange === 'last7' ? 'Last 7 days' :
                     dateRange === 'last30' ? 'Last 30 days' :
                     dateRange === 'thisMonth' ? 'This month' :
                     dateRange === 'custom' ? 'Custom range' : 'Last 12 days'}
                  </p>
                </div>
              </div>

              {/* Table */}
              <div className="overflow-y-auto overflow-x-auto max-h-[360px]">
                <table className="w-full text-xs">
                  <thead className="sticky top-0 bg-white border-b border-gray-200">
                    <tr>
                      <th className="text-left py-2 px-1 text-gray-600 font-medium">Date</th>
                      <th className="text-center py-2 px-1 text-green-600 font-medium">Sessions</th>
                      <th className="text-center py-2 px-1 text-orange-600 font-medium">Transaction</th>
                      <th className="text-center py-2 px-1 text-purple-600 font-medium">CR %</th>
                      <th className="text-center py-2 px-1 text-blue-600 font-medium">Revenue</th>
                      <th className="text-center py-2 px-1 text-red-600 font-medium">
                        <div className="flex items-center justify-center gap-1">
                          <img src="/google_ads-512.webp" alt="Google Ads" className="w-3 h-3" />
                          <span className="text-[10px]">Cost</span>
                        </div>
                      </th>
                      <th className="text-center py-2 px-1 text-blue-500 font-medium">
                        <div className="flex items-center justify-center gap-1">
                          <img src="/6033716.png" alt="Meta Ads" className="w-3 h-3" />
                          <span className="text-[10px]">Cost</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const getDatesForRange = (range) => {
                        const today = new Date();
                        let rangeStart, rangeEnd, maxDays = 12;
                        
                        if (range === 'custom' && startDate && endDate) {
                          const customStart = new Date(startDate);
                          const customEnd = new Date(endDate);
                          maxDays = Math.min(90, Math.ceil((customEnd - customStart) / (1000 * 60 * 60 * 24)) + 1);
                          rangeStart = customStart;
                          rangeEnd = customEnd;
                        } else if (range === 'all') {
                          const allDates = [];
                          if (gaTrafficSourceAllData && Array.isArray(gaTrafficSourceAllData)) {
                            gaTrafficSourceAllData.forEach(item => {
                              const d = (item.date || '').split('T')[0];
                              if (d && !allDates.includes(d)) allDates.push(d);
                            });
                          }
                          if (Array.isArray(unifiedGoogleAdsData)) {
                            unifiedGoogleAdsData.forEach(item => {
                              const d = (item.date || '').split('T')[0];
                              if (d && !allDates.includes(d)) allDates.push(d);
                            });
                          }
                          allDates.sort((a, b) => new Date(b) - new Date(a));
                          return allDates.slice(0, 60);
                        } else {
                          switch(range) {
                            case 'today':
                              rangeStart = new Date(today);
                              rangeEnd = new Date(today);
                              maxDays = 1;
                              break;
                            case 'yesterday':
                              rangeStart = new Date(today);
                              rangeStart.setDate(today.getDate() - 1);
                              rangeEnd = new Date(rangeStart);
                              maxDays = 1;
                              break;
                            case 'last7':
                              rangeStart = new Date(today);
                              rangeStart.setDate(today.getDate() - 6);
                              rangeEnd = new Date(today);
                              maxDays = 7;
                              break;
                            case 'last30':
                              rangeStart = new Date(today);
                              rangeStart.setDate(today.getDate() - 29);
                              rangeEnd = new Date(today);
                              maxDays = 30;
                              break;
                            case 'last90':
                              rangeStart = new Date(today);
                              rangeStart.setDate(today.getDate() - 89);
                              rangeEnd = new Date(today);
                              maxDays = 90;
                              break;
                            case 'thisMonth':
                              rangeStart = new Date(today.getFullYear(), today.getMonth(), 1);
                              rangeEnd = new Date(today);
                              maxDays = today.getDate();
                              break;
                            default:
                              rangeStart = new Date(today);
                              rangeStart.setDate(today.getDate() - 11);
                              rangeEnd = new Date(today);
                              maxDays = 12;
                          }
                        }
                        
                        const toLocalDateStr = (d) => {
                          const y = d.getFullYear();
                          const m = String(d.getMonth() + 1).padStart(2, '0');
                          const dd = String(d.getDate()).padStart(2, '0');
                          return `${y}-${m}-${dd}`;
                        };
                        const dates = [];
                        const currentDate = new Date(rangeEnd);
                        
                        for (let i = 0; i < maxDays; i++) {
                          dates.push(toLocalDateStr(currentDate));
                          currentDate.setDate(currentDate.getDate() - 1);
                        }
                        
                        return dates;
                      };

                      const displayDates = getDatesForRange(dateRange);

                      // LineChart'ın kullandığı aynı data processing'i kullan

                      
                      // Build cost maps by date for Google Ads and Meta Ads
                      const googleCostByDate = {};
                      const metaCostByDate = {};
                      if (Array.isArray(unifiedGoogleAdsData)) {
                        for (const item of unifiedGoogleAdsData) {
                          const dk = (item.date || '').split('T')[0];
                          const c = Number(item.cost || 0);
                          googleCostByDate[dk] = (googleCostByDate[dk] || 0) + (isFinite(c) ? c : 0);
                        }
                      }
                      if (Array.isArray(unifiedMetaAdsData)) {
                        for (const item of unifiedMetaAdsData) {
                          const dk = (item.date || '').split('T')[0];
                          const c = Number(item.spend || 0);
                          metaCostByDate[dk] = (metaCostByDate[dk] || 0) + (isFinite(c) ? c : 0);
                        }
                      }

                      const _now = new Date();
                      const todayStr = `${_now.getFullYear()}-${String(_now.getMonth()+1).padStart(2,'0')}-${String(_now.getDate()).padStart(2,'0')}`;
                      return displayDates.map((date, index) => {
                        // Tarih normalizasyon fonksiyonu (en başta tanımla)
                        const normalizeDate = (date) => {
                          if (!date) return '';
                          if (typeof date === 'string') {
                            return date.includes('T') ? date.split('T')[0] : date;
                          }
                          return date.toISOString().split('T')[0];
                        };

                        // LineChart'ın kullandığı aynı veri kaynağını kullan: gaTrafficSourceData.detailedData
                        let dayRevenue = 0;
                        let daySessions = 0;
                        let dayTransactions = 0;
                        
                        if (gaDailyTotalsMap && gaDailyTotalsMap.has(date)) {
                          const agg = gaDailyTotalsMap.get(date);
                          dayRevenue = agg.revenue;
                          daySessions = agg.sessions;
                          dayTransactions = agg.transactions;
                        }
                        // If today has no aggregated data yet, hydrate from live cards
                        if (date === todayStr && liveGa4) {
                          dayRevenue = Number(liveGa4.revenue || liveGa4.totalRevenue || 0);
                          daySessions = Number(liveGa4.sessions || 0);
                          dayTransactions = Number(liveGa4.purchases || liveGa4.transactions || 0);
                        }
                        // Also hydrate today's ad costs from live cards if available
                        if (date === todayStr) {
                          if (liveGads && typeof liveGads.cost !== 'undefined') {
                            googleCostByDate[date] = Number(liveGads.cost || 0);
                          }
                          // Meta live payload uses `cost` (spend). Fallback to `spend` if present.
                          if (liveMeta && (typeof liveMeta.cost !== 'undefined' || typeof liveMeta.spend !== 'undefined')) {
                            const metaTodayCost = typeof liveMeta.cost !== 'undefined' ? liveMeta.cost : liveMeta.spend;
                            metaCostByDate[date] = Number(metaTodayCost || 0);
                          }
                        }
                        
                        // Conversion Rate hesapla (Transaction / Sessions * 100)
                        const conversionRate = daySessions > 0 ? (dayTransactions / daySessions * 100) : 0;

                        return (
                          <tr key={date} className={`border-b border-gray-100 hover:bg-gray-50 ${index === 0 ? 'bg-blue-50/30' : ''}`}>
                            <td className="py-2 px-1 font-medium text-gray-800">
                              {index === 0 ? 'Today' : new Date(date).toLocaleDateString('en-US', { day: 'numeric', month: 'short' })}
                            </td>
                            <td className="text-center py-2 px-1 font-medium text-green-700">
                              {daySessions.toLocaleString()}
                            </td>
                            <td className="text-center py-2 px-1 font-medium text-orange-700">
                              {dayTransactions.toLocaleString()}
                            </td>
                            <td className="text-center py-2 px-1 font-medium text-purple-700">
                              {conversionRate.toFixed(2)}%
                            </td>
                            <td className="text-center py-2 px-1 font-medium text-blue-700">
                              ₺{dayRevenue.toLocaleString(undefined, {maximumFractionDigits: 0})}
                            </td>
                            <td className="text-center py-2 px-1 font-medium text-red-600">
                              {((googleCostByDate[date] || 0) > 0) ? `₺${Math.round(googleCostByDate[date]).toLocaleString()}` : '-'}
                            </td>
                            <td className="text-center py-2 px-1 font-medium text-blue-500">
                              {((metaCostByDate[date] || 0) > 0) ? `₺${Math.round(metaCostByDate[date]).toLocaleString()}` : '-'}
                            </td>
                          </tr>
                        );
                      });
                    })()}
                  </tbody>
                </table>
              </div>
            </Card>
          </div>
        </div>
      </div>

      {/* AI Insights Section */}
      

      {/* Platform Comparison Widgets */}
      

      {/* Quick Stats Grid */}
      

  

      {/* Quick Stats Grid - 2x2 Grid Şeklinde */}
     

      {/* Gradient Stats Section */}
      

     

      {/* Analytics Tabs - Just updating this section */}
      <div className="mb-7">
        <div className="flex flex-wrap items-center gap-2 sm:gap-4 border-b border-gray-300 overflow-x-auto">
          <button 
            className={`px-3 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
              activeTab === 'overview' 
                ? 'border-blue-600 text-blue-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('overview')}
          >
            <div className="flex items-center gap-2">
              <Activity className="w-4 h-4" />
              <span>Performance Overview</span>
              </div>
          </button>

          {!isMarketer && (
          <button 
            className={`px-3 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
              activeTab === 'ecommerce' 
                ? 'border-blue-600 text-blue-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('ecommerce')}
          >
            <div className="flex items-center gap-2">
              <ShoppingCart className="w-4 h-4" />
              <span>E-commerce Analytics</span>
            </div>
          </button>
          )}
          {!isMarketer && (
          <button 
            className={`px-3 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
              activeTab === 'traffic' 
                ? 'border-blue-600 text-blue-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('traffic')}
          >
            <div className="flex items-center gap-2">
              <Globe className="w-4 h-4" />
              <span>Traffic & Acquisition</span>
            </div>
          </button>
          )}
          {!isMarketer && (
          <button 
            className={`px-3 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
              activeTab === 'journey' 
                ? 'border-blue-600 text-blue-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
            onClick={() => setActiveTab('journey')}
          >
            <div className="flex items-center gap-2">
              <Users className="w-4 h-4" />
              <span>Customer Journey</span>
            </div>
          </button>
          )}
        </div>
            </div>
            
      {/* Conditional Rendering Based on Active Tab */}
      {activeTab === 'overview' && (
        <div className="space-y-6 performance-overview-section">
      {/* Main Charts Grid */}
    
          <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
            <div className="p-6">
                {/* Header Section - Mobile Responsive */}
                <div className="flex flex-col gap-4 mb-6 md:flex-row md:items-center md:justify-between">
                    <div className="flex items-center gap-3">
                        <div className="p-2">
                          <ChartPieIcon className="w-5 h-5 text-blue-600" />
                        </div>
                        <div>
                            <h2 className="text-lg font-semibold text-gray-800">{`${channelAggregation} Channel ${activeChannelMetric}`}</h2>
                            <p className="text-sm text-gray-500 mt-1">GA4 metrics by channel. Costs are sourced from respective platforms.</p>
                        </div>
                    </div>
                    
                    {/* Metric + Aggregation Selector */}
                    <div className="flex items-center gap-2 justify-start md:justify-end">
                      <Menu as="div" className="relative inline-block text-left">
                        <div>
                          <Menu.Button className="inline-flex justify-center w-full rounded-xl border border-gray-200 shadow-sm px-3 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50">
                            {channelAggregation}
                            <ChevronDown className="-mr-1 ml-2 h-4 w-4" aria-hidden="true" />
                          </Menu.Button>
                        </div>
                        <Menu.Items className="absolute right-0 mt-2 w-36 origin-top-right rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                          <div className="py-1 text-sm">
                            <Menu.Item>
                              {({ active }) => (
                                <button onClick={() => setChannelAggregation('Monthly')} className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} block w-full px-3 py-2 text-left`}>Monthly</button>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <button onClick={() => setChannelAggregation('Daily')} className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} block w-full px-3 py-2 text-left`}>Daily</button>
                              )}
                            </Menu.Item>
                          </div>
                        </Menu.Items>
                      </Menu>
                      <Menu as="div" className="relative inline-block text-left">
                        <div>
                          <Menu.Button className="inline-flex justify-center w-full rounded-xl border border-gray-200 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500">
                            {activeChannelMetric}
                            <ChevronDown className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
                          </Menu.Button>
                        </div>

                      <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                        <div className="py-1">
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => setActiveChannelMetric('Revenue')}
                                className={`${
                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                                } group flex rounded-md items-center w-full px-4 py-2 text-sm`}
                              >
                                Revenue
                              </button>
                            )}
                          </Menu.Item>
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => setActiveChannelMetric('Sessions')}
                                className={`${
                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                                } group flex rounded-md items-center w-full px-4 py-2 text-sm`}
                              >
                                Sessions
                              </button>
                            )}
                          </Menu.Item>
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => setActiveChannelMetric('Transactions')}
                                className={`${
                                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                                } group flex rounded-md items-center w-full px-4 py-2 text-sm`}
                              >
                                Transactions
                              </button>
                            )}
                          </Menu.Item>
                        </div>
                      </Menu.Items>
                    </Menu>
                    </div>
                </div>
                <div className="overflow-x-auto rounded-xl border border-gray-200">
                  {isLoadingUnifiedCampaign ? (
                    <div className="flex justify-center items-center h-[200px]">
                      <div className="loading-logo-container">
                        <img src="/logoicon.png" alt="Glowytics Logo" className="loading-logo" />
                      </div>
                    </div>
                  ) : channelAggregation === 'Monthly' ? (
                    channelMonthlyRevenue ? (
                      <><table className="w-full text-sm table-fixed">
                        <thead>
                          <tr className="bg-gray-50/60">
                            {channelMonthlyRevenue.headers.map(header => (
                              <th key={header} className={`py-3 px-4 font-semibold text-gray-600 uppercase tracking-wider ${header === 'Month' ? 'text-left' : 'text-right'} ${header !== 'Month' ? 'border-l border-gray-100' : ''}`}>
                                <div className="flex items-center justify-end">
                                  {header === 'Google Ads' && <img src="/google_ads-512.webp" alt="Google Ads" className="w-3 h-3 mr-2" />}
                                  {header === 'Meta Ads' && <img src="/6033716.png" alt="Meta Ads" className="w-3 h-3 mr-2" />}
                                  <span className="text-[9px]">{header.replace(/REFERRAL/gi, 'REF.')}</span>
                                </div>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                          {(showAllMonths ? channelMonthlyRevenue.rows : channelMonthlyRevenue.rows.slice(0, 6)).map((row, index) => (
                            <tr key={index} className="hover:bg-blue-50/30 transition-colors">
                              <td className="py-3 px-4 font-medium text-xs text-gray-800">{row.month}</td>
                              {channelMonthlyRevenue.headers.filter(h => h !== 'Month').map(header => (
                                <td key={header} className={`py-3 px-4 text-xs text-right border-l border-gray-100 ${header === 'Total' ? 'font-bold text-gray-800' : 'text-gray-700'}`}>
                                  {(() => {
                                    const metricKey = activeChannelMetric.toLowerCase();
                                    const value = row[header]?.[metricKey];
                                    const cost = row[header]?.cost;
                                    if (value === undefined) return 'N/A';
                                    const valueString = activeChannelMetric === 'Revenue'
                                      ? formatCurrencyCompact(value)
                                      : formatNumberCompact(value);
                                    return (
                                      <div>
                                        <span>{valueString}</span>
                                        {(header === 'Google Ads' || header === 'Meta Ads' || header === 'Criteo' || header === 'Total') && cost > 0 && (
                                          <div className={`text-xs ${header === 'Google Ads' ? 'text-red-500' : header === 'Meta Ads' ? 'text-blue-500' : header === 'Criteo' ? 'text-orange-500' : 'text-gray-400'}`}>
                                            (Cost: {formatCurrencyCompact(cost)})
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })()}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr className="bg-gray-100 font-bold text-gray-800">
                            <td className="py-3 px-4 text-left text-xs font-bold">TOTAL</td>
                            {channelMonthlyRevenue.headers.filter(h => h !== 'Month').map(header => (
                              <td key={header} className="py-3 px-4 text-right text-xs border-l border-gray-100">
                                {(() => {
                                  const metricKey = activeChannelMetric.toLowerCase();
                                  const value = channelMonthlyRevenue.totals[header]?.[metricKey];
                                  const cost = channelMonthlyRevenue.totals[header]?.cost;
                                  if (value === undefined) return 'N/A';
                                  const valueString = activeChannelMetric === 'Revenue'
                                    ? formatCurrencyCompact(value)
                                    : formatNumberCompact(value);
                                  return (
                                    <div>
                                      <span>{valueString}</span>
                                      {(header === 'Google Ads' || header === 'Meta Ads' || header === 'Criteo' || header === 'Total') && cost > 0 && (
                                        <div className={`text-xs font-normal ${header === 'Google Ads' ? 'text-red-500' : header === 'Meta Ads' ? 'text-blue-500' : header === 'Criteo' ? 'text-orange-500' : 'text-gray-400'}`}>
                                          (Cost: {formatCurrencyCompact(cost)})
                                        </div>
                                      )}
                                    </div>
                                  );
                                })()}
                              </td>
                            ))}
                          </tr>
                        </tfoot>
                      </table>
                      {channelMonthlyRevenue.rows.length > 6 && (
                        <div className="flex justify-center py-3">
                          <button
                            onClick={() => setShowAllMonths(!showAllMonths)}
                            className="text-xs text-blue-600 hover:text-blue-800 font-medium transition-colors"
                          >
                            {showAllMonths ? "▲ Show less" : `▼ Show all ${channelMonthlyRevenue.rows.length} months`}
                          </button>
                        </div>
                      )}
                      </>
                    ) : (
                      <div className="flex flex-col items-center justify-center py-16 px-4">
                        <div className="text-gray-400 mb-2">
                          <BarChart3 className="w-12 h-12 mx-auto mb-2" />
                        </div>
                        <h3 className="text-lg font-medium text-gray-700 mb-1">No Channel Revenue Data</h3>
                        <p className="text-sm text-gray-500 text-center max-w-md">Could not find monthly aggregated channel revenue data.</p>
                      </div>
                    )
                  ) : (
                    // Daily view pivoted: Date rows, Channel columns
                    unifiedCampaignLast30Data && Array.isArray(unifiedCampaignLast30Data) && unifiedCampaignLast30Data.length > 0 ? (
                      (() => {
                        const metricField = (
                          activeChannelMetric === 'Revenue' ? 'ga4_total_revenue' :
                          activeChannelMetric === 'Sessions' ? 'ga4_sessions' :
                          activeChannelMetric === 'Transactions' ? 'ga4_purchases' : 'ga4_total_revenue'
                        );

                        // Determine channel headers; prefer monthly headers for consistent order
                        const monthlyHeaders = (channelMonthlyRevenue?.headers || []).filter(h => h !== 'Month');
                        const channelsFromData = Array.from(new Set(unifiedCampaignLast30Data.map(r => r.channel).filter(Boolean)));
                        const baseChannels = monthlyHeaders.length > 0 ? monthlyHeaders.filter(h => h !== 'Total') : channelsFromData;
                        const channelHeaders = [...baseChannels, 'Total'];

                        // Group by date and channel (metric values)
                        const byDate = {};
                        for (const row of unifiedCampaignLast30Data) {
                          const dateKey = (row.date || '').split('T')[0];
                          const ch = row.channel || 'Unknown';
                          if (!byDate[dateKey]) byDate[dateKey] = {};
                          if (!byDate[dateKey][ch]) byDate[dateKey][ch] = 0;
                          const val = Number(row[metricField] || 0);
                          byDate[dateKey][ch] += isFinite(val) ? val : 0;
                        }

                        // Build cost maps for Google Ads and Meta Ads by date
                        const googleCostByDate = {};
                        const metaCostByDate = {};
                        if (Array.isArray(unifiedGoogleAdsData)) {
                          for (const item of unifiedGoogleAdsData) {
                            const dk = (item.date || '').split('T')[0];
                            const c = Number(item.cost || 0);
                            googleCostByDate[dk] = (googleCostByDate[dk] || 0) + (isFinite(c) ? c : 0);
                          }
                        }
                        if (Array.isArray(unifiedMetaAdsData)) {
                          for (const item of unifiedMetaAdsData) {
                            const dk = (item.date || '').split('T')[0];
                            const c = Number(item.spend || 0);
                            metaCostByDate[dk] = (metaCostByDate[dk] || 0) + (isFinite(c) ? c : 0);
                          }
                        }

                        // Sort dates desc and limit to last 30
                        const dates = Object.keys(byDate).sort((a, b) => new Date(b) - new Date(a)).slice(0, 30);

                        const formatCell = (num) => {
                          if (activeChannelMetric === 'Revenue') {
                            return formatCurrencyCompact(num);
                          }
                          return formatNumberCompact(num);
                        };

                        return (
                          <table className="w-full text-sm table-fixed">
                            <thead>
                              <tr className="bg-gray-50/60">
                                <th className="py-3 px-4 text-left font-semibold text-gray-600 uppercase tracking-wider">Date</th>
                                {channelHeaders.map(header => (
                                  <th key={header} className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">{header}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                              {dates.map(dateKey => {
                                const channelValues = byDate[dateKey];
                                let rowTotal = 0;
                                const cells = baseChannels.map(ch => {
                                  const val = Number(channelValues[ch] || 0);
                                  rowTotal += val;
                                  const costVal = ch === 'Google Ads'
                                    ? (googleCostByDate[dateKey] || 0)
                                    : ch === 'Meta Ads'
                                      ? (metaCostByDate[dateKey] || 0)
                                      : 0;
                                  return (
                                    <td key={ch} className="py-2 px-4 text-xs text-gray-700 text-right">
                                      <div>
                                        <span>{formatCell(val)}</span>
                                        {(ch === 'Google Ads' || ch === 'Meta Ads' || ch === 'Criteo') && costVal > 0 && (
                                          <div className={`text-[10px] ${ch === 'Google Ads' ? 'text-red-500' : ch === 'Meta Ads' ? 'text-blue-500' : 'text-orange-500'}`}>
                                            (Cost: {formatCurrencyCompact(costVal)})
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                  );
                                });
                                return (
                                  <tr key={dateKey} className="hover:bg-blue-50/20">
                                    <td className="py-2 px-4 text-xs text-gray-700">{new Date(dateKey).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</td>
                                    {cells}
                                    <td className="py-2 px-4 text-xs text-gray-700 text-right font-semibold">{formatCell(rowTotal)}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        );
                      })()
                    ) : (
                      <div className="flex flex-col items-center justify-center py-16 px-4">
                        <div className="text-gray-400 mb-2">
                          <BarChart3 className="w-12 h-12 mx-auto mb-2" />
                        </div>
                        <h3 className="text-lg font-medium text-gray-700 mb-1">No Daily Data</h3>
                        <p className="text-sm text-gray-500 text-center max-w-md">Switch to Monthly or try again later.</p>
                      </div>
                    )
                  )}
                </div>
            </div>
        </Card>

          {/* Monthly Performance Trends - Moved here */}
      <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] transition-all duration-300">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-50 rounded-xl">
                <BarChart2 className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-800">Monthly Performance Trends</h2>
                <p className="text-sm text-gray-500 mt-1">Platform based analysis</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-red-50 rounded-lg border border-red-100">
                <div className="p-1.5 rounded-lg bg-red-100">
                  <img src="/google_ads-512.webp" className="w-4 h-4" alt="Google Ads" />
                </div>
                <span className="text-sm font-medium text-gray-800">Google Ads</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 bg-blue-50 rounded-lg border border-blue-100">
                <div className="p-1.5 rounded-lg bg-blue-100">
                  <img src="/6033716.png" className="w-4 h-4" alt="Meta Ads" />
                </div>
                <span className="text-sm font-medium text-gray-800">Meta Ads</span>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto rounded-xl border border-gray-200">
            {isLoadingMonthly ? (
              <div className="flex justify-center items-center h-[200px]">
                  <div className="loading-logo-container">
                    <img src="/logoicon.png" alt="Glowytics Logo" className="loading-logo" />
                  </div>
              </div>
            ) : monthlyPerformanceData ? (
              <table className="w-full text-sm table-auto">
                <thead>
                  <tr className="bg-gray-50/60 divide-x divide-gray-100">
                    <th className="py-3 px-4 text-left font-semibold text-gray-600 uppercase tracking-wider">Platform</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Spend</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Clicks</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">CPC</th>
                    <th className="py-3 px-4 text-right font-semibold text-green-600 uppercase tracking-wider bg-green-50/40">CPC ($)</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Conv.</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">GA4 Conv.</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">CPA</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">CR</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">GA4 ROAS</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Revenue</th>
                    <th className="py-3 px-4 text-right font-semibold text-green-600 uppercase tracking-wider bg-green-50/40">Revenue ($)</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">GA4 Revenue</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">ROAS</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Sessions</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">CPS</th>
                    
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {['Google Ads', 'Meta Ads'].map(platformName => {
                    const platformData = monthlyPerformanceData[platformName];
                    if (!platformData) return null;
                    const isExpanded = expandedPlatforms.includes(platformName);
                    
                    return (
                      <React.Fragment key={platformName}>
                        <tr className="bg-white hover:bg-gray-50/50 font-medium cursor-pointer divide-x divide-gray-100" onClick={() => togglePlatform(platformName)}>
                          <td className="py-3 px-4">
                            <div className="flex items-center gap-3">
                              <img src={platformName === 'Google Ads' ? "/google_ads-512.webp" : "/6033716.png"} alt={platformName} className="w-5 h-5" />
                              <span className="text-gray-800">{platformName}</span>
                              <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
                            </div>
                          </td>
                          <td className="py-3 px-4 text-right">{formatCurrencyCompact(platformData.totals.cost)}</td>
                          <td className="py-3 px-4 text-right">{formatStat(platformData.totals.clicks)}</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyUnitTwo(platformData.totals.cpc)}</td>
                          <td className="py-3 px-4 text-right bg-green-50/40 text-green-700 font-medium">—</td>
                          <td className="py-3 px-4 text-right">{formatStat(platformData.totals.conversions)}</td>
                          <td className="py-3 px-4 text-right">{formatStat(platformData.totals.ga4_purchases)}</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyUnit(platformData.totals.cpa)}</td>
                          <td className="py-3 px-4 text-right">{platformData.totals.cr.toFixed(2)}%</td>
                          <td className="py-3 px-4 text-right">{platformData.totals.ga4_roas.toFixed(2)}x</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyCompact(platformData.totals.revenue)}</td>
                          <td className="py-3 px-4 text-right bg-green-50/40 text-green-700 font-medium">—</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyCompact(platformData.totals.ga4_total_revenue)}</td>
                          <td className="py-3 px-4 text-right">{platformData.totals.roas.toFixed(1)}x</td>
                          <td className="py-3 px-4 text-right">{formatStat(platformData.totals.ga4_sessions)}</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyUnitTwo(platformData.totals.cps)}</td>
                          <td className="py-3 px-4 text-right">
                            
                          </td>
                        </tr>
                        {isExpanded && (showAllTrendMonths[platformName] ? platformData.months : platformData.months.slice(0, 6)).map((month, index) => {
                          const usdCpc = getUsdValue(month.cpc, month.displayMonthKey);
                          const usdRevenue = getUsdValue(month.revenue, month.displayMonthKey);
                          return (
                          <tr key={index} className="bg-gray-50/30 divide-x divide-gray-100">
                            <td className="py-2 px-4 pl-8 text-gray-600">{month.month}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyCompact(month.cost)}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatStat(month.clicks)}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyUnitTwo(month.cpc)}</td>
                            <td className="py-2 px-4 text-right bg-green-50/40 text-green-700 font-medium">{usdCpc !== null ? `$${usdCpc.toFixed(2)}` : '—'}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatStat(month.conversions)}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatStat(month.ga4_purchases)}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyUnit(month.cpa)}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{month.cr.toFixed(2)}%</td>
                            <td className="py-2 px-4 text-right text-gray-600">{month.ga4_roas.toFixed(2)}x</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyCompact(month.revenue)}</td>
                            <td className="py-2 px-4 text-right bg-green-50/40 text-green-700 font-medium">{usdRevenue !== null ? `$${Math.round(usdRevenue).toLocaleString()}` : '—'}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyCompact(month.ga4_total_revenue)}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{month.roas.toFixed(1)}x</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatStat(month.ga4_sessions)}</td>
                            <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyUnitTwo(month.cps)}</td>
                           
                          </tr>
                          );
                        })}
                        {isExpanded && platformData.months.length > 6 && (
                          <tr>
                            <td colSpan={17} className="py-2 text-center bg-gray-50/30">
                              <button
                                onClick={(e) => { e.stopPropagation(); setShowAllTrendMonths(prev => ({...prev, [platformName]: !prev[platformName]})); }}
                                className="text-xs text-blue-600 hover:text-blue-800 font-medium transition-colors"
                              >
                                {showAllTrendMonths[platformName] ? "▲ Show less" : `▼ Show all ${platformData.months.length} months`}
                              </button>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-100 font-bold text-gray-800 divide-x divide-gray-100">
                    <td className="py-3 px-4">TOTAL</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyCompact(monthlyPerformanceData.Total.cost)}</td>
                    <td className="py-3 px-4 text-right">{formatStat(monthlyPerformanceData.Total.clicks)}</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyUnitTwo(monthlyPerformanceData.Total.cpc)}</td>
                    <td className="py-3 px-4 text-right bg-green-50/40 text-green-700">—</td>
                    <td className="py-3 px-4 text-right">{formatStat(monthlyPerformanceData.Total.conversions)}</td>
                    <td className="py-3 px-4 text-right">{formatStat(monthlyPerformanceData.Total.ga4_purchases)}</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyUnit(monthlyPerformanceData.Total.cpa)}</td>
                    <td className="py-3 px-4 text-right">{monthlyPerformanceData.Total.cr.toFixed(2)}%</td>
                    <td className="py-3 px-4 text-right">{monthlyPerformanceData.Total.ga4_roas.toFixed(2)}x</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyCompact(monthlyPerformanceData.Total.revenue)}</td>
                    <td className="py-3 px-4 text-right bg-green-50/40 text-green-700">—</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyCompact(monthlyPerformanceData.Total.ga4_total_revenue)}</td>
                    <td className="py-3 px-4 text-right">{monthlyPerformanceData.Total.roas.toFixed(1)}x</td>
                    <td className="py-3 px-4 text-right">{formatStat(monthlyPerformanceData.Total.ga4_sessions)}</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyUnitTwo(monthlyPerformanceData.Total.cps)}</td>
                    
                  </tr>
                </tfoot>
              </table>
            ) : (
              <div className="flex flex-col items-center justify-center py-16 px-4">
                <div className="text-gray-400 mb-2">
                  <BarChart3 className="w-12 h-12 mx-auto mb-2" />
                </div>
                <h3 className="text-lg font-medium text-gray-700 mb-1">No data available</h3>
                <p className="text-sm text-gray-500 text-center max-w-md">
                  No monthly performance trend data found for the selected date range. Please try a different date range or check back later.
                </p>
              </div>
            )}
          </div>
          
          {/* Bottom Section */}
          <div className="flex items-center justify-between mt-6">
            
            <button className="text-sm text-blue-600 font-medium hover:text-blue-700 flex items-center gap-1">
         
            </button>
            </div>
          </div>
        </Card>


      {/* Monthly Performance Trends (Duplicate, grouped by Campaign Category) */}
      {allowedBrandIdsForCategoryTable.has(currentBrandIdForView) && (
      <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] transition-all duration-300">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-50 rounded-xl">
                <BarChart2 className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-800">Monthly Performance Trends</h2>
                <p className="text-sm text-gray-500 mt-1">Platform based analysis</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-blue-50 rounded-lg border border-blue-100">
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500" />
                <span className="text-sm font-medium text-gray-800">Performance</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 bg-purple-50 rounded-lg border border-purple-100">
                <div className="w-2.5 h-2.5 rounded-full bg-purple-500" />
                <span className="text-sm font-medium text-gray-800">Branding</span>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto rounded-xl border border-gray-200">
            {isLoadingMonthly ? (
              <div className="flex justify-center items-center h-[200px]">
                  <div className="loading-logo-container">
                    <img src="/logoicon.png" alt="Glowytics Logo" className="loading-logo" />
                  </div>
              </div>
            ) : monthlyPlatformCategoryData ? (
              <table className="w-full text-sm table-auto">
                <thead>
                  <tr className="bg-gray-50/60 divide-x divide-gray-100">
                    <th className="py-3 px-4 text-left font-semibold text-gray-600 uppercase tracking-wider">Platform</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Spend</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Clicks</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">CPC</th>
                    <th className="py-3 px-4 text-right font-semibold text-green-600 uppercase tracking-wider bg-green-50/40">CPC ($)</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Conv.</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">GA4 Conv.</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">CPA</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">CR</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">GA4 ROAS</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Revenue</th>
                    <th className="py-3 px-4 text-right font-semibold text-green-600 uppercase tracking-wider bg-green-50/40">Revenue ($)</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">GA4 Revenue</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">ROAS</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Sessions</th>
                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">CPS</th>
                    
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {['Google Ads', 'Meta Ads'].map(platformName => {
                    const platformStruct = monthlyPlatformCategoryData[platformName];
                    if (!platformStruct) return null;
                    const isExpanded = expandedPlatforms2.includes(platformName);
                    
                    return (
                      <React.Fragment key={platformName}>
                      <tr className="bg-white hover:bg-gray-50/50 font-medium cursor-pointer divide-x divide-gray-100" onClick={() => togglePlatform2(platformName)}>
                          <td className="py-3 px-4">
                            <div className="flex items-center gap-3">
                              <img src={platformName === 'Google Ads' ? "/google_ads-512.webp" : "/6033716.png"} alt={platformName} className="w-5 h-5" />
                              <span className="text-gray-800">{platformName}</span>
                              <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
                            </div>
                          </td>
                          <td className="py-3 px-4 text-right">{formatCurrencyCompact(platformStruct.Total.cost)}</td>
                          <td className="py-3 px-4 text-right">{formatStat(platformStruct.Total.clicks)}</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyUnitTwo(platformStruct.Total.cpc)}</td>
                          <td className="py-3 px-4 text-right bg-green-50/40 text-green-700 font-medium">—</td>
                          <td className="py-3 px-4 text-right">{formatStat(platformStruct.Total.conversions)}</td>
                          <td className="py-3 px-4 text-right">{formatStat(platformStruct.Total.ga4_purchases)}</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyUnit(platformStruct.Total.cpa)}</td>
                          <td className="py-3 px-4 text-right">{platformStruct.Total.cr.toFixed(2)}%</td>
                          <td className="py-3 px-4 text-right">{platformStruct.Total.ga4_roas.toFixed(2)}x</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyCompact(platformStruct.Total.revenue)}</td>
                          <td className="py-3 px-4 text-right bg-green-50/40 text-green-700 font-medium">—</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyCompact(platformStruct.Total.ga4_total_revenue)}</td>
                          <td className="py-3 px-4 text-right">{platformStruct.Total.roas.toFixed(1)}x</td>
                          <td className="py-3 px-4 text-right">{formatStat(platformStruct.Total.ga4_sessions)}</td>
                          <td className="py-3 px-4 text-right">{formatCurrencyUnitTwo(platformStruct.Total.cps)}</td>
                          <td className="py-3 px-4 text-right">
                            
                          </td>
                        </tr>
                        {isExpanded && ['Performance','Branding'].map(category => {
                          const catData = platformStruct[category];
                          if (!catData || !catData.months || catData.months.length === 0) return null;
                          const catKey = `${platformName}:${category}`;
                          const catOpen = !!expandedCategories2[catKey];
                          return (
                            <React.Fragment key={catKey}>
                          <tr className="bg-gray-50/40 cursor-pointer divide-x divide-gray-100" onClick={() => toggleCategory2(catKey)}>
                                <td className="py-2 px-4 pl-8 text-gray-700">
                                  <div className="flex items-center gap-2">
                                    <div className={`w-2.5 h-2.5 rounded-full ${category === 'Performance' ? 'bg-blue-500' : 'bg-purple-500'}`} />
                                    <span className="font-medium">{category}</span>
                                    <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform ${catOpen ? 'rotate-180' : ''}`} />
                                  </div>
                                </td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatCurrencyCompact(catData.totals.cost)}</td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatStat(catData.totals.clicks)}</td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatCurrencyUnitTwo(catData.totals.cpc)}</td>
                                <td className="py-2 px-4 text-right bg-green-50/40 text-green-700 font-medium">—</td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatStat(catData.totals.conversions)}</td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatStat(catData.totals.ga4_purchases)}</td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatCurrencyUnit(catData.totals.cpa)}</td>
                                <td className="py-2 px-4 text-right text-gray-700">{catData.totals.cr.toFixed(2)}%</td>
                                <td className="py-2 px-4 text-right text-gray-700">{catData.totals.ga4_roas.toFixed(2)}x</td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatCurrencyCompact(catData.totals.revenue)}</td>
                                <td className="py-2 px-4 text-right bg-green-50/40 text-green-700 font-medium">—</td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatCurrencyCompact(catData.totals.ga4_total_revenue)}</td>
                                <td className="py-2 px-4 text-right text-gray-700">{catData.totals.roas.toFixed(1)}x</td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatStat(catData.totals.ga4_sessions)}</td>
                                <td className="py-2 px-4 text-right text-gray-700">{formatCurrencyUnitTwo(catData.totals.cps)}</td>
                              </tr>
                              {catOpen && (showAllTrendMonths[`cat_${catKey}`] ? catData.months : catData.months.slice(0, 6)).map((month, index) => {
                                const usdCpc2 = getUsdValue(month.cpc, month.displayMonthKey);
                                const usdRevenue2 = getUsdValue(month.revenue, month.displayMonthKey);
                                return (
                                <tr key={`${catKey}:${index}`} className="bg-gray-50/20 divide-x divide-gray-100">
                                  <td className="py-2 px-4 pl-16 text-gray-600">{month.month}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyCompact(month.cost)}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatStat(month.clicks)}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyUnitTwo(month.cpc)}</td>
                                  <td className="py-2 px-4 text-right bg-green-50/40 text-green-700 font-medium">{usdCpc2 !== null ? `$${usdCpc2.toFixed(2)}` : '—'}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatStat(month.conversions)}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatStat(month.ga4_purchases)}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyUnit(month.cpa)}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{month.cr.toFixed(2)}%</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{month.ga4_roas.toFixed(2)}x</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyCompact(month.revenue)}</td>
                                  <td className="py-2 px-4 text-right bg-green-50/40 text-green-700 font-medium">{usdRevenue2 !== null ? `$${Math.round(usdRevenue2).toLocaleString()}` : '—'}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyCompact(month.ga4_total_revenue)}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{month.roas.toFixed(1)}x</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatStat(month.ga4_sessions)}</td>
                                  <td className="py-2 px-4 text-right text-gray-600">{formatCurrencyUnitTwo(month.cps)}</td>
                                </tr>
                                );
                              })}
                              {catOpen && catData.months.length > 6 && (
                                <tr>
                                  <td colSpan={17} className="py-2 text-center bg-gray-50/20">
                                    <button
                                      onClick={(e) => { e.stopPropagation(); setShowAllTrendMonths(prev => ({...prev, [`cat_${catKey}`]: !prev[`cat_${catKey}`]})); }}
                                      className="text-xs text-blue-600 hover:text-blue-800 font-medium transition-colors"
                                    >
                                      {showAllTrendMonths[`cat_${catKey}`] ? "▲ Show less" : `▼ Show all ${catData.months.length} months`}
                                    </button>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-100 font-bold text-gray-800 divide-x divide-gray-100">
                    <td className="py-3 px-4">TOTAL</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyCompact(monthlyPlatformCategoryData.Total.cost)}</td>
                    <td className="py-3 px-4 text-right">{formatStat(monthlyPlatformCategoryData.Total.clicks)}</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyUnitTwo(monthlyPlatformCategoryData.Total.cpc)}</td>
                    <td className="py-3 px-4 text-right bg-green-50/40 text-green-700">—</td>
                    <td className="py-3 px-4 text-right">{formatStat(monthlyPlatformCategoryData.Total.conversions)}</td>
                    <td className="py-3 px-4 text-right">{formatStat(monthlyPlatformCategoryData.Total.ga4_purchases)}</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyUnit(monthlyPlatformCategoryData.Total.cpa)}</td>
                    <td className="py-3 px-4 text-right">{monthlyPlatformCategoryData.Total.cr.toFixed(2)}%</td>
                    <td className="py-3 px-4 text-right">{monthlyPlatformCategoryData.Total.ga4_roas.toFixed(2)}x</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyCompact(monthlyPlatformCategoryData.Total.revenue)}</td>
                    <td className="py-3 px-4 text-right bg-green-50/40 text-green-700">—</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyCompact(monthlyPlatformCategoryData.Total.ga4_total_revenue)}</td>
                    <td className="py-3 px-4 text-right">{monthlyPlatformCategoryData.Total.roas.toFixed(1)}x</td>
                    <td className="py-3 px-4 text-right">{formatStat(monthlyPlatformCategoryData.Total.ga4_sessions)}</td>
                    <td className="py-3 px-4 text-right">{formatCurrencyUnitTwo(monthlyPlatformCategoryData.Total.cps)}</td>
                    
                  </tr>
                </tfoot>
              </table>
            ) : (
              <div className="flex flex-col items-center justify-center py-16 px-4">
                <div className="text-gray-400 mb-2">
                  <BarChart3 className="w-12 h-12 mx-auto mb-2" />
                </div>
                <h3 className="text-lg font-medium text-gray-700 mb-1">No data available</h3>
                <p className="text-sm text-gray-500 text-center max-w-md">
                  No monthly performance trend data found for the selected date range. Please try a different date range or check back later.
                </p>
              </div>
            )}
          </div>
          
          {/* Bottom Section */}
          <div className="flex items-center justify-between mt-6">
            
            <button className="text-sm text-blue-600 font-medium hover:text-blue-700 flex items-center gap-1">
         
            </button>
            </div>
          </div>
        </Card>
      )}

      <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] transition-all duration-300">
            <div className="p-6">
                <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3">
                        <div className="p-2">
                            <img src="/GA4logoicon.svg" className="w-5 h-5" alt="GA4" />
                        </div>
                        <div>
                            <h2 className="text-lg font-semibold text-gray-800">Google Analytics Monthly Summary</h2>
                            <p className="text-sm text-gray-500 mt-1">Overall traffic and engagement metrics</p>
                        </div>
                    </div>
                </div>
          <div className="overflow-x-auto rounded-xl border border-gray-200">
                    {isLoadingGaTrafficSource ? (
                        <div className="flex justify-center items-center h-[200px]">
                            <div className="loading-logo-container">
                                <img src="/logoicon.png" alt="Glowytics Logo" className="loading-logo" />
                            </div>
                        </div>
                    ) : gaMonthlySummary ? (
                        <>
                        <table className="w-full text-sm table-fixed">
                            <thead>
                                <tr className="bg-gray-50/60 divide-x divide-gray-100">
                                    <th className="py-3 px-4 text-left font-semibold text-gray-600 uppercase tracking-wider">Month</th>
                                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Sessions</th>
                                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Users</th>
                                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Transactions</th>
                                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Revenue</th>
                                    <th className="py-3 px-4 text-right font-semibold text-green-600 uppercase tracking-wider bg-green-50/40">Revenue ($)</th>
                                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">All Costs</th>
                                    <th className="py-3 px-4 text-right font-semibold text-green-600 uppercase tracking-wider bg-green-50/40">All Costs ($)</th>
                                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Total ROI</th>
                                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Avg. Order Value</th>
                                    <th className="py-3 px-4 text-right font-semibold text-gray-600 uppercase tracking-wider">Conv. Rate</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {(showAllGaMonths ? gaMonthlySummary.monthlyData : gaMonthlySummary.monthlyData.slice(0, 6)).map((row, index) => {
                                    const gaUsdRevenue = getUsdValue(row.totalRevenue, row.displayMonthKey);
                                    const gaAllCostTry = Number(allCostsByMonth[row.month] || 0);
                                    const gaUsdCost = getUsdValue(gaAllCostTry, row.displayMonthKey);
                                    return (
                                    <tr key={index} className="hover:bg-green-50/30 transition-colors divide-x divide-gray-100">
                                        <td className="py-3 px-4 font-medium text-sm text-gray-800">{row.month}</td>
                                        <td className="py-3 px-4 text-right text-sm text-gray-700">{formatStat(row.sessions)}</td>
                                        <td className="py-3 px-4 text-right text-sm text-gray-700">{formatStat(row.users)}</td>
                                        <td className="py-3 px-4 text-right text-sm text-gray-700">{row.eventCount.toLocaleString()}</td>
                                        <td className="py-3 px-4 text-right text-sm text-gray-700">₺{row.totalRevenue.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
                                        <td className="py-3 px-4 text-right text-sm bg-green-50/40 text-green-700 font-medium">{gaUsdRevenue !== null ? `$${Math.round(gaUsdRevenue).toLocaleString()}` : '—'}</td>
                                        <td className="py-3 px-4 text-right text-sm text-gray-700">₺{gaAllCostTry.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
                                        <td className="py-3 px-4 text-right text-sm bg-green-50/40 text-green-700 font-medium">{gaUsdCost !== null ? `$${Math.round(gaUsdCost).toLocaleString()}` : '—'}</td>
                                        <td className="py-3 px-4 text-right text-sm text-gray-700">{(() => {
                                          const cost = Number(allCostsByMonth[row.month] || 0);
                                          const revenue = Number(row.totalRevenue || 0);
                                          const roi = cost > 0 ? (revenue / cost) : 0;
                                          return `${roi.toFixed(2)}x`;
                                        })()}</td>
                                        <td className="py-3 px-4 text-right text-sm text-gray-700">₺{((row.eventCount > 0 ? (row.totalRevenue / row.eventCount) : 0)).toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
                                        <td className="py-3 px-4 text-right text-sm text-gray-700">{row.conversionRate.toFixed(2)}%</td>
                                    </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                              <tr className="bg-gray-100 font-bold text-gray-800 divide-x divide-gray-100">
                                <td className="py-3 px-4">TOTAL</td>
                                <td className="py-3 px-4 text-right">{formatStat(gaMonthlySummary.totals.sessions)}</td>
                                <td className="py-3 px-4 text-right">{formatStat(gaMonthlySummary.totals.users)}</td>
                                <td className="py-3 px-4 text-right">{gaMonthlySummary.totals.eventCount.toLocaleString()}</td>
                                <td className="py-3 px-4 text-right">₺{gaMonthlySummary.totals.totalRevenue.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
                                <td className="py-3 px-4 text-right bg-green-50/40 text-green-700">—</td>
                                <td className="py-3 px-4 text-right">₺{(Number(totalAllCosts || 0)).toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
                                <td className="py-3 px-4 text-right bg-green-50/40 text-green-700">—</td>
                                <td className="py-3 px-4 text-right">{(() => {
                                  const cost = Number(totalAllCosts || 0);
                                  const revenue = Number(gaMonthlySummary.totals.totalRevenue || 0);
                                  const roi = cost > 0 ? (revenue / cost) : 0;
                                  return `${roi.toFixed(2)}x`;
                                })()}</td>
                                <td className="py-3 px-4 text-right">₺{((gaMonthlySummary.totals.eventCount > 0 ? (gaMonthlySummary.totals.totalRevenue / gaMonthlySummary.totals.eventCount) : 0)).toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
                                <td className="py-3 px-4 text-right">{gaMonthlySummary.totals.conversionRate.toFixed(2)}%</td>
                              </tr>
                            </tfoot>
                        </table>
                        {gaMonthlySummary.monthlyData.length > 6 && (
                          <div className="flex justify-center py-3 border-t border-gray-100">
                            <button
                              onClick={() => setShowAllGaMonths(prev => !prev)}
                              className="text-sm text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1 transition-colors"
                            >
                              {showAllGaMonths ? 'Show Last 6 Months' : `Show All ${gaMonthlySummary.monthlyData.length} Months`}
                              <svg className={`w-4 h-4 transition-transform ${showAllGaMonths ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                            </button>
                          </div>
                        )}
                        </>
                    ) : (
                        <div className="flex flex-col items-center justify-center py-16 px-4">
                            <div className="text-gray-400 mb-2">
                                <BarChart3 className="w-12 h-12 mx-auto mb-2" />
                            </div>
                            <h3 className="text-lg font-medium text-gray-700 mb-1">No GA data available</h3>
                            <p className="text-sm text-gray-500 text-center max-w-md">
                                Could not find monthly aggregated Google Analytics data.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </Card>

        {/* New Dual Tables at the bottom of Performance Overview */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
          {/* Left Table Card */}
          <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] transition-all duration-300">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-blue-50 rounded-lg border border-blue-100">
                  <BarChart3 className="w-4 h-4 text-blue-600" />
                </div>
                <h3 className="text-sm font-semibold text-gray-800">{`Weekday ${weeklyMetric === 'revenue' ? 'Revenue' : weeklyMetric === 'transactions' ? 'Transactions' : weeklyMetric === 'sessions' ? 'Sessions' : 'CR%'} (by Week)`}</h3>
              </div>
              <div className="flex items-center gap-2">
                <Menu as="div" className="relative inline-block text-left">
                  <div>
                    <Menu.Button className="inline-flex justify-center w-full rounded-md border border-gray-200 px-3 py-1.5 bg-white text-xs font-medium text-gray-700 hover:bg-gray-50">
                      {(() => {
                        switch (weeklyMetric) {
                          case 'transactions': return 'Transactions';
                          case 'sessions': return 'Sessions';
                          case 'cr': return 'CR %';
                          default: return 'Revenue';
                        }
                      })()}
                      <ChevronDown className="-mr-1 ml-2 h-4 w-4" aria-hidden="true" />
                    </Menu.Button>
                  </div>
                  <Menu.Items className="absolute right-0 mt-2 w-36 origin-top-right rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                    <div className="py-1 text-xs">
                      <Menu.Item>
                        {({ active }) => (
                          <button onClick={() => setWeeklyMetric('revenue')} className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} block w-full px-3 py-2 text-left`}>Revenue</button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button onClick={() => setWeeklyMetric('transactions')} className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} block w-full px-3 py-2 text-left`}>Transactions</button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button onClick={() => setWeeklyMetric('sessions')} className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} block w-full px-3 py-2 text-left`}>Sessions</button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button onClick={() => setWeeklyMetric('cr')} className={`${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'} block w-full px-3 py-2 text-left`}>CR %</button>
                        )}
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Menu>
              </div>
            </div>
            <div className="rounded-xl border border-gray-200 overflow-x-auto">
              <table className="w-full text-xs table-fixed">
                <thead>
                  <tr className="bg-gray-50/60">
                    <th className="py-2 px-2 text-left font-semibold text-gray-600 uppercase tracking-wider border-r border-gray-200 w-16">Week</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 uppercase tracking-wider border-x border-gray-200 w-16">Mon</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 uppercase tracking-wider border-x border-gray-200 w-16">Tue</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 uppercase tracking-wider border-x border-gray-200 w-16">Wed</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 uppercase tracking-wider border-x border-gray-200 w-16">Thu</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 uppercase tracking-wider border-x border-gray-200 w-16">Fri</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 uppercase tracking-wider border-x border-gray-200 w-16">Sat</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 uppercase tracking-wider border-l border-gray-200 w-16">Sun</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 uppercase tracking-wider border-l border-gray-200 w-16">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {weeklyRevenueByWeekday && weeklyRevenueByWeekday.length > 0 ? (
                    weeklyRevenueByWeekday.map((row, idx) => (
                      <tr key={idx} className="hover:bg-blue-50/20">
                        <td className="py-2 px-2 text-xs font-medium text-gray-800 border border-gray-100 w-16">{row.weekKey}</td>
                        {row.days.map((v, i) => (
                          <td key={i} className="py-2 px-2 text-right text-xs text-gray-800 border border-gray-100 w-16">
                            <div className="flex flex-col items-end leading-tight">
                              <span>
                                {weeklyMetric === 'cr' ? `${Number(v || 0).toFixed(2)}%` : (weeklyMetric === 'sessions' || weeklyMetric === 'transactions') ? Number(v || 0).toLocaleString() : formatCurrencyCompact(v)}
                              </span>
                              <span className="text-[10px] text-gray-400">{row.dates[i] ? new Date(row.dates[i]).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '-'}</span>
                            </div>
                          </td>
                        ))}
                        <td className="py-2 px-2 text-right text-xs font-semibold text-gray-900 border border-gray-100 w-16">
                          {weeklyMetric === 'cr' ? `${Number(row.total || 0).toFixed(2)}%` : (weeklyMetric === 'sessions' || weeklyMetric === 'transactions') ? Number(row.total || 0).toLocaleString() : formatCurrencyCompact(row.total)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="py-10 text-center text-gray-500">No data</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card>

          {/* Right Table Card */}
          <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] transition-all duration-300">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-purple-50 rounded-lg border border-purple-100">
                  <BarChart2 className="w-4 h-4 text-purple-600" />
                </div>
                <h3 className="text-sm font-semibold text-gray-800">{`Week-over-Week Summary (${weeklyMetric === 'revenue' ? 'Revenue' : weeklyMetric === 'transactions' ? 'Transactions' : weeklyMetric === 'sessions' ? 'Sessions' : 'CR%'})`}</h3>
              </div>
            </div>
            <div className="rounded-xl border border-gray-200 overflow-x-auto">
              <table className="w-full text-xs table-fixed">
                <thead>
                  <tr className="bg-gray-50/60">
                    <th className="py-2 px-2 text-left font-semibold text-gray-600 text-[10px] uppercase tracking-wider w-16">Week</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 text-[10px] uppercase tracking-wider w-16">Revenue</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 text-[10px] uppercase tracking-wider w-16">Trans.</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 text-[10px] uppercase tracking-wider w-16">Sess.</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 text-[10px] uppercase tracking-wider w-16">CR %</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 text-[10px] uppercase tracking-wider w-16">Δ Rev</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 text-[10px] uppercase tracking-wider w-16">Δ Trans</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 text-[10px] uppercase tracking-wider w-16">Δ Sess</th>
                    <th className="py-2 px-2 text-right font-semibold text-gray-600 text-[10px] uppercase tracking-wider w-16">Δ CR</th>
                  </tr>
                </thead>
                <tbody>
                  {weeklyWoWSummary && weeklyWoWSummary.length > 0 ? (
                    weeklyWoWSummary.map((r, idx) => (
                      <tr key={idx} className="hover:bg-purple-50/20">
                        <td className="py-2 px-2 text-xs font-medium text-gray-800 border border-gray-100 w-16">{r.weekKey}</td>
                        <td className="py-2 px-2 text-right text-xs text-gray-800 border border-gray-100 w-16">{formatCurrencyCompact(r.revenue)}</td>
                        <td className="py-2 px-2 text-right text-xs text-gray-800 border border-gray-100 w-16">{Number(r.transactions).toLocaleString()}</td>
                        <td className="py-2 px-2 text-right text-xs text-gray-800 border border-gray-100 w-16">{Number(r.sessions).toLocaleString()}</td>
                        <td className="py-2 px-2 text-right text-xs text-gray-800 border border-gray-100 w-16">{r.cr.toFixed(2)}%</td>
                        <td className={`py-2 px-2 text-right text-xs border border-gray-100 w-16 ${r.deltas.rev >= 0 ? 'text-green-600' : 'text-red-600'}`}>{`${r.deltas.rev >= 0 ? '▲' : '▼'} ${Math.abs(r.deltas.rev).toFixed(1)}%`}</td>
                        <td className={`py-2 px-2 text-right text-xs border border-gray-100 w-16 ${r.deltas.trans >= 0 ? 'text-green-600' : 'text-red-600'}`}>{`${r.deltas.trans >= 0 ? '▲' : '▼'} ${Math.abs(r.deltas.trans).toFixed(1)}%`}</td>
                        <td className={`py-2 px-2 text-right text-xs border border-gray-100 w-16 ${r.deltas.sess >= 0 ? 'text-green-600' : 'text-red-600'}`}>{`${r.deltas.sess >= 0 ? '▲' : '▼'} ${Math.abs(r.deltas.sess).toFixed(1)}%`}</td>
                        <td className={`py-2 px-2 text-right text-xs border border-gray-100 w-16 ${r.deltas.cr >= 0 ? 'text-green-600' : 'text-red-600'}`}>{`${r.deltas.cr >= 0 ? '▲' : '▼'} ${Math.abs(r.deltas.cr).toFixed(1)}%`}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="py-10 text-center text-gray-500">No data</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card>
        </div>

        </div>
      )}



      {activeTab === 'ecommerce' && !isMarketer && (
        <div className="space-y-6">
          {/* E-commerce Summary Cards - Mobile Responsive */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Total Sales</span>
                <div className="p-1.5 bg-blue-100 rounded-lg">
                  <DollarSign className="w-3.5 h-3.5 text-blue-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">{isLoadingEcommerce.daily ? <Loader2 className="w-5 h-5 animate-spin" /> : `₺${(dailyProductData.totals.totalRevenue || 0).toLocaleString()}`}</span>
                <span className={`text-sm font-medium ${dailyProductData.changes?.revenue >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {isLoadingEcommerce.daily ? '' : `${dailyProductData.changes.revenue >= 0 ? '▲' : '▼'}${Math.abs(dailyProductData.changes.revenue || 0).toFixed(1)}%`}
                </span>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Avg Order Value</span>
                <div className="p-1.5 bg-green-100 rounded-lg">
                  <ShoppingCart className="w-3.5 h-3.5 text-green-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                 <span className="text-xl md:text-2xl font-bold text-gray-800">{isLoadingEcommerce.daily ? <Loader2 className="w-5 h-5 animate-spin" /> : `₺${(dailyProductData.totals.avgOrderValue || 0).toLocaleString()}`}</span>
                 <span className={`text-sm font-medium ${dailyProductData.changes?.avgOrderValue >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                   {isLoadingEcommerce.daily ? '' : `${dailyProductData.changes.avgOrderValue >= 0 ? '▲' : '▼'}${Math.abs(dailyProductData.changes.avgOrderValue || 0).toFixed(1)}%`}
                 </span>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-4 border border-purple-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Total Orders</span>
                <div className="p-1.5 bg-purple-100 rounded-lg">
                  <FileText className="w-3.5 h-3.5 text-purple-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                 <span className="text-xl md:text-2xl font-bold text-gray-800">{isLoadingEcommerce.daily ? <Loader2 className="w-5 h-5 animate-spin" /> : (dailyProductData.totals.totalItemsPurchased || 0).toLocaleString()}</span>
                 <span className={`text-sm font-medium ${dailyProductData.changes?.unitsSold >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                   {isLoadingEcommerce.daily ? '' : `${dailyProductData.changes.unitsSold >= 0 ? '▲' : '▼'}${Math.abs(dailyProductData.changes.unitsSold || 0).toFixed(1)}%`}
                 </span>
              </div>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-4 border border-amber-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Total Units Sold</span>
                <div className="p-1.5 bg-amber-100 rounded-lg">
                  <Package className="w-3.5 h-3.5 text-amber-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">{isLoadingEcommerce.daily ? <Loader2 className="w-5 h-5 animate-spin" /> : (dailyProductData.totals.totalItemsPurchased || 0).toLocaleString()}</span>
                <span className={`text-sm font-medium ${dailyProductData.changes?.unitsSold >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                   {isLoadingEcommerce.daily ? '' : `${dailyProductData.changes.unitsSold >= 0 ? '▲' : '▼'}${Math.abs(dailyProductData.changes.unitsSold || 0).toFixed(1)}%`}
                 </span>
              </div>
            </div>
          </div>

          {/* Best Products and Category Performance - Mobile Responsive */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Best Selling Products */}
            <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] transition-all duration-300">
              <div className="flex flex-col gap-4 mb-6 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">Best Selling Products</h2>
                  <p className="text-sm text-gray-500 mt-1">Top performers by revenue</p>
                </div>
                <div className="flex items-center gap-2">
                  <select className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white">
                    <option>By Revenue</option>
                    <option>By Units</option>
                  </select>
                </div>
              </div>
              <div className="space-y-3 max-h-80 overflow-y-auto">
                 {isLoadingEcommerce.products ? (
                   <div className="flex justify-center items-center h-48">
                      <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
                   </div>
                 ) : topProducts.length > 0 ? (
                    topProducts.map((product, index) => (
                      <div key={index} className="flex items-center justify-between p-2 rounded-lg hover:bg-gray-50">
                        <div className="flex items-center gap-3">
                          <span className="font-medium text-gray-500 text-sm w-6 text-center">{index + 1}</span>
                          <div>
                            <p className="font-medium text-gray-800 text-sm truncate" title={product.itemName}>{product.itemName}</p>
                            <p className="text-xs text-gray-400">{product.itemBrand || 'N/A'}</p>
                          </div>
                        </div>
                        <div className="text-right">
                           <p className="font-semibold text-gray-800 text-sm">₺{(product.totalRevenue || 0).toLocaleString('tr-TR', {maximumFractionDigits: 0})}</p>
                           <p className="text-xs text-gray-500">{(product.totalItemsPurchased || 0)} units</p>
                        </div>
                      </div>
                    ))
                 ) : (
                    <div className="text-center py-8">
                      <div className="text-gray-400 mb-2">No product data available</div>
                      <div className="text-sm text-gray-500">Product analytics will appear here when data is available</div>
                    </div>
                 )}
              </div>
            </Card>

            {/* Category Performance */}
            <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] hover:!shadow-[0_8px_28px_rgba(0,0,0,0.15)] transition-all duration-300">
              <div className="flex flex-col gap-4 mb-6 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">Category Performance</h2>
                  <p className="text-sm text-gray-500 mt-1">Sales by category</p>
                </div>
                <button className="text-sm text-blue-600 font-medium hover:text-blue-700 self-start sm:self-auto">View All</button>
              </div>
              {/* Chart and List Section - Mobile Responsive */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="h-[250px] flex items-center justify-center">
                  {isLoadingEcommerce.categories ? (
                      <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
                   ) : categoryPerformance.length > 0 ? (
                      <DoughnutChart data={{
                        labels: categoryPerformance.slice(0, 5).map(c => c.itemCategory),
                        datasets: [{
                          data: categoryPerformance.slice(0, 5).map(c => c.totalRevenue),
                          backgroundColor: ['#3B82F6', '#10B981', '#F59E0B', '#8B5CF6', '#EC4899'],
                        }]
                      }} />
                   ) : (
                      <div className="text-center text-gray-500">No category data</div>
                   )}
                </div>
                 <div className="space-y-3 max-h-[250px] overflow-y-auto">
                    {isLoadingEcommerce.categories ? (
                      <div className="text-center text-sm text-gray-500">Loading...</div>
                    ) : categoryPerformance.length > 0 ? (
                      categoryPerformance.sort((a,b) => b.totalRevenue - a.totalRevenue).map((cat, index) => (
                        <div key={index} className="flex items-center justify-between text-sm">
                           <div className="flex items-center gap-2">
                            <div className={`w-2.5 h-2.5 rounded-full ${['bg-blue-500', 'bg-green-500', 'bg-yellow-500', 'bg-purple-500', 'bg-pink-500'][index % 5]}`}></div>
                            <span className="text-gray-700">{cat.itemCategory}</span>
                          </div>
                           <span className="font-medium text-gray-800">₺{(cat.totalRevenue || 0).toLocaleString('tr-TR', {maximumFractionDigits: 0})}</span>
                        </div>
                      ))
                    ) : (
                      <div className="text-center text-sm text-gray-500">No data</div>
                    )}
                 </div>
              </div>
            </Card>
          </div>


        </div>
      )}

      {activeTab === 'traffic' && !isMarketer && (
        <div className="space-y-6">
          {/* Google Analytics Overview */}
          <Card className="rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] hover:!shadow-[0_8px_28px_rgba(0,0,0,0.15)] transition-all duration-300">
        <div className="p-6">
          <div className="flex flex-col gap-4 mb-6 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-50 rounded-xl">
                <Activity className="w-5 h-5 text-blue-600" />
              </div>
            <div>
                <h2 className="text-lg font-semibold text-gray-800">Google Analytics Overview</h2>
                <p className="text-sm text-gray-500 mt-1">Traffic sources and e-commerce performance</p>
              </div>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <div className="flex items-center bg-gray-100 rounded-lg p-1 overflow-x-auto">
                {gaDateFilters.map(filter => (
                  <button 
                    key={filter.value}
                    onClick={() => setGaDateRange(filter.value)}
                    className={`px-3 py-1.5 text-xs font-medium transition-colors whitespace-nowrap ${
                      gaDateRange === filter.value 
                        ? 'bg-blue-600 text-white rounded-md shadow-sm' 
                        : 'text-gray-600 hover:text-gray-800'
                    }`}
                  >
                    {filter.label}
                  </button>
                ))}
              </div>
              <button className="flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium text-blue-600 hover:text-blue-700 bg-blue-50 border border-blue-100 rounded-lg hover:bg-blue-100 transition-colors">
                <ExternalLink className="w-4 h-4" />
                <span className="hidden sm:inline">Open GA</span>
                <span className="sm:hidden">GA</span>
              </button>
            </div>
          </div>

          {/* Key Metrics Cards - Mobile Responsive */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Sessions</span>
                <div className="p-1.5 bg-blue-100 rounded-lg">
                  <Users className="w-3.5 h-3.5 text-blue-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">
                  {isLoadingGaTrafficSource ? (
                    <div className="h-6 bg-gray-200 rounded w-16 animate-pulse"></div>
                  ) : (
                    (gaTrafficSourceData?.totals?.sessions || 0).toLocaleString()
                  )}
                </span>
                {gaTrafficSourceData?.recentSummary?.last30Days && gaTrafficSourceData?.recentSummary?.previous30Days && (
                  <span className="text-sm font-medium text-green-600">
                    {(() => {
                      const current = gaTrafficSourceData.recentSummary.last30Days.sessions || 0;
                      const previous = gaTrafficSourceData.recentSummary.previous30Days.sessions || 0;
                      const change = previous > 0 ? ((current - previous) / previous * 100) : 0;
                      return `${change > 0 ? '+' : ''}${change.toFixed(1)}%`;
                    })()}
                  </span>
                )}
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-4 border border-indigo-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Transactions</span>
                <div className="p-1.5 bg-indigo-100 rounded-lg">
                  <ShoppingCart className="w-3.5 h-3.5 text-indigo-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">
                  {isLoadingGaTrafficSource ? (
                    <div className="h-6 bg-gray-200 rounded w-16 animate-pulse"></div>
                  ) : (
                    (gaTrafficSourceData?.totals?.eventCount || 0).toLocaleString()
                  )}
                </span>
                {gaTrafficSourceData?.recentSummary?.last30Days && gaTrafficSourceData?.recentSummary?.previous30Days && (
                  <span className="text-sm font-medium text-green-600">
                    {(() => {
                      const current = gaTrafficSourceData.recentSummary.last30Days.eventCount || 0;
                      const previous = gaTrafficSourceData.recentSummary.previous30Days.eventCount || 0;
                      const change = previous > 0 ? ((current - previous) / previous * 100) : 0;
                      return `${change > 0 ? '+' : ''}${change.toFixed(1)}%`;
                    })()}
                  </span>
                )}
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Revenue</span>
                <div className="p-1.5 bg-green-100 rounded-lg">
                  <TrendingUp className="w-3.5 h-3.5 text-green-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">
                  {isLoadingGaTrafficSource ? (
                    <div className="h-6 bg-gray-200 rounded w-20 animate-pulse"></div>
                  ) : (
                    `₺${(gaTrafficSourceData?.totals?.totalRevenue || 0).toLocaleString()}`
                  )}
                </span>
                {gaTrafficSourceData?.recentSummary?.last30Days && gaTrafficSourceData?.recentSummary?.previous30Days && (
                  <span className="text-sm font-medium text-green-600">
                    {(() => {
                      const current = gaTrafficSourceData.recentSummary.last30Days.totalRevenue || 0;
                      const previous = gaTrafficSourceData.recentSummary.previous30Days.totalRevenue || 0;
                      const change = previous > 0 ? ((current - previous) / previous * 100) : 0;
                      return `${change > 0 ? '+' : ''}${change.toFixed(1)}%`;
                    })()}
                  </span>
                )}
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-xl p-4 border border-emerald-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Conversion Rate</span>
                <div className="p-1.5 bg-emerald-100 rounded-lg">
                  <Target className="w-3.5 h-3.5 text-emerald-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">
                  {isLoadingGaTrafficSource ? (
                    <div className="h-6 bg-gray-200 rounded w-12 animate-pulse"></div>
                  ) : (
                    (() => {
                      const sessions = gaTrafficSourceData?.totals?.sessions || 0;
                      const transactions = gaTrafficSourceData?.totals?.eventCount || 0;
                      const conversionRate = sessions > 0 ? (transactions / sessions) * 100 : 0;
                      return `${conversionRate.toFixed(2)}%`;
                    })()
                  )}
                </span>
                {gaTrafficSourceData?.recentSummary?.last30Days && gaTrafficSourceData?.recentSummary?.previous30Days && (
                  <span className="text-sm font-medium text-green-600">
                    {(() => {
                      const currentSessions = gaTrafficSourceData.recentSummary.last30Days.sessions || 0;
                      const currentTransactions = gaTrafficSourceData.recentSummary.last30Days.eventCount || 0;
                      const previousSessions = gaTrafficSourceData.recentSummary.previous30Days.sessions || 0;
                      const previousTransactions = gaTrafficSourceData.recentSummary.previous30Days.eventCount || 0;
                      
                      const currentRate = currentSessions > 0 ? (currentTransactions / currentSessions) * 100 : 0;
                      const previousRate = previousSessions > 0 ? (previousTransactions / previousSessions) * 100 : 0;
                      const change = previousRate > 0 ? ((currentRate - previousRate) / previousRate * 100) : 0;
                      return `${change > 0 ? '+' : ''}${change.toFixed(1)}%`;
                    })()}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Analytics Table */}
          <div className="overflow-x-auto rounded-xl border border-gray-200">
            <table className="w-full table-fixed">
              <thead>
                <tr className="bg-gray-50">
                  <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">Source / Medium</th>
                  <th className="py-3 px-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">Sessions</th>
                  <th className="py-3 px-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">Transactions</th>
                  <th className="py-3 px-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">Revenue</th>
                  <th className="py-3 px-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">Conv. Rate</th>
                  <th className="py-3 px-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-200">Avg. Order Value</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {isLoadingGaTrafficSource ? (
                  // Loading state for table
                  [...Array(5)].map((_, index) => (
                    <tr key={index} className="animate-pulse">
                      <td className="py-3 px-4">
                        <div className="h-4 bg-gray-200 rounded w-24"></div>
                        <div className="h-3 bg-gray-200 rounded w-16 mt-1"></div>
                      </td>
                      <td className="py-3 px-4 text-right">
                        <div className="h-4 bg-gray-200 rounded w-16 ml-auto"></div>
                        <div className="h-3 bg-gray-200 rounded w-10 ml-auto mt-1"></div>
                      </td>
                      <td className="py-3 px-4 text-right">
                        <div className="h-4 bg-gray-200 rounded w-12 ml-auto"></div>
                        <div className="h-3 bg-gray-200 rounded w-8 ml-auto mt-1"></div>
                      </td>
                      <td className="py-3 px-4 text-right">
                        <div className="h-4 bg-gray-200 rounded w-20 ml-auto"></div>
                        <div className="h-3 bg-gray-200 rounded w-12 ml-auto mt-1"></div>
                      </td>
                      <td className="py-3 px-4 text-right">
                        <div className="h-4 bg-gray-200 rounded w-12 ml-auto"></div>
                        <div className="h-3 bg-gray-200 rounded w-8 ml-auto mt-1"></div>
                      </td>
                      <td className="py-3 px-4">
                        <div className="flex justify-end items-center gap-2">
                          <div className="h-6 bg-gray-200 rounded-full w-12"></div>
                          <div className="h-8 bg-gray-200 rounded w-10"></div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    {trafficSourcesAnalytics.tableData.map((source, index) => (
                      <tr key={index} className="hover:bg-blue-50/30 transition-colors">
                        <td className="py-3 px-4">
                          <div className="font-medium text-sm text-gray-800 break-words break-all">{source.sourcemedium}</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-medium text-sm text-gray-800">{source.sessions.toLocaleString()}</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-medium text-sm text-gray-800">{source.transactions.toLocaleString()}</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-medium text-sm text-gray-800">₺{source.revenue.toLocaleString(undefined, {maximumFractionDigits: 0})}</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-medium text-sm text-gray-800">{source.conversionRate.toFixed(2)}%</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-medium text-sm text-gray-800">₺{(source.transactions > 0 ? (source.revenue / source.transactions) : 0).toLocaleString(undefined, {maximumFractionDigits: 0})}</div>
                        </td>
                      </tr>
                    ))}
                    
                    {/* Total Row */}
                    {trafficSourcesAnalytics.totals && (
                      <tr className="bg-gray-50 border-t-2 border-gray-200 font-semibold">
                        <td className="py-3 px-4">
                          <div className="font-bold text-sm text-gray-800">Total</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-bold text-sm text-gray-800">{trafficSourcesAnalytics.totals.sessions.toLocaleString()}</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-bold text-sm text-gray-800">{trafficSourcesAnalytics.totals.transactions.toLocaleString()}</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-bold text-sm text-gray-800">₺{trafficSourcesAnalytics.totals.revenue.toLocaleString(undefined, {maximumFractionDigits: 0})}</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-bold text-sm text-gray-800">{trafficSourcesAnalytics.totals.conversionRate.toFixed(2)}%</div>
                        </td>
                        <td className="py-3 px-4 text-right">
                          <div className="font-bold text-sm text-gray-800">₺{(trafficSourcesAnalytics.totals.transactions > 0 ? (trafficSourcesAnalytics.totals.revenue / trafficSourcesAnalytics.totals.transactions) : 0).toLocaleString(undefined, {maximumFractionDigits: 0})}</div>
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </div>


              </div>
      </Card>
        </div>
      )}

      {activeTab === 'journey' && !isMarketer && (
        <div className="space-y-6">
          {/* Conversion Funnel Overview - Mobile Responsive */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Conversion Rate</span>
                <div className="p-1.5 bg-blue-100 rounded-lg">
                  <Target className="w-3.5 h-3.5 text-blue-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">
                  {funnelLoading ? '...' : `${conversionRate.toFixed(2)}%`}
                </span>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Add to Cart Rate</span>
                <div className="p-1.5 bg-green-100 rounded-lg">
                  <ShoppingCart className="w-3.5 h-3.5 text-green-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">
                  {funnelLoading ? '...' : `${addToCartRate.toFixed(2)}%`}
                </span>
              </div>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-xl p-4 border border-red-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Checkout Rate</span>
                <div className="p-1.5 bg-red-100 rounded-lg">
                  <CreditCard className="w-3.5 h-3.5 text-red-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">
                  {funnelLoading ? '...' : `${checkoutRate.toFixed(2)}%`}
                </span>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-4 border border-purple-100">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-600">Checkout to Purchase</span>
                <div className="p-1.5 bg-purple-100 rounded-lg">
                  <ArrowDownRight className="w-3.5 h-3.5 text-purple-600" />
                </div>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-xl md:text-2xl font-bold text-gray-800">
                  {funnelLoading ? '...' : `${checkoutToPurchaseRate.toFixed(2)}%`}
                </span>
              </div>
            </div>
          </div>

          {/* Funnel Visualization & Drop-off Analysis - Mobile Responsive */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
              <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] hover:!shadow-[0_8px_28px_rgba(0,0,0,0.15)] transition-all duration-300 h-full">
                <div className="flex flex-col gap-4 mb-6 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-gradient-to-br from-blue-500 to-purple-500 rounded-xl">
                      <BarChart3 className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <h2 className="text-lg font-semibold text-gray-800">Conversion Funnel</h2>
                      <p className="text-sm text-gray-500 mt-1">Customer journey and conversion analysis</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 self-start sm:self-auto">
                    {funnelLoading && (
                      <span className="text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded flex items-center gap-1">
                        <RefreshCw className="w-3 h-3 animate-spin" />
                        Loading...
                      </span>
                    )}
                    {eventsError && (
                      <span className="text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                        Error: {eventsError}
                      </span>
                    )}
                    {!funnelLoading && !eventsError && eventsData && eventsData.summaryByEvent?.length > 0 && (
                      <span className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded">
                        Live data
                      </span>
                    )}
                    {!funnelLoading && !eventsError && (!eventsData || !eventsData.summaryByEvent?.length) && (
                      <span className="text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded">
                        No data available
                      </span>
                    )}
                  </div>
                </div>

                {/* Funnel Steps */}
                {funnelLoading ? (
                  <div className="space-y-4">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <div key={index} className="animate-pulse">
                        <div className="h-16 bg-gray-200 rounded-xl"></div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="space-y-2">
                    {funnelData.steps.map((step, index) => {
                      const calculateFunnelWidth = (stepIndex, stepValue) => {
                        if (stepValue === 0) return 15;
                        const baseFunnelWidths = [100, 85, 70, 55, 40];
                        if (stepIndex < baseFunnelWidths.length) {
                          return baseFunnelWidths[stepIndex];
                        }
                        return Math.max(40 - (stepIndex - 4) * 10, 15);
                      };

                      const funnelWidth = calculateFunnelWidth(index, step.value);
                      
                      return (
                        <div key={index} className="relative">
                          <div 
                            className="bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-xl p-4 transition-all hover:shadow-md relative overflow-hidden"
                            style={{ 
                              width: `${funnelWidth}%`,
                              marginLeft: `${(100 - funnelWidth) / 2}%`
                            }}
                          >
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl" />
                            
                            <div className="flex items-center justify-between relative z-10">
                              <div className="flex items-center gap-3">
                                <div className="p-2 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg shadow-lg">
                                  <step.icon className="w-5 h-5 text-white" />
                                </div>
                                <div>
                                  <p className="font-medium text-gray-900">{step.name}</p>
                                  <div className="flex items-center gap-2">
                                    <p className="text-sm text-gray-500">{step.value.toLocaleString()} events</p>
                                  </div>
                                </div>
                              </div>
                              <div className="text-right">
                                <p className="font-medium text-gray-900">{step.value.toLocaleString()}</p>
                                <p className="text-xs text-gray-500">events</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </Card>
            </div>

            <div className="col-span-1">
              <Card className="p-6 rounded-2xl bg-[#ffffff] !shadow-[0_4px_20px_rgba(0,0,0,0.1)] hover:!shadow-[0_8px_28px_rgba(0,0,0,0.15)] transition-all duration-300 h-full">
                <h3 className="text-lg font-medium mb-4 text-gray-800">Drop-off Analysis</h3>
                <div className="space-y-4">
                  {funnelData.steps.slice(0, -1).map((step, index) => (
                    <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl hover:bg-gray-100/70 transition-colors cursor-pointer border border-gray-200/50">
                      <div className="flex items-center gap-3">
                        <step.icon className="w-4 h-4 text-gray-500" />
                        <span className="text-sm font-medium text-gray-700">{step.name}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-sm text-red-500 font-semibold">{step.dropoff}%</span>
                        <ChevronRight className="w-4 h-4 text-gray-400" />
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          </div>

          {/* Events Performance Table */}
          

          {/* Drop-off Analysis */}
          
        </div>
      )}

      {/* Bottom Grid Section */}
      <div className="grid grid-cols-3 gap-6 mb-8">
        {/* Top Campaigns */}
      

        
      </div>

      {/* Platform Performance Section - İki panel yan yana (Clicks ve Sessions Eklendi) */}
      <div className="grid grid-cols-12 gap-6 mb-6">
        {/* Sol Panel - Platform Performans Özeti */}
        
        
        {/* Sağ Panel - Platform Performans Özeti */}
        
      </div>

      {/* Platform Performans Kartları - Yeni ve Daha Efektif Tasarım */}
      <div className="space-y-4 mb-6">
        {/* Card 1: Spend & Revenue with Google Ads */}
       
        
        
        
        {/* Card 3: Conversion Metrics with TikTok Ads */}
        
        
        {/* Platform Detaylı Kartları - İkinci görüntüdeki gibi */}
        <div className="grid grid-cols-5 gap-4">
          {/* Google Ads Kartı */}
        
          
          {/* Meta Ads Kartı */}
         
          
          {/* TikTok Ads Kartı */}
         
          
          {/* Criteo Kartı */}
          
          
          {/* RTB House Kartı */}
          
        </div>
      </div>

      {/* Platform Performans Özeti - Basitleştirilmiş ve Sadece 3 Platform */}
     

      {/* Notification Modal */}
      <NotificationModal />

      {/* GlowyAI Chat Widget (Specific Brand Only) */}
      {(() => {
        const bid = typeof window !== 'undefined' ? localStorage.getItem('currentBrandId') : '';
        const target = '9d8e8a59-5805-4bce-8d1f-0e5152c03f82';
        if (bid === target || bid === target.replace(/-/g, '_')) {
            return <GlowyAIChatWidget />;
        }
        return null;
      })()}
    </div>
  );
}

// Helper Components
// (Removed unused mock components and datasets to resolve linter warnings)
